var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/theme/constants/typography.ts
var typography_exports = {};
__export(typography_exports, {
  getTypography: () => getTypography,
  textStyleBaseFontSize: () => textStyleBaseFontSize,
  textStyleH1CSS: () => textStyleH1CSS,
  textStyleH2CSS: () => textStyleH2CSS,
  textStyleH3CSS: () => textStyleH3CSS,
  textStyleH4CSS: () => textStyleH4CSS,
  textStylePCSS: () => textStylePCSS
});
import { css } from "styled-components";

// src/theme/constants/font.ts
var font_exports = {};
__export(font_exports, {
  BASE: () => BASE,
  CONDENSED: () => CONDENSED
});
var BASE = `'Roboto', -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif`;
var CONDENSED = `'Roboto Condensed', ${BASE}`;

// src/theme/constants/space.ts
var getSpacing = () => ({
  /**
   * Space API
   */
  x0: 0,
  x0_25: 2,
  x0_5: 4,
  x0_75: 6,
  x1: 8,
  x1_25: 10,
  x1_5: 12,
  x1_75: 14,
  x2: 16,
  x3: 24,
  x4: 32,
  x5: 40,
  x6: 48,
  x7: 56,
  x8: 64,
  x9: 72,
  x10: 80,
  x11: 88,
  x12: 96,
  x13: 104,
  x14: 112,
  x15: 120,
  x16: 128,
  x17: 136,
  x18: 144,
  x19: 152,
  x20: 160,
  /**
   * Deprecated Space API
   */
  x0space: 0,
  x0spacePx: 0,
  x1space: 0.8,
  x1spacePx: 8,
  x2space: 1.6,
  x2spacePx: 16,
  x3space: 2.4,
  x3spacePx: 24,
  x4space: 3.2,
  x4spacePx: 32,
  x5space: 4,
  x5spacePx: 40,
  x6space: 4.8,
  x6spacePx: 48,
  x7space: 5.6,
  x7spacePx: 56,
  x8space: 6.4,
  x8spacePx: 64,
  x9space: 7.2,
  x9spacePx: 72,
  x10space: 8,
  x10spacePx: 80,
  x11space: 8.8,
  x11spacePx: 88,
  x12space: 9.6,
  x12spacePx: 96,
  x13space: 10.4,
  x13spacePx: 104,
  x14space: 11.2,
  x14spacePx: 112,
  x15space: 12,
  x15spacePx: 120,
  x16space: 12.8,
  x16spacePx: 128,
  x17space: 13.6,
  x17spacePx: 136,
  x18space: 14.4,
  x18spacePx: 144,
  x19space: 15.2,
  x19spacePx: 152,
  x20space: 16,
  x20spacePx: 160
});

// src/theme/constants/breakPoint.ts
var screenSizeDefault = {
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1200
};
var screenSizeEnforceMobile = {
  sm: 3e3,
  md: 4e3,
  lg: 5e3,
  xl: 6e3
};
var screenSizeEnforcePrint = {
  sm: 300,
  md: 400,
  lg: 500,
  //More than 500 breaks A4
  xl: 1500
  //Enlarge A1 and A2 main container
};
var ScreenSize = /* @__PURE__ */ ((ScreenSize2) => {
  ScreenSize2[ScreenSize2["Default"] = 0] = "Default";
  ScreenSize2[ScreenSize2["Mobile"] = 1] = "Mobile";
  ScreenSize2[ScreenSize2["Print"] = 2] = "Print";
  return ScreenSize2;
})(ScreenSize || {});
var getScreenSize = (requiredScreenSize) => {
  switch (requiredScreenSize) {
    case 1 /* Mobile */:
      return screenSizeEnforceMobile;
    case 2 /* Print */:
      return screenSizeEnforcePrint;
    default:
      return screenSizeDefault;
  }
};
var getBreakpoints = (requiredScreenSize = 0 /* Default */) => {
  const screenSize = getScreenSize(requiredScreenSize);
  return {
    smMin: screenSize.sm + "px",
    mdMin: screenSize.md + "px",
    lgMin: screenSize.lg + "px",
    xlMin: screenSize.xl + "px",
    xsMax: screenSize.sm - 1 + "px",
    smMax: screenSize.md - 1 + "px",
    mdMax: screenSize.lg - 1 + "px",
    lgMax: screenSize.xl - 1 + "px",
    smMinRaw: screenSize.sm,
    mdMinRaw: screenSize.md,
    lgMinRaw: screenSize.lg,
    xlMinRaw: screenSize.xl,
    xsMaxRaw: screenSize.sm - 1,
    smMaxRaw: screenSize.md - 1,
    mdMaxRaw: screenSize.lg - 1,
    lgMaxRaw: screenSize.xl - 1
  };
};

// src/theme/constants/typography.ts
var media = getBreakpoints();
var spacing = getSpacing();
var getFontSizeScalar = (unit) => unit === "px" ? 10 : 1;
var getFontSizeWithUnit = (size, unit = "rem") => {
  return css`
    font-size: ${size * getFontSizeScalar(unit)}${unit};
  `;
};
var strong = css`
  font-weight: 500;
`;
var condensed = css`
  font-family: ${CONDENSED};
`;
var headingLineHeight = css`
  line-height: 1.25;
`;
var paragraphLineHeight = css`
  line-height: 1.5;
`;
var uber = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x5space, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x7space, unit)};
  }
  ${headingLineHeight}
`;
var mass = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x4space + 0.4, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x6space, unit)};
  }
  ${headingLineHeight}
`;
var hero = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x4space - 0.2, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x4space + 0.4, unit)};
  }
  ${headingLineHeight}
`;
var mega = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x3space, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x3space + 0.4, unit)};
  }
  ${headingLineHeight}
`;
var xLarge = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x3space - 0.3, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x3space, unit)};
  }
  ${headingLineHeight}
`;
var large = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x2space + 0.2, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x2space + 0.4, unit)};
  }
  ${paragraphLineHeight}
`;
var base = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x2space, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x2space + 0.2, unit)};
  }
  ${paragraphLineHeight}
`;
var small = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x2space - 0.2, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x2space, unit)};
  }
  ${paragraphLineHeight}
`;
var xSmall = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x1space + 0.5, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x2space - 0.2, unit)};
  }
  ${paragraphLineHeight}
`;
var tiny = (unit) => css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x1space + 0.3, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x1space + 0.4, unit)};
  }
  ${paragraphLineHeight}
`;
var inherit = css`
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
`;
var uberStrong = (unit) => css`
  ${uber(unit)}
  ${strong}
`;
var massStrong = (unit) => css`
  ${mass(unit)}
  ${strong}
`;
var heroStrong = (unit) => css`
  ${hero(unit)}
  ${strong}
`;
var megaStrong = (unit) => css`
  ${mega(unit)}
  ${strong}
`;
var xLargeStrong = (unit) => css`
  ${xLarge(unit)}
  ${strong}
`;
var largeStrong = (unit) => css`
  ${large(unit)}
  ${strong}
`;
var baseStrong = (unit) => css`
  ${base(unit)}
  ${strong}
`;
var smallStrong = (unit) => css`
  ${small(unit)}
  ${strong}
`;
var xSmallStrong = (unit) => css`
  ${xSmall(unit)}
  ${strong}
`;
var tinyStrong = (unit) => css`
  ${tiny(unit)}
  ${strong}
`;
var uberCondensed = (unit) => css`
  ${uber(unit)}
  ${condensed}
`;
var massCondensed = (unit) => css`
  ${mass(unit)}
  ${condensed}
`;
var heroCondensed = (unit) => css`
  ${hero(unit)}
  ${condensed}
`;
var megaCondensed = (unit) => css`
  ${mega(unit)}
  ${condensed}
`;
var xLargeCondensed = (unit) => css`
  ${xLarge(unit)}
  ${condensed}
`;
var largeCondensed = (unit) => css`
  ${large(unit)}
  ${condensed}
`;
var baseCondensed = (unit) => css`
  ${base(unit)}
  ${condensed}
`;
var smallCondensed = (unit) => css`
  ${small(unit)}
  ${condensed}
`;
var xSmallCondensed = (unit) => css`
  ${xSmall(unit)}
  ${condensed}
`;
var tinyCondensed = (unit) => css`
  ${tiny(unit)}
  ${condensed}
`;
var editorHeading = (unit) => css`
  ${headingLineHeight}
  ${getFontSizeWithUnit(spacing.x3space, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x4space - 0.2, unit)};
    line-height: 1.333333; // 40px;
  }
  ${strong}
`;
var editorSubHeading = (unit) => css`
  ${getFontSizeWithUnit(spacing.x2space + 0.4, unit)};
  line-height: 1.4;
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x3space, unit)};
    line-height: 1.333333;
  }
  ${strong}
`;
var editorBody = (unit) => css`
  font-weight: 400;
  line-height: 1.75;
  ${getFontSizeWithUnit(spacing.x2space, unit)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x2space + 0.2, unit)};
    line-height: 1.555555; // 28px;
  }
`;
var editorBodyStrong = (unit) => css`
  ${editorBody(unit)}
  font-weight: 700;
`;
var textStyleBaseFontSize = css`
  font-family: ${BASE};
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x2space - 0.2)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x2space)};
  }
`;
var textStyleH1CSS = css`
  ${getFontSizeWithUnit(spacing.x4space - 0.4)};
  font-family: ${BASE};
  font-weight: 300;
  line-height: 1.5;
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x5space)};
  }
`;
var textStyleH2CSS = css`
  ${getFontSizeWithUnit(spacing.x3space)};
  font-family: ${BASE};
  font-weight: 700;
  line-height: 1.4;
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x4space - 0.2)};
  }
`;
var textStyleH3CSS = css`
  ${getFontSizeWithUnit(spacing.x3space - 0.4)};
  font-family: ${BASE};
  font-weight: 700;
  line-height: 1.5;
  @media (min-width: ${media.lgMin}) {
    font-size: ${spacing.x3space}rem;
  }
`;
var textStyleH4CSS = css`
  font-weight: normal;
  ${getFontSizeWithUnit(spacing.x2space - 0.2)};
  @media (min-width: ${media.lgMin}) {
    ${getFontSizeWithUnit(spacing.x2space)};
  }
`;
var textStylePCSS = css`
  ${textStyleBaseFontSize};
  line-height: 1.7;
`;
var getTypography = (unit) => ({
  uber: uber(unit),
  uberStrong: uberStrong(unit),
  uberCondensed: uberCondensed(unit),
  mass: mass(unit),
  massStrong: massStrong(unit),
  massCondensed: massCondensed(unit),
  hero: hero(unit),
  heroStrong: heroStrong(unit),
  heroCondensed: heroCondensed(unit),
  mega: mega(unit),
  megaStrong: megaStrong(unit),
  megaCondensed: megaCondensed(unit),
  xLarge: xLarge(unit),
  xLargeStrong: xLargeStrong(unit),
  xLargeCondensed: xLargeCondensed(unit),
  large: large(unit),
  largeStrong: largeStrong(unit),
  largeCondensed: largeCondensed(unit),
  base: base(unit),
  baseStrong: baseStrong(unit),
  baseCondensed: baseCondensed(unit),
  small: small(unit),
  smallStrong: smallStrong(unit),
  smallCondensed: smallCondensed(unit),
  xSmall: xSmall(unit),
  xSmallStrong: xSmallStrong(unit),
  xSmallCondensed: xSmallCondensed(unit),
  tiny: tiny(unit),
  tinyStrong: tinyStrong(unit),
  tinyCondensed: tinyCondensed(unit),
  editorHeading: editorHeading(unit),
  editorSubHeading: editorSubHeading(unit),
  editorBody: editorBody(unit),
  editorBodyStrong: editorBodyStrong(unit),
  inherit,
  strong,
  condensed,
  headingLineHeight,
  paragraphLineHeight
});

// src/theme/constants/focus.ts
import { css as css3 } from "styled-components";

// src/components/Toggle/styled.ts
import styled, { css as css2 } from "styled-components";
var cubicBezierFunction = css2`0.2s cubic-bezier(0.23, 1, 0.32, 1)`;
var ToggleLabel = styled("label")`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  padding: ${({ theme: theme2 }) => theme2.x1spacePx / 2}px;

  /* Overwrite default theme */
  &&& {
    margin: 0px;
  }
`;
var ToggleLabelText = styled("span")`
  ${({ theme: theme2 }) => theme2.typography.xSmall}
  line-height: normal;

  margin-left: ${({ theme: theme2 }) => theme2.x1spacePx}px;
`;
var ToggleSwitch = styled("span")`
  position: absolute;
  top: -${({ theme: theme2 }) => theme2.x1spacePx / 2}px;
  left: -2px;
  transition: transform ${cubicBezierFunction};
  width: 20px;
  height: 20px;
  display: block;
  background: white;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
`;
var ToggleBase = styled("span")`
  display: block;
  position: relative;
  transition: background ${cubicBezierFunction};
  background: ${({ theme: theme2, styleType }) => styleType === "light" ? theme2.color.lightGray : theme2.color.darkerGray};
  width: ${({ theme: theme2 }) => theme2.x5spacePx}px;
  height: ${({ theme: theme2 }) => theme2.x1spacePx + 4}px;
  border-radius: ${({ theme: theme2 }) => theme2.x3spacePx + 4}px;
`;
var ToggleWrapper = styled("fieldset")`
  z-index: 0;
  user-select: none;
  display: ${({ display }) => display};
  opacity: ${({ disabled: disabled4 }) => disabled4 ? 0.5 : 1};
  transition: opacity ${cubicBezierFunction};
  color: ${({ theme: theme2 }) => theme2.color.white};
  ${ToggleLabel} {
    cursor: ${({ disabled: disabled4 }) => disabled4 ? "not-allowed" : "pointer"};
    min-height: ${({ theme: theme2 }) => theme2.x3spacePx}px;
  }
  input {
    opacity: 0;
    position: absolute;
    top: ${({ theme: theme2 }) => theme2.x1spacePx / 2}px;
    left: ${({ theme: theme2 }) => theme2.x1spacePx / 2}px;
    &:checked {
      + ${ToggleBase} {
        background: ${({ theme: theme2 }) => theme2.color.brand01};
        > ${ToggleSwitch} {
          transform: translateX(${({ theme: theme2 }) => theme2.x3spacePx}px);
          box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
`;

// src/components/Toggle/Toggle.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Toggle = ({
  name,
  value,
  label,
  tabIndex,
  readOnly,
  autoFocus,
  disabled: disabled4 = false,
  onChange,
  onFocus,
  onBlur,
  styleType = "dark",
  display = "inline-block"
}) => /* @__PURE__ */ jsx(ToggleWrapper, { disabled: disabled4, display, children: /* @__PURE__ */ jsxs(ToggleLabel, { "data-cy-id": `toggle-label-${name}`, children: [
  /* @__PURE__ */ jsx(
    "input",
    {
      name,
      type: "checkbox",
      checked: value,
      disabled: disabled4,
      readOnly,
      autoFocus,
      tabIndex: tabIndex || 0,
      onBlur,
      onFocus,
      onChange: (e) => {
        onChange && onChange(e);
      },
      "data-cy-id": `toggle-btn-${name}`
    }
  ),
  /* @__PURE__ */ jsx(ToggleBase, { styleType, children: /* @__PURE__ */ jsx(ToggleSwitch, {}) }),
  label ? /* @__PURE__ */ jsx(ToggleLabelText, { children: label }) : null
] }) });
var Toggle_default = Toggle;

// src/theme/constants/focus.ts
var dashedFocus = css3`
  ${({ theme: theme2 }) => `
    &:after {
      display: block;
      content: '';
      position: absolute;
      top: -3px;
      right: -3px;
      bottom: -3px;
      left: -3px;
      border: 1px dashed ${theme2.color.brand01};
      border-radius: 8px;
    }
  `}
`;
var solidFocus = css3`
  ${({ theme: theme2 }) => `
    background-color: ${theme2.color.brand01};
    color: ${theme2.color.white};
    box-shadow: none;
  `}
`;
var attr = (theme2, type) => Object.entries(theme2.focus(type)).map((n) => `${n[0]}="${n[1]}"`).join();
var focus_default = css3`
  body:not(.using-mouse) {
    button[${({ theme: theme2 }) => attr(theme2, "dashed")}]:focus {
      ${dashedFocus}
    }

    ${ToggleLabel}:focus-within {
      ${dashedFocus}
    }
  }

  body:not(.using-mouse) [${({ theme: theme2 }) => attr(theme2, "solid")}]:focus {
    ${solidFocus}
  }
`;

// src/theme/utils/colors.ts
var colors_exports = {};
__export(colors_exports, {
  applyColor: () => applyColor,
  calculateMidColor: () => calculateMidColor,
  getRgbString: () => getRgbString,
  hexToRgb: () => hexToRgb,
  hexToRgbA: () => hexToRgbA,
  hslToRgb: () => hslToRgb,
  rgbToHsl: () => rgbToHsl
});
var getRgbString = (rv, gv, bv) => {
  const r = parseInt(rv, 16);
  const g = parseInt(gv, 16);
  const b = parseInt(bv, 16);
  return `${r},${g},${b}`;
};
var hexToRgb = (hex) => {
  const a = hex.split("");
  return getRgbString(`${a[1]}${a[2]}`, `${a[3]}${a[4]}`, `${a[5]}${a[6]}`);
};
var hexToRgbA = (colour, alpha = 1) => {
  if (colour.includes("rgba")) {
    const colourSplit = colour.split(",");
    colourSplit[3] = "0)";
    return colourSplit.join(",");
  }
  return `rgba(${hexToRgb(colour)},${alpha})`;
};
function parseColor(hex) {
  let parts;
  const color3 = hex.replace(/\s\s*/g, "");
  if (parts = /^#([\da-fA-F]{2})([\da-fA-F]{2})([\da-fA-F]{2})/.exec(color3))
    parts = [
      parseInt(parts[1], 16),
      parseInt(parts[2], 16),
      parseInt(parts[3], 16)
    ];
  else if (parts = /^#([\da-fA-F])([\da-fA-F])([\da-fA-F])/.exec(color3))
    parts = [
      parseInt(parts[1], 16) * 17,
      parseInt(parts[2], 16) * 17,
      parseInt(parts[3], 16) * 17
    ];
  else if (parts = /^rgba\(([\d]+),([\d]+),([\d]+),([\d]+|[\d]*.[\d]+)\)/.exec(color3))
    parts = [+parts[1], +parts[2], +parts[3]];
  else if (parts = /^rgb\(([\d]+),([\d]+),([\d]+)\)/.exec(color3))
    parts = [+parts[1], +parts[2], +parts[3]];
  else
    throw Error(color3 + " is not supported by $.parseColor");
  return parts.slice(0, 3);
}
function rgbToHsl(r, g, b) {
  const red = r / 255;
  const green = g / 255;
  const blue = b / 255;
  const max = Math.max(red, green, blue);
  const min = Math.min(red, green, blue);
  let h = 0;
  let s;
  const l = (max + min) / 2;
  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case red:
        h = (green - blue) / d + (green < blue ? 6 : 0);
        break;
      case green:
        h = (blue - red) / d + 2;
        break;
      case blue:
        h = (red - green) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }
  return [h, s, l];
}
function hslToRgb(h, s, l) {
  let r, g, b;
  if (s === 0) {
    r = g = b = l;
  } else {
    const hue2rgb = function(p1, q1, t) {
      let tt = t;
      if (t < 0)
        tt += 1;
      if (t > 1)
        tt -= 1;
      if (t < 1 / 6)
        return p1 + (q1 - p1) * 6 * tt;
      if (t < 1 / 2)
        return q1;
      if (t < 2 / 3)
        return p1 + (q1 - p1) * (2 / 3 - tt) * 6;
      return p1;
    };
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}
function calculateMidColor(minColor, maxColor, value, alpha = 1) {
  const rgb1 = parseColor(minColor);
  const rgb2 = parseColor(maxColor);
  const hsl1 = rgbToHsl(rgb1[0], rgb1[1], rgb1[2]);
  const hsl2 = rgbToHsl(rgb2[0], rgb2[1], rgb2[2]);
  const hsli = [
    hsl1[0] + value * (hsl2[0] - hsl1[0]),
    hsl1[1] + value * (hsl2[1] - hsl1[1]),
    hsl1[2] + value * (hsl2[2] - hsl1[2])
  ];
  const color3 = hslToRgb(hsli[0], hsli[1], hsli[2]);
  return "rgba(" + Math.round(color3[0]) + "," + Math.round(color3[1]) + "," + Math.round(color3[2]) + "," + alpha + ")";
}
var isRGBAColor = (c) => typeof c === "function";
var applyColor = (color3, opacity = 1) => {
  if (isRGBAColor(color3)) {
    return color3(opacity);
  }
  return color3;
};

// src/theme/utils/darken.ts
function darken(rgbOrHex, percent) {
  const rgb = rgbOrHex.startsWith("#") ? hexToRgb(rgbOrHex) : rgbOrHex;
  const arr = rgb.split(",");
  const r = +arr[0];
  const g = +arr[1];
  const b = +arr[2];
  return [
    Math.max(0, Math.round(r - r * percent)),
    Math.max(0, Math.round(g - g * percent)),
    Math.max(0, Math.round(b - b * percent))
  ].join();
}

// src/theme/utils/lighten.ts
function lighten(rgbOrHex, percent) {
  const rgb = rgbOrHex.startsWith("#") ? hexToRgb(rgbOrHex) : rgbOrHex;
  const arr = rgb.split(",");
  const r = +arr[0];
  const g = +arr[1];
  const b = +arr[2];
  return [
    Math.min(255, Math.round(r + r * percent)),
    Math.min(255, Math.round(g + g * percent)),
    Math.min(255, Math.round(b + b * percent))
  ].join();
}

// src/theme/utils/media.ts
import { css as css4 } from "styled-components";
var breakControl = (condition, wA, wB = "0") => {
  switch (condition) {
    case "up":
      return "(min-width: " + wA + ")";
    case "down":
      return "(max-width: " + wA + ")";
    case "only":
      return "(min-width: " + wA + ") and (max-width: " + wB + ")";
    default:
      return "";
  }
};
var media2 = {
  xsDown: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("down", theme2.xsMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  smDown: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("down", theme2.smMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  mdDown: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("down", theme2.mdMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  lgDown: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("down", theme2.lgMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  smUp: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("up", theme2.smMin)} {
      ${css4(literals, ...styles)};
    }
  `,
  mdUp: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("up", theme2.mdMin)} {
      ${css4(literals, ...styles)};
    }
  `,
  lgUp: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("up", theme2.lgMin)} {
      ${css4(literals, ...styles)};
    }
  `,
  xlUp: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("up", theme2.xlMin)} {
      ${css4(literals, ...styles)};
    }
  `,
  xsOnly: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("down", theme2.xsMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  smOnly: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("only", theme2.smMin, theme2.smMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  mdOnly: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("only", theme2.mdMin, theme2.mdMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  lgOnly: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("only", theme2.lgMin, theme2.lgMax)} {
      ${css4(literals, ...styles)};
    }
  `,
  xlOnly: (literals, ...styles) => css4`
    @media ${({ theme: theme2 }) => breakControl("up", theme2.xlMin)} {
      ${css4(literals, ...styles)};
    }
  `
};
var media_default = media2;

// src/theme/utils/ellipsis.ts
import { css as css5 } from "styled-components";
var Ellipsis = () => css5`
  width: 100%;
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
var EllipsisWithLineClamp = (lineClamp = 1) => css5`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${lineClamp};
`;

// src/theme/utils/hideScrollbar.ts
import { css as css6 } from "styled-components";
var hideScrollbar = css6`
  /* Hide scrollbar */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
`;

// src/theme/utils/accessibility.ts
import { css as css7 } from "styled-components";
var VisuallyHidden = css7`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

// src/theme/constants/color.ts
var basePalette = {
  //  Brand
  brand01: "#2394DF",
  brand02: "#43C1EE",
  brand03: "#356EE9",
  brand04: "#02ABDE",
  //  Charts
  chart01: "#2394DF",
  chart02: "#71E7D6",
  chart03: "#BB4786",
  chart04: "#E5B061",
  chart05: "#A54CEC",
  chart06: "#E75D75",
  //  Signals
  bad: "#E64141",
  good: "#2DC97E",
  neutral: "#EEB219",
  warning: "#FF9212",
  attention: "#A54CEC",
  //  Social
  google: "#D1493C",
  facebook: "#4868AD",
  //  Structural
  black: "#000000",
  almostBlack: "#0B0E13",
  charcoal: "#151B24",
  noir: "#1B222D",
  phantom: "#202833",
  spaceGray: "#262E3A",
  darkerGray: "#3E4855",
  darkGray: "#5F6875",
  mediumGray: "#8C929B",
  lightGray: "#C9CBCF",
  paper: "#F2F2F3",
  paleWhite: "#EAF4FF",
  white: "#FFFFFF"
};
var baseSemanticTokens = {
  // Transparent
  transparentStrong: hexToRgbA(basePalette.white, 0.2),
  transparentSubtle: hexToRgbA(basePalette.white, 0.1),
  // Text
  textSolid: basePalette.white,
  textSoft: hexToRgbA(basePalette.white, 0.7),
  textSofter: hexToRgbA(basePalette.white, 0.5),
  textSubtle: hexToRgbA(basePalette.white, 0.3),
  // Signal
  attentionSubtle: hexToRgbA(basePalette.attention, 0.1),
  neutralSubtle: hexToRgbA(basePalette.neutral, 0.1),
  goodSubtle: hexToRgbA(basePalette.good, 0.1),
  badSubtle: hexToRgbA(basePalette.bad, 0.1),
  warningSubtle: hexToRgbA(basePalette.warning, 0.1),
  attentionStrong: hexToRgbA(basePalette.attention, 0.3),
  neutralStrong: hexToRgbA(basePalette.neutral, 0.3),
  goodStrong: hexToRgbA(basePalette.good, 0.3),
  badStrong: hexToRgbA(basePalette.bad, 0.3),
  warningStrong: hexToRgbA(basePalette.warning, 0.3)
};
var optionalSemanticTokens = {
  // Charts
  snowflakeLabel: basePalette.white,
  snowflakeRingEven: void 0,
  snowflakeRingOdd: void 0
};
var darkTokens = {
  ...basePalette,
  ...baseSemanticTokens,
  ...optionalSemanticTokens
};
var printTokens = {
  ...darkTokens,
  black: basePalette.white,
  charcoal: basePalette.white,
  noir: basePalette.white,
  phantom: basePalette.white,
  spaceGray: basePalette.white,
  white: basePalette.spaceGray,
  paleWhite: basePalette.mediumGray,
  // Transparent
  transparentStrong: hexToRgbA(basePalette.noir, 0.2),
  transparentSubtle: hexToRgbA(basePalette.noir, 0.1),
  // Text
  textSolid: basePalette.noir,
  textSoft: hexToRgbA(basePalette.noir, 0.7),
  textSofter: hexToRgbA(basePalette.noir, 0.5),
  textSubtle: hexToRgbA(basePalette.noir, 0.3)
};
var lightTokens = {
  ...darkTokens,
  // Charts
  snowflakeLabel: basePalette.noir,
  snowflakeRingEven: hexToRgbA(basePalette.spaceGray, 0.1),
  snowflakeRingOdd: basePalette.white
};
var getColor = (appTheme) => {
  let systemColour = darkTokens;
  if (appTheme === "light")
    systemColour = printTokens;
  if (appTheme === "light-v1")
    systemColour = lightTokens;
  return {
    // Spread the system colours and create RGBA Variants
    ...Object.entries(systemColour).reduce((a, [name, hex]) => {
      const isSemanticToken = name in baseSemanticTokens || name in optionalSemanticTokens;
      if (isSemanticToken)
        return {
          ...a,
          [name]: hex
        };
      const rgb = hexToRgb(hex);
      return {
        ...a,
        [name]: hex,
        [`${name}RGBA`]: (alpha) => `rgba(${rgb},${alpha >= 0 && alpha <= 1 ? alpha : 1})`
      };
    }, {})
  };
};

// src/theme/constants/charts.ts
var getBarChart = (color3) => ({
  assetsVsLiabilities: {
    colors: [color3.chart01, color3.chart02],
    titleColors: [color3.white, color3.spaceGray]
  },
  pastGrowth: {
    colors: [color3.chart01, color3.chart02, color3.chart03],
    titleColors: [color3.white, color3.spaceGray, color3.white]
  },
  futureGrowth: {
    colors: [color3.chart01, color3.chart02, color3.chart03],
    titleColors: [color3.white, color3.spaceGray, color3.white]
  },
  valuator: {
    colors: [color3.brand01, color3.chart02, color3.chart03, color3.chart05],
    valueColors: [color3.brand01, color3.white, color3.white, color3.white]
  },
  dividendYieldVsMarket: {
    colors: [
      color3.chart01,
      color3.chart03RGBA(0.5),
      color3.chart03,
      color3.chart02,
      color3.chart01
    ],
    titleColors: [
      color3.white,
      color3.white,
      color3.white,
      color3.spaceGray,
      color3.white
    ]
  },
  futureAnnualGrowthAnalysis: {
    colors: [color3.chart01, color3.chart02, color3.chart03],
    titleColors: [color3.white, color3.spaceGray, color3.white]
  },
  incomeStatement: {
    colors: [
      color3.chart01,
      color3.badRGBA(0.5),
      color3.good,
      color3.badRGBA(0.5),
      color3.chart02
    ],
    titleColors: [
      color3.white,
      color3.white,
      color3.white,
      color3.white,
      color3.white
    ]
  }
});
var charts_default = getBarChart;

// src/theme/styled.theme.ts
var theme = (config = {}) => {
  const spacing2 = getSpacing();
  let appTheme = config && config.screenSize === 2 /* Print */ ? "light" : "dark";
  if (typeof config?.theme !== "undefined") {
    appTheme = config.theme;
  }
  const color3 = getColor(appTheme);
  const barChart = charts_default(color3);
  const screenSize = config.screenSize ?? 0 /* Default */;
  const breakpoints = getBreakpoints(screenSize);
  const typographyBaseline = config.typographyBaselineMeasurementUnit ?? "rem";
  const typography2 = getTypography(typographyBaseline);
  let safeAreaInsetTop = "0px";
  try {
    if (CSS.supports("padding-top", "env(safe-area-inset-top)")) {
      safeAreaInsetTop = "env(safe-area-inset-top)";
    }
  } catch {
  }
  let safeAreaInsetBottom = "0px";
  try {
    if (CSS.supports("padding-bottom", "env(safe-area-inset-bottom)")) {
      safeAreaInsetBottom = "env(safe-area-inset-bottom)";
    }
  } catch {
  }
  return {
    /* Safe Areas */
    safeAreaInsetTop,
    safeAreaInsetBottom,
    /* Font */
    fontBase: BASE,
    /* Spacing */
    ...spacing2,
    /* Breakpoints */
    ...breakpoints,
    appTheme,
    /* Colours */
    color: color3,
    /* Typography */
    typography: typography2,
    /* Charts */
    chart: {
      barChart
    },
    /* Focus */
    focus: (type) => ({ "data-focus": type }),
    desktopTopbarHeight: spacing2.x8spacePx,
    mobileTopbarHeight: 114,
    sidebarWidth: 298
  };
};

// src/theme/ThemeProvider.tsx
import { useEffect } from "react";
import {
  ThemeProvider as StyledThemeProvider
} from "styled-components";
import { jsx as jsx2 } from "react/jsx-runtime";
var useUsingMouse = () => {
  useEffect(() => {
    const onMousedown = () => {
      document.body.classList.add("using-mouse");
    };
    const onKeydown = (e) => {
      switch (e.key) {
        case "Tab":
          document.body.classList.remove("using-mouse");
          break;
        default:
          break;
      }
    };
    document.body.addEventListener("mousedown", onMousedown);
    document.body.addEventListener("keydown", onKeydown);
    return () => {
      document.body.removeEventListener("mousedown", onMousedown);
      document.body.removeEventListener("keydown", onKeydown);
    };
  }, []);
};
var ThemeProvider = ({ theme: theme2, children }) => {
  useUsingMouse();
  return /* @__PURE__ */ jsx2(StyledThemeProvider, { theme: theme2 ? theme2 : theme(), children });
};

// src/theme/index.ts
var hexToRgb2 = colors_exports.hexToRgb;

// src/components/Badge/styled.ts
import styled2, { css as css8 } from "styled-components";
var solidAttention = css8`
  background-color: ${({ theme: theme2 }) => theme2.color.attention};
  color: ${({ theme: theme2 }) => theme2.color.textSolid};
`;
var solidGood = css8`
  background-color: ${({ theme: theme2 }) => theme2.color.goodSubtle};
  color: ${({ theme: theme2 }) => theme2.color.good};
`;
var solidBad = css8`
  background-color: ${({ theme: theme2 }) => theme2.color.badSubtle};
  color: ${({ theme: theme2 }) => theme2.color.bad};
`;
var solidWarning = css8`
  background-color: ${({ theme: theme2 }) => theme2.color.warningSubtle};
  color: ${({ theme: theme2 }) => theme2.color.warning};
`;
var solidDefault = css8`
  background-color: ${({ theme: theme2 }) => theme2.color.transparentSubtle};
  color: ${({ theme: theme2 }) => theme2.color.textSofter};
`;
var variantToneMap = {
  solid: {
    attention: solidAttention,
    good: solidGood,
    bad: solidBad,
    warning: solidWarning,
    default: solidDefault
  }
};
var Badge = styled2.mark`
  border-radius: ${({ theme: theme2 }) => `${theme2.x1_5}px`};
  padding: 3px 8px;
  white-space: nowrap;
  text-decoration: none;
  height: min-content;
  text-align: center;
  display: inline-block;
  ${({ theme: theme2 }) => theme2.typography.tiny}
  svg {
    height: 1em;
    fill: currentColor;
    width: auto;
  }
  ${({ variant, tone }) => variantToneMap[variant ?? "solid"][tone ?? "default"]}

  ${({ maxWidth }) => maxWidth && css8`
      max-width: ${maxWidth};
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;
Badge.defaultProps = {
  variant: "solid",
  tone: "default"
};

// src/components/BlurFilter/BlurFilter.tsx
import { Component } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var BlurFilter = class extends Component {
  static defaultProps = {
    blurAmount: 6
  };
  componentDidMount() {
    const oldTempStyle = document.getElementById("blur-css");
    if (oldTempStyle)
      return;
    const { filterId, blurAmount } = this.props;
    const cssContent = `
			#${filterId} {
				filter: url(#blur-filter);
				filter: blur(${blurAmount}px);
			}
		`;
    if (document) {
      const tempStyle = document.createElement("style");
      tempStyle.type = "text/css";
      tempStyle.id = "blur-css";
      tempStyle.appendChild(document.createTextNode(cssContent));
      document.head && document.head.appendChild(tempStyle);
    }
  }
  componentWillUnmount() {
    if (document) {
      const tempStyle = document.getElementById("blur-css");
      if (tempStyle && document.head) {
        document.head.removeChild(tempStyle);
      }
    }
  }
  render() {
    const { blurAmount } = this.props;
    return /* @__PURE__ */ jsx3(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: "0",
        height: "0",
        style: { display: "none" },
        children: /* @__PURE__ */ jsx3("defs", { children: /* @__PURE__ */ jsx3(
          "filter",
          {
            id: "blur-filter",
            x: "0%",
            y: "0%",
            width: "100%",
            height: "100%",
            colorInterpolationFilters: "sRGB",
            children: /* @__PURE__ */ jsx3("feGaussianBlur", { in: "SourceGraphic", stdDeviation: blurAmount })
          }
        ) })
      }
    );
  }
};

// src/components/Modal/components/Modal/Modal.tsx
import { useCallback as useCallback4 } from "react";

// src/components/Modal/components/Portal/Portal.tsx
import {
  useEffect as useEffect4,
  useState,
  useCallback as useCallback3
} from "react";
import { createPortal } from "react-dom";

// src/hooks/usePreventWindowScroll/usePreventWindowScroll.ts
import { useRef, useEffect as useEffect2 } from "react";
var usePreventWindowScroll = () => {
  const oldBodyPosition = useRef();
  const oldBodyTop = useRef();
  const oldBodyWidth = useRef();
  const oldWindowScrollPos = useRef(0);
  useEffect2(() => {
    oldBodyTop.current = document.body.style.top;
    oldBodyWidth.current = document.body.style.width;
    oldBodyPosition.current = document.body.style.position;
    oldWindowScrollPos.current = window.pageYOffset;
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${oldWindowScrollPos.current}px`;
    return () => {
      if (oldBodyPosition.current) {
        document.body.style["position"] = oldBodyPosition.current;
      } else {
        document.body.style.removeProperty("position");
      }
      if (oldBodyTop.current) {
        document.body.style["top"] = oldBodyTop.current;
      } else {
        document.body.style.removeProperty("top");
      }
      if (oldBodyWidth.current) {
        document.body.style["width"] = oldBodyWidth.current;
      } else {
        document.body.style.removeProperty("width");
      }
      window.scrollTo(0, oldWindowScrollPos.current);
    };
  }, []);
};

// src/components/Modal/components/Content/Content.tsx
import {
  useEffect as useEffect3,
  useRef as useRef2
} from "react";
import { useCallback as useCallback2 } from "react";

// src/components/Modal/components/Footer/Footer.tsx
import { useCallback } from "react";

// src/components/Button/Button.ts
import styled4, { css as css10 } from "styled-components";

// src/components/LoadingSpinner/LoadingSpinner.ts
import styled3, { keyframes, css as css9 } from "styled-components";
var loadingKeyframes = keyframes`
	from 				{transform: rotate(0);}
	to 					{transform: rotate(360deg);}
`;
var loadingAnimation = (strings, ...interpolations) => css9`
  &:before {
    content: '';
    display: block;
    opacity: 1;
    transition: opacity 0.2s;
    width: ${({ width, theme: theme2 }) => width ? width : theme2.x2spacePx}px;
    height: ${({ width, theme: theme2 }) => width ? width : theme2.x2spacePx}px;
    border-radius: ${({ width, theme: theme2 }) => width ? width : theme2.x2spacePx}px;
    border: solid 1px
      ${({ light, styleType, theme: theme2 }) => light === true || styleType === "light" ? theme2.color.white : theme2.color.black};
    border-bottom-color: transparent;
    animation: ${loadingKeyframes} 0.5s linear infinite forwards;
    ${css9(strings, ...interpolations)};
  }
`;
var LoadingSpinner = styled3("div")`
  position: ${({ top, right, bottom, left }) => top || right || bottom || left ? `absolute` : `static`};
  top: ${({ top }) => top ? top : `auto`};
  right: ${({ right }) => right ? right : `auto`};
  bottom: ${({ bottom }) => bottom ? bottom : `auto`};
  left: ${({ left }) => left ? left : `auto`};
  margin-top: ${({ top, width, theme: theme2 }) => top ? `-${(width || theme2.x2spacePx) / 2}px` : `0`};
  margin-left: ${({ left, width, theme: theme2 }) => left ? `-${(width || theme2.x2spacePx) / 2}px` : `0`};
  margin-bottom: ${({ bottom, width, theme: theme2 }) => bottom ? `-${(width || theme2.x2spacePx) / 2}px` : `0`};
  margin-right: ${({ right, width, theme: theme2 }) => right ? `-${(width || theme2.x2spacePx) / 2}px` : `0`};
  z-index: ${({ zIndex }) => zIndex ? zIndex : 0};
  ${loadingAnimation``};
`;

// src/components/Button/Button.ts
var displayKeys = [
  "displayXsDown",
  "displaySmDown",
  "displayMdDown",
  "displayLgDown",
  "displaySmUp",
  "displayMdUp",
  "displayLgUp",
  "displayXlUp"
];
var displayMap = {
  displayXsDown: "xsDown",
  displaySmDown: "smDown",
  displayMdDown: "mdDown",
  displayLgDown: "lgDown",
  displaySmUp: "smUp",
  displayMdUp: "mdUp",
  displayLgUp: "lgUp",
  displayXlUp: "xlUp"
};
var getPadding = (theme2) => theme2.x2spacePx - 4;
var font = css10`
  ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "passive":
    case "passiveReverse":
    case "gentle":
    case "gentleReverse":
    case "solid":
    case "solidReverse":
    case "loud":
    case "louder":
      return theme2.typography.tiny;
    case "gentleLarge":
    case "gentleLargeReverse":
    case "solidLarge":
    case "solidLargeReverse":
    case "passiveLarge":
    case "passiveLargeReverse":
    case "loudLarge":
    case "louderLarge":
      return theme2.typography.xSmall;
    default:
      return "font-size: inherit";
  }
}}
`;
var lineHeight = css10`
  line-height: ${({ styleType }) => {
  switch (styleType) {
    case "passive":
    case "passiveReverse":
    case "gentle":
    case "gentleReverse":
    case "solid":
    case "solidReverse":
    case "loud":
    case "louder":
    case "gentleLarge":
    case "gentleLargeReverse":
    case "solidLarge":
    case "solidLargeReverse":
    case "passiveLarge":
    case "passiveLargeReverse":
    case "loudLarge":
    case "louderLarge":
      return "1";
    default:
      return "inherit";
  }
}};
`;
var height = css10`
  height: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "passive":
    case "passiveReverse":
    case "gentle":
    case "gentleReverse":
    case "solid":
    case "solidReverse":
    case "loud":
    case "louder":
      return `${theme2.x4spacePx}px`;
    case "gentleLarge":
    case "gentleLargeReverse":
    case "solidLarge":
    case "solidLargeReverse":
    case "passiveLarge":
    case "passiveLargeReverse":
    case "loudLarge":
    case "louderLarge":
      return `${theme2.x5spacePx}px`;
    default:
      return "auto";
  }
}};
`;
var padding = css10`
  padding: ${({ theme: theme2, styleType }) => {
  if (styleType === "softLink" || styleType === "strongLink" || styleType === "softLinkReverse") {
    return "0";
  }
  return `0 ${getPadding(theme2)}px`;
}};
`;
var color = css10`
  color: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "strongLink":
    case "loud":
    case "loudLarge":
      return theme2.color.brand01;
    case "gentleReverse":
    case "gentleLargeReverse":
    case "solid":
    case "solidLarge":
      return theme2.color.spaceGray;
    case "softLinkReverse":
      return theme2.color.darkGray;
    case "passive":
    case "passiveLarge":
      return theme2.color.whiteRGBA(0.7);
    case "passiveReverse":
    case "passiveLargeReverse":
      return theme2.color.spaceGrayRGBA(0.5);
    default:
      return theme2.color.white;
  }
}};
`;
var backgroundColor = css10`
  background-color: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "loud":
    case "loudLarge":
      return theme2.color.brand03RGBA(0.1);
    case "louder":
    case "louderLarge":
      return theme2.color.brand01;
    case "solid":
    case "solidLarge":
      return theme2.color.white;
    case "solidReverse":
    case "solidLargeReverse":
      return theme2.color.spaceGray;
    case "gentle":
    case "gentleLarge":
      return theme2.color.whiteRGBA(0.05);
    default:
      return "transparent";
  }
}};
`;
var boxShadow = css10`
  box-shadow: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "gentle":
    case "gentleLarge":
    case "loud":
    case "loudLarge":
      return `inset 0px 0px 0 1px ${theme2.color.whiteRGBA(0.05)}`;
    case "gentleReverse":
    case "gentleLargeReverse":
      return `inset 0px 0px 0 1px ${theme2.color.spaceGrayRGBA(0.2)}`;
    case "softLink":
      return `inset 0px -1px 0 0 ${theme2.color.whiteRGBA(0.5)}`;
    case "softLinkReverse":
      return `inset 0px -1px 0 0 ${theme2.color.spaceGrayRGBA(0.3)}`;
    case "strongLink":
      return `inset 0px -1px 0 0 ${theme2.color.brand01RGBA(0.5)}`;
    default:
      return "none";
  }
}};
`;
var hover = css10`
  background-color: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "loud":
    case "loudLarge":
      return theme2.color.brand03RGBA(0.2);
    case "passive":
    case "passiveLarge":
      return theme2.color.whiteRGBA(0.05);
    case "passiveReverse":
    case "passiveLargeReverse":
      return theme2.color.spaceGrayRGBA(0.05);
    case "gentle":
    case "gentleLarge":
      return theme2.color.whiteRGBA(0.1);
    case "gentleReverse":
    case "gentleLargeReverse":
      return theme2.color.spaceGrayRGBA(0.1);
    case "louder":
    case "louderLarge":
      return `rgb(${darken(theme2.color.brand01, 0.1)})`;
    case "solid":
    case "solidLarge":
      return `rgb(${darken(theme2.color.white, 0.1)})`;
    case "solidReverse":
    case "solidLargeReverse":
      return theme2.color.spaceGrayRGBA(0.9);
    default:
      return "transparent";
  }
}};
  box-shadow: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "gentle":
    case "gentleLarge":
      return `inset 0px 0px 0 1px ${theme2.color.whiteRGBA(0.1)}`;
    case "gentleReverse":
    case "gentleLargeReverse":
      return `inset 0px 0px 0 1px ${theme2.color.spaceGrayRGBA(0.7)}`;
    case "softLink":
      return `inset 0px -1px 0 0 ${theme2.color.white}`;
    case "softLinkReverse":
      return `inset 0px -1px 0 0 ${theme2.color.spaceGrayRGBA(0.7)}`;
    case "strongLink":
      return `inset 0px -1px 0 0 ${theme2.color.brand01}`;
    default:
      return "none";
  }
}};
`;
var active = css10`
  background-color: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "loud":
    case "loudLarge":
      return theme2.color.brand03RGBA(0.2);
    case "passive":
    case "passiveLarge":
      return theme2.color.whiteRGBA(0.1);
    case "passiveReverse":
    case "passiveLargeReverse":
      return theme2.color.spaceGrayRGBA(0.1);
    case "gentle":
    case "gentleLarge":
      return theme2.color.whiteRGBA(0.1);
    case "gentleReverse":
    case "gentleLargeReverse":
      return theme2.color.spaceGrayRGBA(0.2);
    case "louder":
    case "louderLarge":
      return `rgb(${darken(theme2.color.brand01, 0.2)})`;
    case "solid":
    case "solidLarge":
      return `rgb(${darken(theme2.color.white, 0.2)})`;
    case "solidReverse":
    case "solidLargeReverse":
      return theme2.color.spaceGrayRGBA(0.8);
    default:
      return "transparent";
  }
}};
  box-shadow: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "gentle":
    case "gentleLarge":
      return `inset 0px 0px 0 1px ${theme2.color.whiteRGBA(0.2)}`;
    case "gentleReverse":
    case "gentleLargeReverse":
      return `inset 0px 0px 0 1px ${theme2.color.spaceGrayRGBA(0.5)}`;
    case "softLink":
      return `inset 0px -1px 0 0 ${theme2.color.whiteRGBA(0.8)}`;
    case "softLinkReverse":
      return `inset 0px -1px 0 0 ${theme2.color.spaceGrayRGBA(0.5)}`;
    case "strongLink":
      return `inset 0px -1px 0 0 ${theme2.color.brand01RGBA(0.8)}`;
    default:
      return "none";
  }
}};
`;
var disabled = css10`
  cursor: auto;
  pointer-events: none;
  opacity: 0.3;
  color: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "strongLink":
    case "loud":
    case "loudLarge":
      return theme2.color.brand01;
    case "gentleReverse":
    case "gentleLargeReverse":
    case "solid":
    case "solidLarge":
      return theme2.color.spaceGray;
    case "softLinkReverse":
      return theme2.color.darkGray;
    case "passive":
    case "passiveLarge":
      return theme2.color.whiteRGBA(0.7);
    case "passiveReverse":
    case "passiveLargeReverse":
      return theme2.color.spaceGrayRGBA(0.5);
    default:
      return theme2.color.white;
  }
}};
  box-shadow: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "strongLink":
    case "softLink":
      return `inset 0px -1px 0 0 ${theme2.color.whiteRGBA(0.3)}`;
    case "gentle":
    case "gentleLarge":
      return `inset 0px 0px 0 1px ${theme2.color.whiteRGBA(0.3)}`;
    case "gentleReverse":
    case "gentleLargeReverse":
      return `inset 0px 0px 0 1px ${theme2.color.spaceGrayRGBA(0.5)}`;
    default:
      return "none";
  }
}};
  background-color: 'transparent';
`;
var hasDarkSpinner = (styleType) => {
  switch (styleType) {
    case "passiveReverse":
    case "gentleReverse":
    case "gentleLargeReverse":
    case "solid":
    case "solidLarge":
      return true;
    default:
      return false;
  }
};
var loadingAnimationStyles = css10`
  position: absolute;
  top: 50%;
  right: 12px;
  margin-top: -${({ theme: theme2 }) => theme2.x2spacePx / 2}px;
`;
var loading = css10`
  ${loadingAnimation`
      ${loadingAnimationStyles}
      border-color: white;
      border-bottom-color: transparent;
    `}
`;
var loadingBlack = css10`
  ${loadingAnimation`
      ${loadingAnimationStyles}
      border-color: black;
      border-bottom-color: transparent;
  `}
`;
var horizontalMargin = css10`
  ${({ marginLeft, marginRight, theme: theme2 }) => {
  const marginLeftStyle = `margin-left: ${theme2.x1spacePx / 2}px;`;
  const marginRightStyle = `margin-right: ${theme2.x1spacePx / 2}px;`;
  if (marginLeft) {
    return marginLeftStyle;
  }
  if (marginRight) {
    return marginRightStyle;
  }
}};
`;
var verticalMargin = css10`
  ${({ marginTop, marginBottom, theme: theme2 }) => {
  if (marginTop) {
    return `margin-top: ${theme2.x1spacePx / 2}px;`;
  }
  if (marginBottom) {
    return `margin-bottom: ${theme2.x1spacePx / 2}px;`;
  }
}};
`;
var boxCSS = (boxType) => css10`
  display: ${boxType};
  width: ${boxType === "block" ? "100%" : "auto"};
  ${({ alignIcon }) => alignIcon && `text-align: left;`}
`;
var box = css10`
  ${({
  display,
  displayXsDown,
  displaySmDown,
  displayMdDown,
  displayLgDown,
  displaySmUp,
  displayMdUp,
  displayLgUp,
  displayXlUp
}) => {
  if (typeof display !== "undefined") {
    return boxCSS(display);
  }
  const entities = {
    displayXsDown,
    displaySmDown,
    displayMdDown,
    displayLgDown,
    displaySmUp,
    displayMdUp,
    displayLgUp,
    displayXlUp
  };
  return css10`
      ${displayKeys.filter((key) => key in entities).map((key) => {
    const displayEntity = entities[key];
    if (typeof displayEntity === "undefined") {
      return null;
    }
    return media_default[displayMap[key]]`
              ${boxCSS(displayEntity)}
          `;
  })}
    `;
}};
`;
var svgFill = css10`
  fill: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "loud":
    case "loudLarge":
      return theme2.color.brand01;
    case "louder":
    case "louderLarge":
    case "gentle":
    case "gentleLarge":
    case "passive":
    case "passiveLarge":
      return theme2.color.white;
    case "gentleReverse":
    case "gentleLargeReverse":
    case "solid":
    case "solidLarge":
    case "passiveReverse":
    case "passiveLargeReverse":
      return theme2.color.spaceGray;
    default:
      return theme2.color.white;
  }
}};
`;
var svg = css10`
  ${({ theme: theme2, alignIcon }) => {
  const dimensions = theme2.x3spacePx;
  const margin = theme2.x1spacePx / 2;
  const buttonPadding = theme2.x1spacePx;
  const padding3 = alignIcon ? `padding-${alignIcon}: ${dimensions + buttonPadding + margin}px;` : ``;
  return css10`
      ${padding3}
      > svg {
        display: inline;
        ${svgFill}
        opacity: 0.5;
        width: ${dimensions}px;
        height: ${dimensions}px;
        vertical-align: middle;
        margin: 0 ${alignIcon ? 0 : -(theme2.x1spacePx / 2)}px;
        ${alignIcon && css10`
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          ${alignIcon}: ${buttonPadding}px;
        `}
      }
    `;
}}
`;
var link = css10`
  border-radius: 0;
  text-align: left;
  ${({ as: type, theme: theme2, styleType }) => {
  if (type === "a") {
    return `
        display: inline;
        padding: ${styleType === "softLinkReverse" ? theme2.x1spacePx / 2 - 1 : theme2.x1spacePx / 2}px 0;
      `;
  }
}}
`;
var buttonCSS = css10`
  position: relative;
  transition:
    0.2s background-color,
    0.2s box-shadow,
    0.4s color,
    padding 0.4s;
  border: 0;
  margin: 0;
  border-radius: 6px;
  text-decoration: none;
  vertical-align: top;
  ${font}
  ${lineHeight}
  ${color}
  ${height}
  ${padding}
  ${boxShadow}
  ${backgroundColor}
  ${media_default.mdUp`
    &:hover {
      ${hover}
    }
  `}
  &:active {
    ${active}
  }
  &:disabled {
    ${disabled}
    ${({ styleType, isLoading }) => isLoading && (hasDarkSpinner(styleType) ? loadingBlack : loading)}
  }
  /*
  * SVG Support
  */
  ${svg}
  /*
  * Spacing
  */
  ${({ marginTop, marginBottom }) => (marginTop || marginBottom) && verticalMargin}
  ${({ marginLeft, marginRight }) => (marginLeft || marginRight) && horizontalMargin}
  /*
  * Display
  */
  align-content: center;

  ${({
  display,
  displayXsDown,
  displaySmDown,
  displayMdDown,
  displayLgDown,
  displaySmUp,
  displayMdUp,
  displayLgUp,
  displayXlUp
}) => (display || displayXsDown || displaySmDown || displayMdDown || displayLgDown || displaySmUp || displayMdUp || displayLgUp || displayXlUp) && box}
  /*
  * Link
  */
  ${({ styleType }) => (styleType === "softLink" || styleType === "softLinkReverse" || styleType === "strongLink") && link}
  ${({ isLoading, display }) => isLoading && !display && css10`
      padding-right: 34px;
    `}
`;
var Button = styled4("button").attrs(({ theme: theme2, styleType }) => {
  const focusType = styleType === "softLink" || styleType === "strongLink" || styleType === "softLinkReverse" ? "solid" : "dashed";
  return {
    ...theme2.focus(focusType)
  };
})`
  ${buttonCSS}
`;
var Button_default = Button;

// src/components/Modal/components/Footer/styled.ts
import styled7 from "styled-components";

// src/components/FlexGrid/Row.ts
import styled5, { css as css12 } from "styled-components";

// src/components/FlexGrid/utils.ts
import { css as css11 } from "styled-components";
var getWidth = (n) => n / 12 * 100;
var getFlex = (span) => {
  if (typeof span !== "number" || span === void 0)
    return;
  const n = getWidth(span);
  return css11`
    flex: 0 0 ${n}%;
    max-width: ${n}%;
  `;
};
var getFlexOrder = (n) => {
  if (n === "first") {
    return `order: -1;`;
  } else if (n === "last") {
    return `order: 13;`;
  } else {
    return `order: ${n};`;
  }
};
var getFlexOffset = (span) => {
  if (typeof span !== "number" || span === void 0)
    return;
  return `margin-left: ${getWidth(span)}%;`;
};
var getFlexJustifyContent = (type) => css11`
  justify-content: ${type};
`;
var getFlexAlignContent = (type) => css11`
  align-content: ${type} !important;
`;
var getFlexAlignItem = (type) => css11`
  align-items: ${type};
`;
var getFlexAlignSelf = (type) => css11`
  align-self: ${type} !important;
`;
var getFlexRow = () => css11`
  flex-direction: row !important;
`;
var getFlexColumn = () => css11`
  flex-direction: column !important;
`;
var getFlexRowReverse = () => css11`
  flex-direction: row-reverse !important;
`;
var getFlexColumnReverse = () => css11`
  flex-direction: column-reverse !important;
`;
var getFlexWrap = () => css11`
  flex-wrap: wrap !important;
`;
var getFlexNoWrap = () => css11`
  flex-wrap: nowrap !important;
`;
var getFlexWrapReverse = () => css11`
  flex-wrap: wrap-reverse !important;
`;
var getFlexFillVoid = () => css11`
  flex: 1 1 auto !important;
`;
var getDisplayInline = () => css11`
  display: inline !important;
`;
var getDisplayInlineBlock = () => css11`
  display: inline-block !important;
`;
var getDisplayBlock = () => css11`
  display: block !important;
`;
var getDisplayTable = () => css11`
  display: table !important;
`;
var getDisplayTableRow = () => css11`
  display: table-row !important;
`;
var getDisplayTableCell = () => css11`
  display: table-cell !important;
`;
var getDisplayFlex = () => css11`
  display: flex;
`;
var getDisplayInlineFlex = () => css11`
  display: inline-flex !important;
`;
var getGap = (gap) => css11`
  gap: ${gap};
`;

// src/components/FlexGrid/Row.ts
var Row = styled5("div")`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  ${({ justifyContent }) => justifyContent && getFlexJustifyContent(justifyContent)}
  ${({ alignContent }) => alignContent && getFlexAlignContent(alignContent)}
  ${({ alignItem }) => alignItem && getFlexAlignItem(alignItem)}
  ${({ fillVoid }) => fillVoid && getFlexFillVoid()}
  ${({ row }) => row && getFlexRow()}
  ${({ column }) => column && getFlexColumn()}
  ${({ noWrap }) => noWrap && getFlexNoWrap()}
  ${({ rowReverse }) => rowReverse && getFlexRowReverse()}
  ${({ columnReverse }) => columnReverse && getFlexColumnReverse()}
  ${({ gap }) => gap && getGap(gap)}  
  ${({ width }) => width && css12`
      width: ${width};
    `}
  ${({ height: height4 }) => height4 && css12`
      height: ${height4};
    `}
  ${({ maxWidth }) => maxWidth && css12`
      max-width: ${maxWidth};
    `}
  ${({ maxHeight }) => maxHeight && css12`
      max-height: ${maxHeight};
    `}

    ${({ hiddenXsDown }) => {
  if (hiddenXsDown) {
    return media_default.xsDown`
        ${css12`
          display: none !important;
        `}
      `;
  }
}}

  ${({
  justifyContentSm,
  alignContentSm,
  rowSm,
  columnSm,
  rowReverseSm,
  columnReverseSm,
  colSm,
  offsetSm,
  orderSm,
  alignItemSm,
  alignSelfSm,
  wrapSm,
  noWrapSm,
  wrapReverseSm,
  fillVoidSm,
  displayInlineSm,
  displayInlineBlockSm,
  displayBlockSm,
  displayTableSm,
  displayTableRowSm,
  displayTableCellSm,
  displayFlexSm,
  displayInlineFlexSm,
  hiddenSmUp
}) => {
  if (colSm || offsetSm || orderSm || justifyContentSm || alignContentSm || alignItemSm || alignSelfSm || rowSm || columnSm || rowReverseSm || columnReverseSm || wrapSm || noWrapSm || wrapReverseSm || fillVoidSm || displayInlineSm || displayInlineBlockSm || displayBlockSm || displayTableSm || displayTableRowSm || displayTableCellSm || displayFlexSm || displayInlineFlexSm || hiddenSmUp) {
    return media_default.smUp`
        ${colSm && getFlex(colSm)}
        ${offsetSm && getFlexOffset(offsetSm)}
        ${orderSm && getFlexOrder(orderSm)}
        ${justifyContentSm && getFlexJustifyContent(justifyContentSm)}
        ${alignContentSm && getFlexAlignContent(alignContentSm)}
        ${alignItemSm && getFlexAlignItem(alignItemSm)}
        ${alignSelfSm && getFlexAlignSelf(alignSelfSm)}
        ${rowSm && getFlexRow()}
        ${columnSm && getFlexColumn()}
        ${rowReverseSm && getFlexRowReverse()}
        ${columnReverseSm && getFlexColumnReverse()}
        ${wrapSm && getFlexWrap()}
        ${noWrapSm && getFlexNoWrap()}
        ${wrapReverseSm && getFlexWrapReverse()}
        ${fillVoidSm && getFlexFillVoid()}
        ${displayInlineSm && getDisplayInline()}
        ${displayInlineBlockSm && getDisplayInlineBlock()}
        ${displayBlockSm && getDisplayBlock()}
        ${displayTableSm && getDisplayTable()}
        ${displayTableRowSm && getDisplayTableRow()}
        ${displayTableCellSm && getDisplayTableCell()}
        ${displayFlexSm && getDisplayFlex()}
        ${displayInlineFlexSm && getDisplayInlineFlex()}
        ${hiddenSmUp && css12`
            display: none !important;
          `}
      `;
  }
}}

  ${({ hiddenSmDown }) => {
  if (hiddenSmDown) {
    return media_default.smDown`
        ${css12`
          display: none !important;
        `}
      `;
  }
}}

  ${({
  justifyContentMd,
  alignContentMd,
  rowMd,
  columnMd,
  rowReverseMd,
  columnReverseMd,
  colMd,
  offsetMd,
  orderMd,
  alignItemMd,
  alignSelfMd,
  wrapMd,
  noWrapMd,
  wrapReverseMd,
  fillVoidMd,
  displayInlineMd,
  displayInlineBlockMd,
  displayBlockMd,
  displayTableMd,
  displayTableRowMd,
  displayTableCellMd,
  displayFlexMd,
  displayInlineFlexMd,
  hiddenMdUp
}) => {
  if (colMd || offsetMd || orderMd || justifyContentMd || alignContentMd || alignItemMd || alignSelfMd || rowMd || columnMd || rowReverseMd || columnReverseMd || wrapMd || noWrapMd || wrapReverseMd || fillVoidMd || displayInlineMd || displayInlineBlockMd || displayBlockMd || displayTableMd || displayTableRowMd || displayTableCellMd || displayFlexMd || displayInlineFlexMd || hiddenMdUp) {
    return media_default.mdUp`
        ${colMd && getFlex(colMd)};
        ${offsetMd && getFlexOffset(offsetMd)}
        ${orderMd && getFlexOrder(orderMd)}
        ${justifyContentMd && getFlexJustifyContent(justifyContentMd)}
        ${alignContentMd && getFlexAlignContent(alignContentMd)}
        ${alignItemMd && getFlexAlignItem(alignItemMd)}
        ${alignSelfMd && getFlexAlignSelf(alignSelfMd)}
        ${rowMd && getFlexRow()}
        ${columnMd && getFlexColumn()}
        ${rowReverseMd && getFlexRowReverse()}
        ${columnReverseMd && getFlexColumnReverse()}
        ${wrapMd && getFlexWrap()}
        ${noWrapMd && getFlexNoWrap()}
        ${wrapReverseMd && getFlexWrapReverse()}
        ${fillVoidMd && getFlexFillVoid()}
        ${displayInlineMd && getDisplayInline()}
        ${displayInlineBlockMd && getDisplayInlineBlock()}
        ${displayBlockMd && getDisplayBlock()}
        ${displayTableMd && getDisplayTable()}
        ${displayTableRowMd && getDisplayTableRow()}
        ${displayTableCellMd && getDisplayTableCell()}
        ${displayFlexMd && getDisplayFlex()}
        ${displayInlineFlexMd && getDisplayInlineFlex()}
        ${hiddenMdUp && css12`
            display: none !important;
          `}
      `;
  }
}}

  ${({ hiddenMdDown }) => {
  if (hiddenMdDown) {
    return media_default.mdDown`
        ${css12`
          display: none !important;
        `}
      `;
  }
}}

  ${({
  justifyContentLg,
  alignContentLg,
  rowLg,
  columnLg,
  rowReverseLg,
  columnReverseLg,
  colLg,
  offsetLg,
  orderLg,
  alignItemLg,
  alignSelfLg,
  wrapLg,
  noWrapLg,
  wrapReverseLg,
  fillVoidLg,
  displayInlineLg,
  displayInlineBlockLg,
  displayBlockLg,
  displayTableLg,
  displayTableRowLg,
  displayTableCellLg,
  displayFlexLg,
  displayInlineFlexLg,
  hiddenLgUp
}) => {
  if (colLg || offsetLg || orderLg || justifyContentLg || alignContentLg || alignItemLg || alignSelfLg || rowLg || columnLg || rowReverseLg || columnReverseLg || wrapLg || noWrapLg || wrapReverseLg || fillVoidLg || displayInlineLg || displayInlineBlockLg || displayBlockLg || displayTableLg || displayTableRowLg || displayTableCellLg || displayFlexLg || displayInlineFlexLg || hiddenLgUp) {
    return media_default.lgUp`
        ${colLg && getFlex(colLg)};
        ${offsetLg && getFlexOffset(offsetLg)}
        ${orderLg && getFlexOrder(orderLg)}
        ${justifyContentLg && getFlexJustifyContent(justifyContentLg)}
        ${alignContentLg && getFlexAlignContent(alignContentLg)}
        ${alignItemLg && getFlexAlignItem(alignItemLg)}
        ${alignSelfLg && getFlexAlignSelf(alignSelfLg)}
        ${rowLg && getFlexRow()}
        ${columnLg && getFlexColumn()}
        ${rowReverseLg && getFlexRowReverse()}
        ${columnReverseLg && getFlexColumnReverse()}
        ${wrapLg && getFlexWrap()}
        ${noWrapLg && getFlexNoWrap()}
        ${wrapReverseLg && getFlexWrapReverse()}
        ${fillVoidLg && getFlexFillVoid()}
        ${displayInlineLg && getDisplayInline()}
        ${displayInlineBlockLg && getDisplayInlineBlock()}
        ${displayBlockLg && getDisplayBlock()}
        ${displayTableLg && getDisplayTable()}
        ${displayTableRowLg && getDisplayTableRow()}
        ${displayTableCellLg && getDisplayTableCell()}
        ${displayFlexLg && getDisplayFlex()}
        ${displayInlineFlexLg && getDisplayInlineFlex()}
        ${hiddenLgUp && css12`
            display: none !important;
          `}
      `;
  }
}}

  ${({ hiddenLgDown }) => {
  if (hiddenLgDown) {
    return media_default.lgDown`
        ${hiddenLgDown && css12`
            display: none !important;
          `}
      `;
  }
}}

  ${({
  justifyContentXl,
  alignContentXl,
  rowXl,
  columnXl,
  rowReverseXl,
  columnReverseXl,
  colXl,
  offsetXl,
  orderXl,
  alignItemXl,
  alignSelfXl,
  wrapXl,
  noWrapXl,
  wrapReverseXl,
  fillVoidXl,
  displayInlineXl,
  displayInlineBlockXl,
  displayBlockXl,
  displayTableXl,
  displayTableRowXl,
  displayTableCellXl,
  displayFlexXl,
  displayInlineFlexXl,
  hiddenXlUp
}) => {
  if (colXl || offsetXl || orderXl || justifyContentXl || alignContentXl || alignItemXl || alignSelfXl || rowXl || columnXl || rowReverseXl || columnReverseXl || wrapXl || noWrapXl || wrapReverseXl || fillVoidXl || displayInlineXl || displayInlineBlockXl || displayBlockXl || displayTableXl || displayTableRowXl || displayTableCellXl || displayFlexXl || displayInlineFlexXl || hiddenXlUp) {
    return media_default.xlUp`
        ${colXl && getFlex(colXl)};
        ${offsetXl && getFlexOffset(offsetXl)}
        ${orderXl && getFlexOrder(orderXl)}
        ${justifyContentXl && getFlexJustifyContent(justifyContentXl)}
        ${alignContentXl && getFlexAlignContent(alignContentXl)}
        ${alignItemXl && getFlexAlignItem(alignItemXl)}
        ${alignSelfXl && getFlexAlignSelf(alignSelfXl)}
        ${rowXl && getFlexRow()}
        ${columnXl && getFlexColumn()}
        ${rowReverseXl && getFlexRowReverse()}
        ${columnReverseXl && getFlexColumnReverse()}
        ${wrapXl && getFlexWrap()}
        ${noWrapXl && getFlexNoWrap()}
        ${wrapReverseXl && getFlexWrapReverse()}
        ${fillVoidXl && getFlexFillVoid()}
        ${displayInlineXl && getDisplayInline()}
        ${displayInlineBlockXl && getDisplayInlineBlock()}
        ${displayBlockXl && getDisplayBlock()}
        ${displayTableXl && getDisplayTable()}
        ${displayTableRowXl && getDisplayTableRow()}
        ${displayTableCellXl && getDisplayTableCell()}
        ${displayFlexXl && getDisplayFlex()}
        ${displayInlineFlexXl && getDisplayInlineFlex()}
        ${hiddenXlUp && css12`
            display: none !important;
          `}
      `;
  }
}}
`;
var Row_default = Row;

// src/components/FlexGrid/Column.ts
import styled6, { css as css13 } from "styled-components";
var Column = styled6("div")`
  flex-grow: 1;
  flex-basis: 0;
  position: relative;
  ${({ fillVoid, width }) => !fillVoid && !width && `width: 100%;`}
  ${({ marginRightAuto }) => marginRightAuto && `margin-right: auto;`}
  min-height: 0px;
  max-width: ${({ maxWidth }) => maxWidth ? maxWidth : `100%`};
  ${({ col, width }) => col ? getFlex(col) : width ? `flex: 0 0 ${width};` : `flex: 0 0 100%;`}
  ${({ offset }) => offset && getFlexOffset(offset)}
  ${({ order }) => order && getFlexOrder(order)}
  ${({ justifyContent }) => justifyContent && getFlexJustifyContent(justifyContent)}
  ${({ alignContent }) => alignContent && getFlexAlignContent(alignContent)}
  ${({ alignItem }) => alignItem && getFlexAlignItem(alignItem)}
  ${({ alignSelf }) => alignSelf && getFlexAlignSelf(alignSelf)}
  ${({ row }) => row && getFlexRow()}
  ${({ column }) => column && getFlexColumn()}
  ${({ rowReverse }) => rowReverse && getFlexRowReverse()}
  ${({ columnReverse }) => columnReverse && getFlexColumnReverse()}
  ${({ wrap }) => wrap && getFlexWrap()}
  ${({ noWrap }) => noWrap && getFlexNoWrap()}
  ${({ wrapReverse }) => wrapReverse && getFlexWrapReverse()}
  ${({ fillVoid }) => fillVoid && getFlexFillVoid()}
  ${({ displayInline }) => displayInline && getDisplayInline()}
  ${({ displayInlineBlock }) => displayInlineBlock && getDisplayInlineBlock()}
  ${({ displayBlock }) => displayBlock && getDisplayBlock()}
  ${({ displayTable }) => displayTable && getDisplayTable()}
  ${({ displayTableRow }) => displayTableRow && getDisplayTableRow()}
  ${({ displayTableCell }) => displayTableCell && getDisplayTableCell()}
  ${({ displayFlex }) => displayFlex && getDisplayFlex()}
  ${({ displayInlineFlex }) => displayInlineFlex && getDisplayInlineFlex()}

  ${({ hiddenXsDown }) => {
  if (hiddenXsDown) {
    return media_default.xsDown`
        ${css13`
          display: none !important;
        `}
      `;
  }
}}

  ${({
  justifyContentSm,
  alignContentSm,
  rowSm,
  columnSm,
  rowReverseSm,
  columnReverseSm,
  colSm,
  offsetSm,
  orderSm,
  alignItemSm,
  alignSelfSm,
  wrapSm,
  noWrapSm,
  wrapReverseSm,
  fillVoidSm,
  displayInlineSm,
  displayInlineBlockSm,
  displayBlockSm,
  displayTableSm,
  displayTableRowSm,
  displayTableCellSm,
  displayFlexSm,
  displayInlineFlexSm,
  hiddenSmUp
}) => {
  if (colSm || offsetSm || orderSm || justifyContentSm || alignContentSm || alignItemSm || alignSelfSm || rowSm || columnSm || rowReverseSm || columnReverseSm || wrapSm || noWrapSm || wrapReverseSm || fillVoidSm || displayInlineSm || displayInlineBlockSm || displayBlockSm || displayTableSm || displayTableRowSm || displayTableCellSm || displayFlexSm || displayInlineFlexSm || hiddenSmUp) {
    return media_default.smUp`
        ${colSm && getFlex(colSm)}
        ${offsetSm && getFlexOffset(offsetSm)}
        ${orderSm && getFlexOrder(orderSm)}
        ${justifyContentSm && getFlexJustifyContent(justifyContentSm)}
        ${alignContentSm && getFlexAlignContent(alignContentSm)}
        ${alignItemSm && getFlexAlignItem(alignItemSm)}
        ${alignSelfSm && getFlexAlignSelf(alignSelfSm)}
        ${rowSm && getFlexRow()}
        ${columnSm && getFlexColumn()}
        ${rowReverseSm && getFlexRowReverse()}
        ${columnReverseSm && getFlexColumnReverse()}
        ${wrapSm && getFlexWrap()}
        ${noWrapSm && getFlexNoWrap()}
        ${wrapReverseSm && getFlexWrapReverse()}
        ${fillVoidSm && getFlexFillVoid()}
        ${displayInlineSm && getDisplayInline()}
        ${displayInlineBlockSm && getDisplayInlineBlock()}
        ${displayBlockSm && getDisplayBlock()}
        ${displayTableSm && getDisplayTable()}
        ${displayTableRowSm && getDisplayTableRow()}
        ${displayTableCellSm && getDisplayTableCell()}
        ${displayFlexSm && getDisplayFlex()}
        ${displayInlineFlexSm && getDisplayInlineFlex()}
        ${hiddenSmUp && css13`
            display: none !important;
          `}
      `;
  }
}}

  ${({ hiddenSmDown }) => {
  if (hiddenSmDown) {
    return media_default.smDown`
        ${css13`
          display: none !important;
        `}
      `;
  }
}}

  ${({
  justifyContentMd,
  alignContentMd,
  rowMd,
  columnMd,
  rowReverseMd,
  columnReverseMd,
  colMd,
  offsetMd,
  orderMd,
  alignItemMd,
  alignSelfMd,
  wrapMd,
  noWrapMd,
  wrapReverseMd,
  fillVoidMd,
  displayInlineMd,
  displayInlineBlockMd,
  displayBlockMd,
  displayTableMd,
  displayTableRowMd,
  displayTableCellMd,
  displayFlexMd,
  displayInlineFlexMd,
  hiddenMdUp
}) => {
  if (colMd || offsetMd || orderMd || justifyContentMd || alignContentMd || alignItemMd || alignSelfMd || rowMd || columnMd || rowReverseMd || columnReverseMd || wrapMd || noWrapMd || wrapReverseMd || fillVoidMd || displayInlineMd || displayInlineBlockMd || displayBlockMd || displayTableMd || displayTableRowMd || displayTableCellMd || displayFlexMd || displayInlineFlexMd || hiddenMdUp) {
    return media_default.mdUp`
        ${colMd && getFlex(colMd)};
        ${offsetMd && getFlexOffset(offsetMd)}
        ${orderMd && getFlexOrder(orderMd)}
        ${justifyContentMd && getFlexJustifyContent(justifyContentMd)}
        ${alignContentMd && getFlexAlignContent(alignContentMd)}
        ${alignItemMd && getFlexAlignItem(alignItemMd)}
        ${alignSelfMd && getFlexAlignSelf(alignSelfMd)}
        ${rowMd && getFlexRow()}
        ${columnMd && getFlexColumn()}
        ${rowReverseMd && getFlexRowReverse()}
        ${columnReverseMd && getFlexColumnReverse()}
        ${wrapMd && getFlexWrap()}
        ${noWrapMd && getFlexNoWrap()}
        ${wrapReverseMd && getFlexWrapReverse()}
        ${fillVoidMd && getFlexFillVoid()}
        ${displayInlineMd && getDisplayInline()}
        ${displayInlineBlockMd && getDisplayInlineBlock()}
        ${displayBlockMd && getDisplayBlock()}
        ${displayTableMd && getDisplayTable()}
        ${displayTableRowMd && getDisplayTableRow()}
        ${displayTableCellMd && getDisplayTableCell()}
        ${displayFlexMd && getDisplayFlex()}
        ${displayInlineFlexMd && getDisplayInlineFlex()}
        ${hiddenMdUp && css13`
            display: none !important;
          `}
      `;
  }
}}

  ${({ hiddenMdDown }) => {
  if (hiddenMdDown) {
    return media_default.mdDown`
        ${css13`
          display: none !important;
        `}
      `;
  }
}}

  ${({
  justifyContentLg,
  alignContentLg,
  rowLg,
  columnLg,
  rowReverseLg,
  columnReverseLg,
  colLg,
  offsetLg,
  orderLg,
  alignItemLg,
  alignSelfLg,
  wrapLg,
  noWrapLg,
  wrapReverseLg,
  fillVoidLg,
  displayInlineLg,
  displayInlineBlockLg,
  displayBlockLg,
  displayTableLg,
  displayTableRowLg,
  displayTableCellLg,
  displayFlexLg,
  displayInlineFlexLg,
  hiddenLgUp
}) => {
  if (colLg || offsetLg || orderLg || justifyContentLg || alignContentLg || alignItemLg || alignSelfLg || rowLg || columnLg || rowReverseLg || columnReverseLg || wrapLg || noWrapLg || wrapReverseLg || fillVoidLg || displayInlineLg || displayInlineBlockLg || displayBlockLg || displayTableLg || displayTableRowLg || displayTableCellLg || displayFlexLg || displayInlineFlexLg || hiddenLgUp) {
    return media_default.lgUp`
        ${colLg && getFlex(colLg)};
        ${offsetLg && getFlexOffset(offsetLg)}
        ${orderLg && getFlexOrder(orderLg)}
        ${justifyContentLg && getFlexJustifyContent(justifyContentLg)}
        ${alignContentLg && getFlexAlignContent(alignContentLg)}
        ${alignItemLg && getFlexAlignItem(alignItemLg)}
        ${alignSelfLg && getFlexAlignSelf(alignSelfLg)}
        ${rowLg && getFlexRow()}
        ${columnLg && getFlexColumn()}
        ${rowReverseLg && getFlexRowReverse()}
        ${columnReverseLg && getFlexColumnReverse()}
        ${wrapLg && getFlexWrap()}
        ${noWrapLg && getFlexNoWrap()}
        ${wrapReverseLg && getFlexWrapReverse()}
        ${fillVoidLg && getFlexFillVoid()}
        ${displayInlineLg && getDisplayInline()}
        ${displayInlineBlockLg && getDisplayInlineBlock()}
        ${displayBlockLg && getDisplayBlock()}
        ${displayTableLg && getDisplayTable()}
        ${displayTableRowLg && getDisplayTableRow()}
        ${displayTableCellLg && getDisplayTableCell()}
        ${displayFlexLg && getDisplayFlex()}
        ${displayInlineFlexLg && getDisplayInlineFlex()}
        ${hiddenLgUp && css13`
            display: none !important;
          `}
      `;
  }
}}

  ${({ hiddenLgDown }) => {
  if (hiddenLgDown) {
    return media_default.lgDown`
        ${hiddenLgDown && css13`
            display: none !important;
          `}
      `;
  }
}}

  ${({
  justifyContentXl,
  alignContentXl,
  rowXl,
  columnXl,
  rowReverseXl,
  columnReverseXl,
  colXl,
  offsetXl,
  orderXl,
  alignItemXl,
  alignSelfXl,
  wrapXl,
  noWrapXl,
  wrapReverseXl,
  fillVoidXl,
  displayInlineXl,
  displayInlineBlockXl,
  displayBlockXl,
  displayTableXl,
  displayTableRowXl,
  displayTableCellXl,
  displayFlexXl,
  displayInlineFlexXl,
  hiddenXlUp
}) => {
  if (colXl || offsetXl || orderXl || justifyContentXl || alignContentXl || alignItemXl || alignSelfXl || rowXl || columnXl || rowReverseXl || columnReverseXl || wrapXl || noWrapXl || wrapReverseXl || fillVoidXl || displayInlineXl || displayInlineBlockXl || displayBlockXl || displayTableXl || displayTableRowXl || displayTableCellXl || displayFlexXl || displayInlineFlexXl || hiddenXlUp) {
    return media_default.xlUp`
        ${colXl && getFlex(colXl)};
        ${offsetXl && getFlexOffset(offsetXl)}
        ${orderXl && getFlexOrder(orderXl)}
        ${justifyContentXl && getFlexJustifyContent(justifyContentXl)}
        ${alignContentXl && getFlexAlignContent(alignContentXl)}
        ${alignItemXl && getFlexAlignItem(alignItemXl)}
        ${alignSelfXl && getFlexAlignSelf(alignSelfXl)}
        ${rowXl && getFlexRow()}
        ${columnXl && getFlexColumn()}
        ${rowReverseXl && getFlexRowReverse()}
        ${columnReverseXl && getFlexColumnReverse()}
        ${wrapXl && getFlexWrap()}
        ${noWrapXl && getFlexNoWrap()}
        ${wrapReverseXl && getFlexWrapReverse()}
        ${fillVoidXl && getFlexFillVoid()}
        ${displayInlineXl && getDisplayInline()}
        ${displayInlineBlockXl && getDisplayInlineBlock()}
        ${displayBlockXl && getDisplayBlock()}
        ${displayTableXl && getDisplayTable()}
        ${displayTableRowXl && getDisplayTableRow()}
        ${displayTableCellXl && getDisplayTableCell()}
        ${displayFlexXl && getDisplayFlex()}
        ${displayInlineFlexXl && getDisplayInlineFlex()}
        ${hiddenXlUp && css13`
            display: none !important;
          `}
      `;
  }
}}
`;
var Column_default = Column;

// src/components/Modal/components/Footer/styled.ts
var Wrapper = styled7(Row_default)`
  background: white;
  padding: ${({ theme: theme2 }) => theme2.x2spacePx}px;
  border-top: 1px solid #e8e8e8;
  ${({ theme: theme2 }) => media_default.mdDown`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    > button {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      &:first-child + button {
        margin-left: ${theme2.x1spacePx}px;
      }
    }
  `}
`;

// src/components/Modal/components/Footer/Footer.tsx
import { Fragment, jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var Footer = ({
  confirmWithSubmit = false,
  disabled: disabled4 = false,
  secondaryLabel,
  onPrimaryClick,
  onSecondaryClick,
  primaryLabel,
  primaryLoading = false,
  secondaryLoading = false,
  primaryDisabled = false,
  secondaryDisabled = false,
  justifyContent = "flex-end",
  children
}) => {
  const handleSecondaryClick = useCallback(() => {
    onSecondaryClick && onSecondaryClick();
  }, [onSecondaryClick]);
  const handlePrimaryClick = useCallback(
    (e) => {
      confirmWithSubmit === false && onPrimaryClick && onPrimaryClick(e);
    },
    [confirmWithSubmit, onPrimaryClick]
  );
  return /* @__PURE__ */ jsx4(Wrapper, { as: "footer", justifyContentMd: justifyContent || "flex-end", children: children ? children : /* @__PURE__ */ jsxs2(Fragment, { children: [
    typeof secondaryLabel !== "undefined" && /* @__PURE__ */ jsx4(
      Button_default,
      {
        type: "button",
        "data-testid": "modal-secondary-button",
        styleType: "gentleLargeReverse",
        marginRight: true,
        displaySmDown: "block",
        onClick: handleSecondaryClick,
        disabled: secondaryDisabled || disabled4 || secondaryLoading,
        isLoading: secondaryLoading,
        "data-cy-id": "modal-close-button",
        children: secondaryLabel
      }
    ),
    typeof primaryLabel !== "undefined" && /* @__PURE__ */ jsx4(
      Button_default,
      {
        styleType: "louderLarge",
        "data-testid": "modal-primary-button",
        type: confirmWithSubmit ? "submit" : "button",
        displaySmDown: "block",
        disabled: primaryDisabled || disabled4 || primaryLoading,
        onClick: (
          // Cast is here as types have changed in react 18, but wished to limit impact of type change
          handlePrimaryClick
        ),
        isLoading: primaryLoading,
        "data-cy-id": "modal-confirm-button",
        children: primaryLabel
      }
    )
  ] }) });
};
var Footer_default = Footer;

// src/components/Modal/components/Header/styled.ts
import styled8, { css as css14 } from "styled-components";
var Wrapper2 = styled8("header")`
  ${({ theme: theme2 }) => css14`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    position: relative;
    z-index: 1;
    padding: ${theme2.x2spacePx}px;
    padding-left: ${theme2.x3spacePx}px;
    padding-right: ${theme2.x3spacePx}px;
    border-bottom: 1px solid #e8e8e8;
    color: ${theme2.color.black};
    min-height: ${theme2.x8spacePx}px;
    > h1 {
      ${theme2.typography.largeStrong}
      margin: 0;
      color: ${theme2.color.spaceGray};
    }
  `}
`;

// src/icons/CrossSolid.tsx
import { forwardRef } from "react";

// src/icons/solid/cross.svg
import * as React from "react";
import { jsx as jsx5 } from "react/jsx-runtime";
var SvgCross = (props) => /* @__PURE__ */ jsx5("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx5("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.75886 6.34273C7.36834 5.9522 6.73518 5.9522 6.34465 6.34273C5.95413 6.73325 5.95413 7.36642 6.34465 7.75694L10.5869 11.9992L6.34359 16.2426C5.95307 16.6331 5.95307 17.2663 6.34359 17.6568C6.73412 18.0473 7.36728 18.0473 7.75781 17.6568L12.0012 13.4134L16.2441 17.6564C16.6347 18.047 17.2678 18.047 17.6584 17.6564C18.0489 17.2659 18.0489 16.6327 17.6584 16.2422L13.4154 11.9992L17.6573 7.75731C18.0478 7.36678 18.0478 6.73362 17.6573 6.34309C17.2668 5.95257 16.6336 5.95257 16.2431 6.34309L12.0012 10.585L7.75886 6.34273Z" }) });
var cross_default = SvgCross;

// src/icons/CrossSolid.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var CrossSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx6(cross_default, { ref, ...props })
);

// src/components/Modal/components/Header/Header.tsx
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var Header = ({ title, onClose, disabled: disabled4, hideClose = false }) => /* @__PURE__ */ jsxs3(Wrapper2, { "data-cy-id": "modal-header", children: [
  typeof title === "string" ? /* @__PURE__ */ jsx7("h1", { "data-testid": "modal-title", children: title }) : title,
  !hideClose && /* @__PURE__ */ jsx7(
    Button_default,
    {
      type: "button",
      styleType: "passiveReverse",
      disabled: disabled4,
      "data-testid": "modal-close",
      "data-cy-id": "modal-close-icon-button",
      onClick: onClose,
      children: /* @__PURE__ */ jsx7(CrossSolid_default, {})
    }
  )
] });
var Header_default = Header;

// src/components/Modal/components/Content/styled.ts
import styled9, { keyframes as keyframes2, css as css15 } from "styled-components";
var onEnter = keyframes2`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
var Wrapper3 = styled9(Row_default)`
  ${({ theme: theme2, scrollable, isLoading, dropOpacity, fullscreen }) => {
  return css15`
      top: 0;
      left: 0;
      position: fixed;
      background: ${fullscreen && !isLoading ? theme2.color.white : theme2.color.spaceGrayRGBA(dropOpacity ? 0.4 : 0.9)};
      animation: ${onEnter} 0.1s linear;
      height: 100%;
      z-index: 9999;
      padding: ${fullscreen ? 0 : theme2.x2spacePx}px;
      padding-top: ${`calc(${fullscreen ? 0 : theme2.x2spacePx}px + ${theme2.safeAreaInsetTop})`};
      padding-bottom: ${`calc(${fullscreen ? 0 : theme2.x2spacePx}px + ${theme2.safeAreaInsetBottom})`};
      overflow-y: ${scrollable ? "auto" : "hidden"};

      ${media_default.mdUp`
        padding: ${theme2.x4spacePx}px;
      `};
      ${media_default.smDown`
         ${scrollable && !isLoading && css15`
             display: block;
           `}
      `};
      ${media_default.lgUp`
        background: ${theme2.color.spaceGrayRGBA(dropOpacity ? 0.4 : 0.9)};
      `};
    `;
}};
`;
var Body = styled9("section")`
  ${({ theme: theme2, scrollable }) => {
  return css15`
      position: relative;
      background: white;
      color: black;
      ${scrollable && css15`
        overflow-y: auto;
        overflow-x: hidden;
      `}
      font-size: ${({ theme: theme3 }) => theme3.x2space}rem;
      line-height: 1.5;
      padding: ${({ theme: theme3 }) => theme3.x4spacePx}px
        ${({ theme: theme3 }) => theme3.x3spacePx}px;
      ${media_default.lgUp`
        max-height: calc(480px - 88px); /* 130px = header height + footer height */
      `};
      ${media_default.mdDown`
        position: absolute;
        width: 100%;
        z-index: 0;
        top: ${theme2.x8spacePx}px;
        /* Height: 100% parent height - header height - footer height*/
        height: ${`calc(100% - ${theme2.x8spacePx}px - ${theme2.x9spacePx}px)`};
        -webkit-overflow-scrolling: touch;
      `};
    `;
}};
`;

// src/components/LoadingWarren/styled.ts
import styled10, { keyframes as keyframes3 } from "styled-components";
var blink = keyframes3`
	0% 					{transform: translateY(0px) scaleY(1);}
	90%		 			{transform: translateY(0px) scaleY(1);}
	100% 				{transform: translateY(100px) scaleY(.1);}
`;
var sniff = keyframes3`
	0% 					{transform: translateY(0px)}
	80%		 			{transform: translateY(0px)}
	90% 				{transform: translateY(-5px)}
	100% 				{transform: translateY(0px)}
`;
var flap = keyframes3`
	0% 					{transform: translateY(0px)}
	80%		 			{transform: translateY(0px)}
	90% 				{transform: translateY(4px)}
	100% 				{transform: translateY(0px)}
`;
var Container = styled10.div`
  position: relative;
  z-index: 0;
`;
var Warren = styled10("div")`
  width: ${({ loaderWidth }) => loaderWidth ? loaderWidth : 100}px;
  position: relative;
  margin: 0 auto;
  &:after {
    background: rgba(0, 0, 0, 0.2);
    display: block;
    position: absolute;
    content: '';
    width: 88%;
    padding-bottom: 88%;
    border-radius: 100%;
    bottom: 0;
    left: 50%;
    margin-left: -44%;
  }
  .logo {
    width: 100%;
    display: block;
    position: relative;
    z-index: 1;
  }
  .eye {
    animation: 1s linear infinite alternate ${blink};
  }
  .nose {
    animation: 1s linear infinite alternate ${sniff};
  }
  .ear {
    animation: 1s linear infinite alternate ${flap};
  }
`;

// src/components/LoadingWarren/LoadingWarren.tsx
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var LoadingWarren = ({ width = 100 }) => /* @__PURE__ */ jsxs4(Container, { children: [
  /* @__PURE__ */ jsx8(Warren, { loaderWidth: width, children: /* @__PURE__ */ jsxs4(
    "svg",
    {
      className: "logo",
      viewBox: "0 0 480 490",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx8("rect", { fill: "#CCCCCC", x: "145", y: "335", width: "190", height: "79" }),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M240,490 C139.815569,490 56.0108318,419.893841 35,326.08049 L35.0000015,326 L144.96684,255 L240,459 L240,490 Z",
            fill: "#1f2b36"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M445,490 C344.815569,490 261.010832,419.893841 240,326.08049 L240.000002,326 L349.96684,255 L445,459 L445,490 Z",
            fill: "#1f2a35",
            transform: "translate(342.500000, 372.500000) scale(-1, 1) translate(-342.500000, -372.500000) "
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            fill: "#CC3300",
            points: "215.33667 406 240 459 240 335 218 356 234.095032 372.095695"
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            fill: "#A32900",
            transform: "translate(252.331665, 397.000000) scale(-1, 1) translate(-252.331665, -397.000000) ",
            points: "240 406 264.66333 459 264.66333 335 242.66333 356 258.758362 372.095695"
          }
        ),
        /* @__PURE__ */ jsx8("polygon", { fill: "#FFCC00", points: "207 401 252 401 252 410 207 410" }),
        /* @__PURE__ */ jsx8("polygon", { fill: "#FFFFFF", points: "145 255 200 374 240 335" }),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            fill: "#FFFFFF",
            transform: "translate(287.500000, 314.500000) scale(-1, 1) translate(-287.500000, -314.500000) ",
            points: "240 255 295 374 335 335"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            className: "ear",
            d: "M153.361374,22.1564262 L196.220104,63.0538465 C202.233881,68.7894912 202.462316,78.4086979 196.731243,84.4298614 L155.876685,127.330967 C150.145612,133.349604 140.53619,133.580799 134.522413,127.842627 L91.6649445,86.9464702 C85.6524296,81.2095622 85.4202082,71.5903556 91.1525429,65.5704554 L132.008364,22.6680861 C137.738174,16.6507127 147.348859,16.4195182 153.361374,22.1564262 Z M327.637221,22.1564262 C333.650998,16.4195182 343.261682,16.6507127 348.992755,22.6680861 L389.847314,65.5704554 C395.579649,71.5903556 395.347427,81.2095622 389.336174,86.9464702 L346.477444,127.842627 C340.463667,133.580799 330.855507,133.349604 325.123172,127.330967 L284.267351,84.4298614 C278.537541,78.4086979 278.765976,68.7894912 284.778491,63.0538465 L327.637221,22.1564262 Z",
            fill: "#2E7091"
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            className: "ear",
            fill: "#CCCCCC",
            points: "143.555706 36 105 76.4449398 145.445556 115 184 74.5550602"
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            className: "ear",
            fill: "#CCCCCC",
            points: "338.446202 36 298 74.5550602 336.553798 115 377 76.4449398"
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            className: "ear",
            fill: "#FFFFFF",
            points: "108 79.7731152 144.949473 115 180 78.2268848 143.049258 43"
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            className: "ear",
            fill: "#FFFFFF",
            points: "338.952012 43 302 78.2268848 337.047988 115 374 79.7731152"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M50,175 C107.905087,101.247796 136.858262,64.9996231 136.858262,64.9996231 C157.53134,40.8836231 191.790196,34 240,34 C288.211067,34 322.469924,40.8836231 343.143002,64.9996231 C343.143002,64.9996231 372.096177,101.247796 430,175 C176.666667,174.951927 50,174.951927 50,175 Z",
            fill: "#3885B0"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M50,175 C107.905087,101.247796 136.858262,64.9996231 136.858262,64.9996231 C157.53134,40.8836231 191.790196,34 240,34 C288.211067,34 322.469924,40.8836231 343.143002,64.9996231 C343.143002,64.9996231 372.096177,101.247796 430,175 C176.666667,174.951927 50,174.951927 50,175 Z",
            fill: "#3885B0"
          }
        ),
        /* @__PURE__ */ jsx8("polygon", { fill: "#2E7091", points: "50 175 240 335 430 175" }),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M325,197.093688 C293.16113,136.575275 277.241695,106.317965 277.241695,106.317965 C269.370786,92.1347714 257.124188,92.8590357 240.500634,93.0827613 C223.878349,92.8590357 211.630483,92.1347714 203.760842,106.317965 C203.760842,106.317965 187.840138,136.575275 156,197.093688 C187.840138,233.697475 203.760842,252 203.760842,252 L277.241695,252 C277.241695,252 293.16113,233.697475 325,197.093688 C293.995924,225.730567 252.263864,224.970911 240.500634,192.17678 C228.738674,224.970911 187.005345,225.730567 156,197.093688 C187.840138,233.698739 203.760842,252 203.760842,252 L277.241695,252 C277.241695,252 293.16113,233.698739 325,197.093688 Z",
            fill: "#FFFFFF"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M277.241695,252 L203.760842,252 C203.760842,252 187.840138,233.644658 156,196.931437 C187.005345,225.65294 228.738674,224.891039 240.500634,192 C252.263864,224.891039 293.995924,225.65294 325,196.931437 C293.16113,233.644658 277.241695,252 277.241695,252 Z",
            fill: "#CCCCCC"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            className: "nose",
            d: "M182,147.570763 C222.854387,133.476412 256.144357,133.476412 297,147.570763 C279.672936,168.5466 260.508154,183.689679 239.499372,193 C218.493102,183.689679 199.324551,168.5466 182,147.570763 Z",
            fill: "#1A1A1A"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            className: "nose",
            d: "M204,146.851558 C229.931226,139.049481 251.06624,139.049481 277,146.851558 C266.001024,158.462161 253.833724,166.844147 240.499366,172 C227.163742,166.844147 214.997709,158.462161 204,146.851558 Z",
            fill: "#4D4D4D"
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            fill: "#0d161d",
            points: "126 267.260864 145 255 240 459 129 348 152 334 120 320"
          }
        ),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            fill: "#0d161d",
            transform: "translate(300.000000, 357.000000) scale(-1, 1) translate(-300.000000, -357.000000) ",
            points: "246 267.260864 265 255 360 459 249 348 272 334 240 320"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M240,468 C244.971277,468 249,472.030345 249,477.000663 C249,481.97098 244.971277,486 240,486",
            fill: "#808080"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            d: "M231,468 C235.971277,468 240,472.030345 240,477.000663 C240,481.97098 235.971277,486 231,486",
            fill: "#B3B3B3",
            transform: "translate(235.500000, 477.000000) scale(-1, 1) translate(-235.500000, -477.000000) "
          }
        ),
        /* @__PURE__ */ jsx8("polygon", { fill: "#4D4D4D", points: "307 415 380 415 380 425 307 425" }),
        /* @__PURE__ */ jsx8(
          "polygon",
          {
            fill: "#FFFFFF",
            points: "307 414 336.785868 385 353.67805 401.445258 360.391544 394.908892 380 414"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            className: "eye",
            d: "M165.261393,121.363393 C173.509479,121.0088 180.753153,127.584324 183.415542,136 C190.03225,81.4001319 138.524775,79.1257595 127,114.960811 C136.71354,120.769916 147.162974,122.14101 165.261393,121.363393 Z",
            fill: "#1A1A1A"
          }
        ),
        /* @__PURE__ */ jsx8(
          "path",
          {
            className: "eye",
            d: "M316.737476,121.363393 C334.835831,122.14101 345.285228,120.769916 355,114.960811 C343.475265,79.1257595 291.966706,81.4001319 298.584657,136 C301.244503,127.584324 308.489418,121.0088 316.737476,121.363393 Z",
            fill: "#1A1A1A"
          }
        )
      ]
    }
  ) }),
  /* @__PURE__ */ jsx8(LoadingSpinner, { left: "50%", bottom: "-16px", styleType: "light" })
] });
var LoadingWarren_default = LoadingWarren;

// src/components/Modal/components/Content/Content.tsx
import { jsx as jsx9, jsxs as jsxs5 } from "react/jsx-runtime";
function Content({
  title,
  asForm,
  isNaked,
  disabled: disabled4,
  children,
  isLoading,
  scrollable,
  secondaryLabel,
  blurTargetId,
  primaryLabel,
  hideClose,
  fullscreen,
  hideHeader,
  hideFooter,
  primaryLoading,
  secondaryLoading,
  primaryDisabled,
  secondaryDisabled,
  onClose,
  onPrimaryClick,
  onSecondaryClick,
  onTamper,
  "data-cy-id": dataCyId = "modal-content"
}) {
  const handleClose = useCallback2(() => {
    if (typeof onClose === "function") {
      onClose();
    }
  }, [onClose]);
  const handleSecondaryClick = useCallback2(() => {
    if (typeof onSecondaryClick === "function") {
      onSecondaryClick();
    }
  }, [onSecondaryClick]);
  const handlePrimaryClick = useCallback2(
    (e) => {
      asForm && e.preventDefault();
      if (typeof onPrimaryClick === "function") {
        onPrimaryClick(e);
      }
    },
    [asForm, onPrimaryClick]
  );
  const tamperedRef = useRef2(false);
  useEffect3(() => {
    if (typeof blurTargetId === "undefined")
      return;
    if (tamperedRef.current)
      return;
    const intervalObj = setInterval(() => {
      const blurTargetElement = document.getElementById(blurTargetId);
      if (blurTargetElement) {
        const rootStyle = getComputedStyle(blurTargetElement);
        const filterStyle = rootStyle.getPropertyValue("filter");
        if (filterStyle !== "blur(6px)") {
          clearInterval(intervalObj);
          if (typeof onTamper === "function") {
            onTamper();
            tamperedRef.current = true;
          }
        }
      } else {
        if (typeof onTamper === "function") {
          onTamper();
          tamperedRef.current = true;
        }
      }
    }, 2500);
    return () => clearInterval(intervalObj);
  }, [blurTargetId, onTamper]);
  return /* @__PURE__ */ jsxs5(
    Wrapper3,
    {
      "data-cy-id": dataCyId,
      justifyContent: "center",
      fullscreen,
      isLoading,
      scrollable: isNaked,
      dropOpacity: blurTargetId && blurTargetId.length > 0 || false,
      width: "100%",
      children: [
        isLoading ? /* @__PURE__ */ jsx9(Column_default, { alignSelf: "center", children: /* @__PURE__ */ jsx9(LoadingWarren_default, { width: 80 }) }) : isNaked ? children : /* @__PURE__ */ jsxs5(
          Column_default,
          {
            maxWidth: "700px",
            alignSelfLg: "center",
            as: asForm ? "form" : "section",
            onSubmit: asForm ? (
              // Cast is here as types have changed in react 18, but wished to limit impact of type change
              handlePrimaryClick
            ) : void 0,
            children: [
              hideHeader === false && /* @__PURE__ */ jsx9(
                Header_default,
                {
                  title,
                  disabled: disabled4,
                  hideClose,
                  onClose: handleClose
                }
              ),
              /* @__PURE__ */ jsx9(Body, { scrollable, "data-cy-id": "modal-body", children }),
              hideFooter === false && /* @__PURE__ */ jsx9(
                Footer_default,
                {
                  confirmWithSubmit: asForm,
                  disabled: disabled4,
                  secondaryLabel,
                  primaryLabel,
                  onPrimaryClick: handlePrimaryClick,
                  onSecondaryClick: handleSecondaryClick,
                  primaryLoading,
                  secondaryLoading,
                  primaryDisabled,
                  secondaryDisabled
                }
              )
            ]
          }
        ),
        blurTargetId && blurTargetId.length > 0 && /* @__PURE__ */ jsx9(BlurFilter, { filterId: blurTargetId })
      ]
    }
  );
}
var Content_default = Content;

// src/components/Modal/components/Portal/Portal.tsx
import { jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var PreventWindowScroll = () => {
  usePreventWindowScroll();
  return null;
};
var Portal = ({
  children,
  asForm,
  isServer,
  removeWindowScroll,
  title,
  isNaked,
  scrollable,
  disabled: disabled4,
  isLoading,
  fullscreen,
  blurTargetId,
  secondaryLabel,
  primaryLabel,
  hideClose,
  primaryLoading,
  secondaryLoading,
  primaryDisabled,
  secondaryDisabled,
  hideHeader,
  hideFooter,
  onTamper,
  onClose,
  onPrimaryClick,
  onSecondaryClick,
  "data-cy-id": dataCyId
}) => {
  const [container, setContainer] = useState(null);
  const handleKeyUp = useCallback3(
    (e) => {
      switch (e.key) {
        case "Enter":
          if (!asForm) {
            onPrimaryClick && onPrimaryClick(e);
          }
          break;
        case "Escape":
          onClose && onClose();
          break;
        default:
          break;
      }
    },
    [onPrimaryClick, onClose, asForm]
  );
  useEffect4(() => {
    document.addEventListener("keyup", handleKeyUp);
    return () => {
      document.removeEventListener("keyup", handleKeyUp);
    };
  }, [handleKeyUp]);
  useEffect4(() => {
    const modalContainer = document.createElement("div");
    modalContainer.setAttribute("id", "modal-container");
    document.body.appendChild(modalContainer);
    setContainer(modalContainer);
    return () => {
      if (modalContainer !== null && document.body && typeof document.body.contains === "function" && document.body.contains(modalContainer)) {
        try {
          document.body.removeChild(modalContainer);
        } catch (error) {
          console.log(error);
        }
      }
    };
  }, []);
  if (isServer && typeof document === "undefined")
    return null;
  if (container === null)
    return null;
  return createPortal(
    /* @__PURE__ */ jsxs6(
      Content_default,
      {
        "data-cy-id": dataCyId,
        title,
        asForm,
        isNaked,
        scrollable,
        disabled: disabled4,
        isLoading,
        fullscreen,
        blurTargetId,
        secondaryLabel,
        primaryLabel,
        onClose,
        onPrimaryClick,
        onSecondaryClick,
        hideClose,
        primaryLoading,
        secondaryLoading,
        primaryDisabled,
        secondaryDisabled,
        hideHeader,
        hideFooter,
        onTamper,
        children: [
          removeWindowScroll && /* @__PURE__ */ jsx10(PreventWindowScroll, {}),
          children
        ]
      }
    ),
    container
  );
};
var Portal_default = Portal;

// src/components/Modal/components/Portal/index.ts
var Portal_default2 = Portal_default;

// src/components/Modal/components/Modal/Modal.tsx
import { jsx as jsx11 } from "react/jsx-runtime";
var Modal = ({
  title = "",
  isServer = false,
  blurTargetId,
  asForm = false,
  isNaked = false,
  disabled: disabled4 = false,
  children = null,
  isLoading = false,
  scrollable = true,
  secondaryLabel,
  primaryLabel,
  hideClose = false,
  hideHeader = false,
  hideFooter = false,
  fullscreen = false,
  removeWindowScroll = true,
  primaryLoading = false,
  secondaryLoading = false,
  primaryDisabled = false,
  secondaryDisabled = false,
  onTamper,
  onClose,
  onSecondaryClick,
  onPrimaryClick,
  "data-cy-id": dataCyId
}) => {
  const handleClose = useCallback4(() => {
    if (onClose && typeof onClose === "function") {
      onClose();
    } else if (onSecondaryClick && typeof onSecondaryClick === "function") {
      onSecondaryClick();
    } else {
      console.log("Please set a close action or secondary action");
    }
  }, []);
  return /* @__PURE__ */ jsx11(
    Portal_default2,
    {
      "data-cy-id": dataCyId,
      isServer,
      asForm,
      title,
      isNaked,
      scrollable,
      disabled: disabled4,
      isLoading,
      fullscreen,
      blurTargetId,
      secondaryLabel,
      primaryLabel,
      hideClose,
      primaryLoading,
      secondaryLoading,
      primaryDisabled,
      secondaryDisabled,
      hideHeader,
      hideFooter,
      removeWindowScroll,
      onClose: handleClose,
      onPrimaryClick: onPrimaryClick || handleClose,
      onSecondaryClick: onSecondaryClick || handleClose,
      onTamper,
      children
    }
  );
};
var Modal_default = Modal;

// src/components/ButtonWithDropdown/ButtonWithDropdown.tsx
import {
  isValidElement,
  cloneElement,
  useState as useState2,
  useEffect as useEffect5,
  useRef as useRef3,
  useCallback as useCallback5
} from "react";

// src/components/ButtonWithDropdown/styled.ts
import styled11, { css as css16 } from "styled-components";
var ButtonWrapper = styled11("div")`
  display: inline-block;
  width: auto;
  position: relative;
`;
var DropdownWrapper = styled11("div")`
  position: absolute;
  width: 100%;
  ${({ dropUp }) => dropUp && css16`
      top: 0;
    `};
`;
var Dropdown = styled11("div")`
  position: absolute;
  z-index: 1;
  ${({ dropUp, marginTop, marginBottom, theme: theme2 }) => {
  if (dropUp) {
    return css16`
        bottom: ${marginTop ? 0 : theme2.x1spacePx / 2}px;
      `;
  }
  return css16`
      top: ${marginBottom ? 0 : theme2.x1spacePx / 2}px;
    `;
}};
  ${({ floatLeft, marginLeft, marginRight, theme: theme2 }) => floatLeft ? css16`
          left: ${marginLeft ? theme2.x1spacePx / 2 : 0}px;
        ` : css16`
          right: ${marginRight ? theme2.x1spacePx / 2 : 0}px;
        `};
  background: white;
  border: 1px solid ${({ theme: theme2 }) => theme2.color.whiteRGBA(0.5)};
  padding: ${({ theme: theme2 }) => theme2.x1spacePx}px 0;
  border-radius: 4px;
  > hr {
    margin: 8px 0;
    border-top: 1px solid ${({ theme: theme2 }) => theme2.color.lightGray};
  }
  display: inline-block;
  width: auto;
`;
var DropdownButton = styled11("button")`
  ${({ theme: theme2 }) => theme2.typography.xSmall};
  color: ${({ theme: theme2 }) => theme2.color.black};
  display: flex;
  align-items: center;
  white-space: nowrap;
  user-select: none;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  transition: background 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  padding: ${({ theme: theme2 }) => theme2.x1spacePx}px
    ${({ theme: theme2 }) => theme2.x2spacePx}px;
  ${({ theme: theme2 }) => media_default.mdUp`
    &:hover {
      background: ${theme2.color.brand01};
      color: ${theme2.color.white};
      > svg {
        fill: ${theme2.color.white};
      }
    }
  `}

  > svg {
    opacity: 0.5;
    margin-left: -4px;
    height: 24px;
    width: 24px;
    padding-right: ${({ theme: theme2 }) => theme2.x4space}px;
    fill: ${({ theme: theme2 }) => theme2.color.black};
    transition: fill 0.2s cubic-bezier(0.23, 1, 0.32, 1);
  }
`;

// src/components/ButtonWithDropdown/DropdownMenu.tsx
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
var DropdownMenu = ({
  options,
  dropUp,
  secondaryOptions,
  floatLeft,
  marginTop,
  marginLeft,
  marginRight,
  marginBottom
}) => {
  return /* @__PURE__ */ jsx12(DropdownWrapper, { dropUp, children: /* @__PURE__ */ jsxs7(
    Dropdown,
    {
      floatLeft,
      dropUp,
      marginTop,
      marginLeft,
      marginRight,
      marginBottom,
      children: [
        options.map((DropDownButton) => DropDownButton),
        secondaryOptions && secondaryOptions.length > 0 && /* @__PURE__ */ jsx12("hr", {}),
        secondaryOptions && secondaryOptions.length && secondaryOptions.map((DropDownButton) => DropDownButton)
      ]
    }
  ) });
};
var DropdownMenu_default = DropdownMenu;

// src/components/ButtonWithDropdown/ButtonWithDropdown.tsx
import { jsx as jsx13, jsxs as jsxs8 } from "react/jsx-runtime";
function isOptionItem(option) {
  return isValidElement(option);
}
var getDropDownButton = (onSelect, onTouchSelect, onBlur, onFocus, styleType, options) => {
  return options.map((option, i) => {
    if (isOptionItem(option)) {
      const childProps = {
        onTouchEnd: onTouchSelect,
        onBlur,
        onFocus,
        onSelect,
        styleType,
        key: `DropdownButton-${i}`
      };
      return cloneElement(option, childProps);
    } else {
      return /* @__PURE__ */ jsxs8(
        DropdownButton,
        {
          as: "a",
          tabIndex: -1,
          styleType,
          "data-cy-id": `dropdown-button-${i}`,
          onBlur,
          onFocus,
          onClick: () => {
            onSelect?.(option.value, option.label);
          },
          onTouchEnd: (e) => {
            e.preventDefault();
            onTouchSelect(
              e.changedTouches[0].pageY,
              option.value,
              option.label
            );
          },
          children: [
            option.icon,
            option.label
          ]
        },
        `DropdownButton-${i}`
      );
    }
  });
};
var ButtonWithDropdown = ({
  children,
  options,
  dropUp,
  styleType,
  secondaryOptions,
  headerText,
  floatLeft,
  marginTop,
  marginLeft,
  marginRight,
  marginBottom,
  alignIcon,
  onSelect,
  onClick,
  as,
  ...props
}) => {
  const [isActive, setIsActive] = useState2(false);
  const ref = useRef3(null);
  const startYRef = useRef3(0);
  let queue = 0;
  const handleTouchStart = useCallback5((e) => {
    const touch = e.changedTouches[0];
    startYRef.current = touch.pageY;
  }, []);
  const handleTouchEnd = useCallback5(
    (e) => {
      const { current } = ref;
      const touch = e.changedTouches[0];
      if (isActive && current && Math.abs(touch.pageY - startYRef.current) < 1) {
        current.blur();
      }
    },
    [isActive]
  );
  const handleKeyUp = (e) => {
    const { current } = ref;
    switch (e.keyCode) {
      case 27:
        if (current) {
          current.blur();
        }
        break;
      default:
        break;
    }
  };
  useEffect5(() => {
    document.addEventListener("keyup", handleKeyUp);
    document.addEventListener("touchstart", handleTouchStart);
    document.addEventListener("touchend", handleTouchEnd);
    return () => {
      document.removeEventListener("keyup", handleKeyUp);
      document.removeEventListener("touchstart", handleTouchStart);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [handleTouchStart, handleTouchEnd]);
  const handleClick = (e) => {
    onClick && onClick();
    e.stopPropagation();
    e.preventDefault();
    const { current } = ref;
    if (current) {
      if (!isActive && document.activeElement !== current) {
        current.focus();
      }
    }
  };
  const handleSelect = (value, label) => {
    setIsActive(false);
    onSelect?.(value, label);
  };
  const handleTouchSelect = (yPos, value, label) => {
    if (Math.abs(yPos - startYRef.current) < 1) {
      handleSelect(value, label);
    }
  };
  const handleFocus = () => {
    window.clearTimeout(queue);
    setIsActive(true);
  };
  const handleBlur = () => {
    queue = window.setTimeout(() => {
      setIsActive(false);
    }, 0);
  };
  const shouldRenderDropdownMenu = isActive && (options.length > 0 || secondaryOptions && secondaryOptions.length > 0);
  return /* @__PURE__ */ jsxs8(ButtonWrapper, { ...props, children: [
    /* @__PURE__ */ jsx13(
      Button_default,
      {
        ref,
        "data-active": isActive,
        styleType,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        alignIcon,
        marginTop,
        marginLeft,
        marginRight,
        marginBottom,
        children
      }
    ),
    shouldRenderDropdownMenu && /* @__PURE__ */ jsx13(
      DropdownMenu_default,
      {
        options: getDropDownButton(
          handleSelect,
          handleTouchSelect,
          handleBlur,
          handleFocus,
          styleType,
          options
        ),
        secondaryOptions: secondaryOptions && getDropDownButton(
          handleSelect,
          handleTouchSelect,
          handleBlur,
          handleFocus,
          styleType,
          secondaryOptions
        ),
        headerText,
        styleType,
        dropUp,
        floatLeft,
        marginTop,
        marginLeft,
        marginRight,
        marginBottom,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onSelect: handleSelect,
        onTouchSelect: handleTouchSelect
      }
    )
  ] });
};

// src/components/Textfield/Textfield.tsx
import {
  forwardRef as forwardRef2,
  useId
} from "react";

// src/components/ValidationMessage/styled.ts
import styled12, { keyframes as keyframes4 } from "styled-components";
var reveal = keyframes4`
	from 				{opacity: 0;}
	to 					{opacity: 1;}
`;
var Wrapper4 = styled12("div")`
  animation: ${reveal} 0.2s linear forwards;
  position: relative;
  ${({ theme: theme2 }) => theme2.typography.tiny};
  color: ${({ type, theme: theme2 }) => theme2.color[type === "error" ? "bad" : "good"]};
  > span {
    display: inline-block;
    position: absolute;
    top: 2px;
    left: 0;
  }
`;

// src/components/ValidationMessage/ValidationMessage.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var ValidationMessage = ({ name, type, message }) => {
  return /* @__PURE__ */ jsx14(Wrapper4, { type, children: /* @__PURE__ */ jsx14("span", { "data-cy-id": name, "data-testid": "validation-message", children: message }) });
};
var ValidationMessage_default = ValidationMessage;

// src/components/Textfield/styled.ts
import styled13, { css as css17 } from "styled-components";
var placeHolder = css17`
  ${({ theme: theme2, styleType }) => {
  const color3 = styleType === "compactReverse" || styleType === "standardReverse" ? theme2.color.spaceGrayRGBA(0.3) : theme2.color.whiteRGBA(0.3);
  return `
      ::-webkit-input-placeholder {
        color: ${color3};
      }
      :-moz-placeholder {
        color: ${color3};
      }
      ::-moz-placeholder {
        color: ${color3};
      }
      :-ms-input-placeholder {
        color: ${color3};
      }
      ::-ms-input-placeholder {
        color: ${color3};
      }
    `;
}}
`;
var labelColor = css17`
  color: ${({ theme: theme2, styleType }) => {
  if (styleType === "compactReverse" || styleType === "standardReverse") {
    return theme2.color.spaceGray;
  }
  return theme2.color.white;
}};
`;
var getHeight = (theme2, styleType) => {
  if (styleType === "compactReverse" || styleType === "compact") {
    return theme2.x4spacePx;
  }
  return theme2.x5spacePx;
};
var height2 = css17`
  height: ${({ theme: theme2, styleType }) => getHeight(theme2, styleType)}px;
`;
var getColor2 = (theme2, styleType) => {
  if (styleType === "compactReverse" || styleType === "standardReverse") {
    return theme2.color.spaceGray;
  }
  return theme2.color.white;
};
var color2 = css17`
  --textfield-addon-color: ${({ theme: theme2, styleType }) => getColor2(theme2, styleType)};
  color: var(--textfield-addon-color);
`;
var SVGfill = css17`
  fill: var(--textfield-addon-color);
`;
var background = css17`
  background: ${({ theme: theme2, styleType }) => {
  if (styleType === "compactReverse" || styleType === "standardReverse") {
    return theme2.color.spaceGrayRGBA(0.05);
  }
  return theme2.color.whiteRGBA(0.05);
}};
`;
var border = css17`
  border: ${({ theme: theme2, styleType, error }) => {
  if (error) {
    return `2px solid ${theme2.color.bad}`;
  }
  if (styleType === "compactReverse" || styleType === "standardReverse") {
    return `1px solid ${theme2.color.spaceGrayRGBA(0.2)}`;
  }
  return `1px solid ${theme2.color.whiteRGBA(0.2)}`;
}};
`;
var Wrapper5 = styled13("fieldset")`
  margin: 0;
  position: relative;
  padding-top: ${({ label, hiddenLabel, theme: theme2 }) => label && !hiddenLabel ? theme2.x3spacePx : 0}px;

  > label {
    display: block;
    opacity: 0.7;
    ${labelColor}
  }

  &:focus-within {
    > label {
      opacity: 1;
    }
  }
`;
var Addon = styled13("span")`
  ${({ theme: theme2 }) => theme2.typography.xSmall}
  ${color2}
  padding: 0 ${({ theme: theme2 }) => theme2.x1_5}px;
  display: flex;
  align-items: center;

  > svg {
    height: 100%;
    * {
      ${SVGfill}
    }
  }
`;
var InputGroup = styled13("div")`
  position: relative;
  display: grid;
  align-items: center;
  ${border}
  ${background}
  margin: ${({ error }) => error ? "0" : "1px"};
  transition:
    border,
    background-color,
    opacity 0.2s;
  border-radius: 4px;
  grid-template-columns: 1fr;

  &:has(${Addon} + input) {
    grid-template-columns: auto 1fr;
    > input {
      padding-left: 0;
    }
  }

  &:has(input + ${Addon}) {
    grid-template-columns: 1fr auto;
    > input {
      padding-right: 0;
    }
  }

  &:has(${Addon} + input + ${Addon}) {
    grid-template-columns: auto 1fr auto;
    > input {
      padding-left: 0;
      padding-right: 0;
    }
  }

  opacity: 0.7;
  &:has(input:disabled) {
    opacity: 0.3;
  }

  body:not(.using-mouse) &:has(:focus-visible) {
    outline: 1px dashed ${({ theme: theme2 }) => theme2.color.brand01};
    outline-offset: 3px;
  }

  &:focus-within {
    background: ${({ theme: theme2 }) => theme2.color.brand01RGBA(0.05)};
    opacity: 1;
  }
`;
var Label = styled13("label")`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  margin-bottom: 0;
  transition: opacity 0.3s;
  ${({ hiddenLabel }) => hiddenLabel && VisuallyHidden}
  ${({ theme: theme2 }) => theme2.typography.xSmall}
`;
var Input = styled13("input")`
  width: 100%;
  background-color: transparent;
  padding: 14px 12px;

  ${({ theme: theme2 }) => theme2.typography.xSmall}

  ${height2}
  line-height: normal;
  ${color2}

  caret-color: ${({ theme: theme2 }) => theme2.color.brand01};

  &[type='search'] {
    &::-webkit-search-decoration,
    &::-webkit-search-cancel-button,
    &::-webkit-search-results-button,
    &::-webkit-search-results-decoration {
      display: none;
    }
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 5000s ease-in-out 0s;
    ${({ theme: theme2 }) => theme2.typography.xSmall}
    -webkit-text-fill-color: ${({ theme: theme2, styleType }) => getColor2(theme2, styleType)};
  }

  ${placeHolder}
`;

// src/components/Textfield/Textfield.tsx
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var Textfield = forwardRef2(function InputComponent({
  id,
  styleType,
  autoComplete,
  autoFocus,
  disabled: disabled4,
  error,
  label,
  hiddenLabel,
  maxLength,
  minLength,
  name,
  onBlur,
  onChange,
  onClick,
  onFocus,
  onKeyDown,
  onKeyPress,
  placeholder,
  prefix,
  postfix,
  readOnly,
  success,
  tabIndex,
  type,
  value,
  defaultValue,
  inputMode,
  pattern,
  ...inputProps
}, ref) {
  const internalId = useId();
  const targetId = id || internalId;
  return /* @__PURE__ */ jsxs9(Wrapper5, { styleType, label, hiddenLabel, children: [
    label && /* @__PURE__ */ jsx15(Label, { htmlFor: targetId, hiddenLabel, children: label }),
    /* @__PURE__ */ jsxs9(InputGroup, { styleType, error, children: [
      prefix && /* @__PURE__ */ jsx15(Addon, { "data-testid": "prefix", styleType, children: prefix }),
      /* @__PURE__ */ jsx15(
        Input,
        {
          ...inputProps,
          id: targetId,
          autoComplete,
          type,
          name,
          styleType,
          maxLength,
          minLength,
          autoFocus,
          error,
          tabIndex,
          ref,
          placeholder,
          onChange,
          onClick,
          onBlur,
          onFocus,
          value,
          defaultValue,
          disabled: disabled4,
          readOnly,
          onKeyPress,
          onKeyDown,
          "data-cy-id": name,
          inputMode,
          pattern
        }
      ),
      postfix && /* @__PURE__ */ jsx15(Addon, { "data-testid": "postfix", styleType, children: postfix })
    ] }),
    success && /* @__PURE__ */ jsx15(
      ValidationMessage_default,
      {
        type: "success",
        name: `${name}-invalid-message`,
        message: success
      }
    ),
    error && /* @__PURE__ */ jsx15(
      ValidationMessage_default,
      {
        type: "error",
        name: `${name}-invalid-message`,
        message: error
      }
    )
  ] });
});
var Textfield_default = Textfield;

// src/components/Tab/styled.ts
import styled14, { css as css18 } from "styled-components";
var disabled2 = css18`
  cursor: auto;
`;
var hover2 = css18`
  background: ${({ theme: theme2, styleType }) => {
  if (styleType === "subnav")
    return "transparent;";
  return `${theme2.color.whiteRGBA(0.1)};`;
}};
`;
var select = css18`
  color: ${({ theme: theme2 }) => theme2.color.white};
  ${({ theme: theme2, styleType }) => {
  if (styleType === "period") {
    return css18`
        background-color: ${theme2.color.blackRGBA(0.3)};
      `;
  }
  if (styleType === "subnav") {
    return css18`
        box-shadow: 0px -${theme2.x1spacePx / 2}px 0px 0px inset ${theme2.color.brand01};
      `;
  }
  return css18`
      border-color: ${theme2.color.whiteRGBA(0.1)};
    `;
}}
`;
var padding2 = css18`
  padding: ${({ theme: theme2, styleType }) => {
  if (styleType === "period") {
    return `${theme2.x1spacePx / 2}px ${theme2.x1spacePx / 2}px;`;
  }
  if (styleType === "subnav") {
    return `0px ${theme2.x2spacePx}px ${theme2.x1spacePx / 2}px;`;
  }
  return `${theme2.x1spacePx}px ${theme2.x2spacePx}px;`;
}};
`;
var border2 = css18`
  ${({ styleType }) => {
  if (styleType === "subnav") {
    return css18`
        border: none;
      `;
  }
  return css18`
      border-top: 1px solid transparent;
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
    `;
}};
`;
var height3 = css18`
  height: ${({ theme: theme2, styleType }) => {
  if (styleType === "subnav") {
    return `${theme2.x6spacePx}px;`;
  }
  return "auto;";
}};
`;
var typography = css18`
  ${({ theme: theme2, styleType }) => {
  if (styleType === "subnav") {
    return theme2.typography.xSmall;
  }
  return theme2.typography.xSmallStrong;
}}
`;
var tabCSS = css18`
  position: relative;
  display: block;
  width: 100%;
  ${height3}
  ${border2}
  ${padding2}
  ${typography}
  color: ${({ styleType, theme: theme2 }) => theme2.color.whiteRGBA(styleType === "period" ? 0.3 : 0.5)};
  ${({ selected }) => selected && select};
  ${({ styleType, theme: theme2 }) => styleType === "period" && `border-radius: ${theme2.x1spacePx / 2}px;`}
  &:disabled {
    ${disabled2}
  }
  ${media_default.lgUp`
    &:hover:not(:disabled) {
      ${hover2}
    }
  `}
`;
var StyledTab = styled14("button")`
  ${tabCSS}
`;

// src/components/Tab/Tab.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var Tab = ({
  value,
  selected,
  disabled: disabled4,
  hasPanel = true,
  styleType = "default",
  ...props
}) => /* @__PURE__ */ jsx16(
  StyledTab,
  {
    role: "tab",
    value,
    id: `${value}-tab`,
    styleType,
    selected,
    "aria-selected": Boolean(selected),
    "aria-controls": hasPanel ? `${value}-panel` : void 0,
    disabled: disabled4 ?? selected,
    ...props
  }
);
var Tab_default = Tab;

// src/components/Grid/DeprecatedGrid.ts
import styled16, { css as css21 } from "styled-components";

// src/components/Box/styled.ts
import styled15, { css as css20 } from "styled-components";

// src/components/Box/boxShadow.ts
import { css as css19 } from "styled-components";
var inset = {
  subtleBorder: {
    thickness: 1,
    blur: 0,
    opacity: 0.05
  },
  strongBorder: {
    thickness: 1,
    blur: 0,
    opacity: 0.2
  }
};
var outset = {
  softShadow: {
    thickness: 4,
    blur: 25,
    opacity: 0.2
  },
  diffuseShadow: {
    thickness: 4,
    blur: 20,
    opacity: 0.25
  },
  crispShadow: {
    thickness: 4,
    blur: 10,
    opacity: 0.3
  }
};
var insetShadow = (boxShadow2, thickness = 0, blur = 0) => {
  switch (boxShadow2) {
    case "boxShadow":
      return `0px 0px ${blur}px ${thickness}px inset`;
    case "boxShadowTop":
      return `0px ${thickness}px ${blur}px 0px inset`;
    case "boxShadowBottom":
      return `0px -${thickness}px ${blur}px 0px inset`;
    case "boxShadowLeft":
      return `${thickness}px 0px ${blur}px 0px inset`;
    case "boxShadowRight":
      return `-${thickness}px 0px ${blur}px 0px inset`;
  }
};
var outsetShadow = (boxShadow2, thickness = 0, blur = 0) => {
  switch (boxShadow2) {
    case "boxShadow":
      return `0px 0px ${blur}px ${thickness}px`;
    case "boxShadowTop":
      return `0px -${thickness}px ${blur}px 0px`;
    case "boxShadowBottom":
      return `0px ${thickness}px ${blur}px 0px`;
    case "boxShadowLeft":
      return `-${thickness}px 0px ${blur}px 0px`;
    case "boxShadowRight":
      return `${thickness}px 0px ${blur}px 0px`;
  }
};
var isInsetBoxShadow = (type) => {
  if (typeof inset[type] === "undefined")
    return false;
  return true;
};
var isOutsetBoxShadow = (type) => {
  if (typeof outset[type] === "undefined")
    return false;
  return true;
};
var getBoxShadow = (boxShadow2, color3) => {
  const props = Object.entries(boxShadow2).filter(
    ([_, value]) => Boolean(value)
  );
  const response = props.reduce((a, b) => {
    const boxShadowStyleType = b[1];
    if (isInsetBoxShadow(boxShadowStyleType)) {
      const styleType = inset[boxShadowStyleType];
      return [
        ...a,
        `${color3.whiteRGBA(styleType.opacity)} ${insetShadow(
          b[0],
          styleType.thickness,
          styleType.blur
        )}`
      ];
    }
    if (isOutsetBoxShadow(boxShadowStyleType)) {
      const styleType = outset[boxShadowStyleType];
      return [
        ...a,
        `${color3.blackRGBA(styleType.opacity)} ${outsetShadow(
          b[0],
          styleType.thickness,
          styleType.blur
        )}`
      ];
    }
    return a;
  }, []).join();
  return css19`
    box-shadow: ${response};
  `;
};

// src/components/Box/styled.ts
var getValue = (value) => typeof value === "string" ? value : `${value}px`;
var getPadding2 = (px) => css20`
  padding: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getPaddingX = (px) => css20`
  padding-left: ${({ theme: theme2 }) => theme2[px]}px;
  padding-right: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getPaddingY = (px) => css20`
  padding-top: ${({ theme: theme2 }) => theme2[px]}px;
  padding-bottom: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getPaddingTop = (px) => css20`
  padding-top: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getPaddingRight = (px) => css20`
  padding-right: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getPaddingBottom = (px) => css20`
  padding-bottom: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getPaddingLeft = (px) => css20`
  padding-left: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getMargin = (px) => css20`
  margin: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getMarginX = (px) => css20`
  margin-left: ${({ theme: theme2 }) => theme2[px]}px;
  margin-right: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getMarginY = (px) => css20`
  margin-top: ${({ theme: theme2 }) => theme2[px]}px;
  margin-bottom: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getMarginTop = (px) => css20`
  margin-top: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getMarginRight = (px) => css20`
  margin-right: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getMarginBottom = (px) => css20`
  margin-bottom: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getMarginLeft = (px) => css20`
  margin-left: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getBorderRadius = (px) => css20`
  border-radius: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getBorderTopRightRadius = (px) => css20`
  border-top-right-radius: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getBorderTopLeftRadius = (px) => css20`
  border-top-left-radius: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getBorderBottomRightRadius = (px) => css20`
  border-bottom-right-radius: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getBorderBottomLeftRadius = (px) => css20`
  border-bottom-left-radius: ${({ theme: theme2 }) => theme2[px]}px;
`;
var getDisplay = (display) => css20`
  display: ${display};
`;
var getPosition = (position) => css20`
  position: ${position};
`;
var getTop = (top) => css20`
  top: ${getValue(top)};
`;
var getRight = (right) => css20`
  right: ${getValue(right)};
`;
var getBottom = (bottom) => css20`
  bottom: ${getValue(bottom)};
`;
var getLeft = (left) => css20`
  left: ${getValue(left)};
`;
var getWidth2 = (width) => css20`
  width: ${getValue(width)};
`;
var getMaxWidth = (maxWidth) => css20`
  max-width: ${getValue(maxWidth)};
`;
var getMinWidth = (minWidth) => css20`
  min-width: ${getValue(minWidth)};
`;
var getHeight2 = (height4) => css20`
  height: ${getValue(height4)};
`;
var getMaxHeight = (maxHeight) => css20`
  max-height: ${getValue(maxHeight)};
`;
var getMinHeight = (minHeight) => css20`
  min-height: ${getValue(minHeight)};
`;
var getCursor = (cursor) => css20`
  cursor: ${cursor};
`;
var getZIndex = (zIndex) => css20`
  z-index: ${zIndex};
`;
var getUserSelect = (userSelect) => css20`
  user-select: ${userSelect};
`;
var getOverflow = (overflow) => css20`
  overflow: ${overflow};
`;
var getTransform = (transform) => css20`
  transform: ${transform};
`;
var getOpacity = (opacity) => css20`
  opacity: ${opacity};
`;
var getBackground = (backgroundColor3) => {
  if (backgroundColor3 === "transparent" || backgroundColor3 === "inherit") {
    return css20`
      background-color: ${backgroundColor3};
    `;
  }
  return css20`
    background-color: ${({ theme: theme2 }) => theme2.color[backgroundColor3]};
  `;
};
var StyledBoxCSS = css20`
  ${({ $display }) => $display && getDisplay($display)}
  ${({ position }) => position && getPosition(position)}
  ${({ top }) => top && getTop(top)}
  ${({ right }) => right && getRight(right)}
  ${({ bottom }) => bottom && getBottom(bottom)}
  ${({ left }) => left && getLeft(left)}
  ${({ $width }) => $width && getWidth2($width)}
  ${({ maxWidth }) => maxWidth && getMaxWidth(maxWidth)}
  ${({ minWidth }) => minWidth && getMinWidth(minWidth)}
  ${({ $height }) => $height && getHeight2($height)}
  ${({ maxHeight }) => maxHeight && getMaxHeight(maxHeight)}
  ${({ minHeight }) => minHeight && getMinHeight(minHeight)}
  ${({ $cursor }) => $cursor && getCursor($cursor)}
  ${({ zIndex }) => zIndex && getZIndex(zIndex)}
  ${({ userSelect }) => userSelect && getUserSelect(userSelect)}
  ${({ $overflow }) => $overflow && getOverflow($overflow)}
  ${({ $transform }) => $transform && getTransform($transform)}
  ${({ $opacity }) => $opacity && getOpacity($opacity)}
  ${({ backgroundColor: backgroundColor3 }) => backgroundColor3 && getBackground(backgroundColor3)}

  ${({ padding: padding3 }) => padding3 && getPadding2(padding3)};
  ${({ paddingX }) => paddingX && getPaddingX(paddingX)};
  ${({ paddingY }) => paddingY && getPaddingY(paddingY)};
  ${({ paddingTop }) => paddingTop && getPaddingTop(paddingTop)};
  ${({ paddingRight }) => paddingRight && getPaddingRight(paddingRight)};
  ${({ paddingBottom }) => paddingBottom && getPaddingBottom(paddingBottom)};
  ${({ paddingLeft }) => paddingLeft && getPaddingLeft(paddingLeft)};

  ${({ margin }) => margin && getMargin(margin)};
  ${({ marginX }) => marginX && getMarginX(marginX)};
  ${({ marginY }) => marginY && getMarginY(marginY)};
  ${({ marginTop }) => marginTop && getMarginTop(marginTop)};
  ${({ marginRight }) => marginRight && getMarginRight(marginRight)};
  ${({ marginBottom }) => marginBottom && getMarginBottom(marginBottom)};
  ${({ marginLeft }) => marginLeft && getMarginLeft(marginLeft)};

  ${({ borderRadius }) => borderRadius && getBorderRadius(borderRadius)};
  ${({ borderTopRightRadius }) => borderTopRightRadius && getBorderTopRightRadius(borderTopRightRadius)};
  ${({ borderTopLeftRadius }) => borderTopLeftRadius && getBorderTopLeftRadius(borderTopLeftRadius)};
  ${({ borderBottomRightRadius }) => borderBottomRightRadius && getBorderBottomRightRadius(borderBottomRightRadius)};
  ${({ borderBottomLeftRadius }) => borderBottomLeftRadius && getBorderBottomLeftRadius(borderBottomLeftRadius)};

  ${({
  boxShadow: boxShadow2,
  boxShadowBottom,
  boxShadowLeft,
  boxShadowRight,
  boxShadowTop,
  theme: theme2
}) => {
  if (boxShadow2 || boxShadowBottom || boxShadowLeft || boxShadowRight || boxShadowTop) {
    return getBoxShadow(
      {
        boxShadow: boxShadow2,
        boxShadowBottom,
        boxShadowLeft,
        boxShadowRight,
        boxShadowTop
      },
      theme2.color
    );
  }
}};
  /*
    media.smUp
  */
  ${({
  // Padding
  paddingSm,
  paddingXSm,
  paddingYSm,
  paddingTopSm,
  paddingRightSm,
  paddingBottomSm,
  paddingLeftSm,
  // Margin
  marginSm,
  marginXSm,
  marginYSm,
  marginTopSm,
  marginRightSm,
  marginBottomSm,
  marginLeftSm,
  // BorderRadius
  borderRadiusSm,
  borderTopLeftRadiusSm,
  borderTopRightRadiusSm,
  borderBottomLeftRadiusSm,
  borderBottomRightRadiusSm
}) => {
  if (
    // Padding
    paddingSm || paddingXSm || paddingYSm || paddingTopSm || paddingRightSm || paddingBottomSm || paddingLeftSm || // Margin
    marginSm || marginXSm || marginYSm || marginTopSm || marginRightSm || marginBottomSm || marginLeftSm || // BorderRadius
    borderRadiusSm || borderTopLeftRadiusSm || borderTopRightRadiusSm || borderBottomLeftRadiusSm || borderBottomRightRadiusSm
  ) {
    return media_default.smUp`
        ${paddingSm && getPadding2(paddingSm)};
        ${paddingXSm && getPaddingX(paddingXSm)};
        ${paddingYSm && getPaddingY(paddingYSm)};
        ${paddingTopSm && getPaddingTop(paddingTopSm)};
        ${paddingRightSm && getPaddingRight(paddingRightSm)};
        ${paddingBottomSm && getPaddingBottom(paddingBottomSm)};
        ${paddingLeftSm && getPaddingLeft(paddingLeftSm)};

        ${marginSm && getMargin(marginSm)};
        ${marginXSm && getMarginX(marginXSm)};
        ${marginYSm && getMarginY(marginYSm)};
        ${marginTopSm && getMarginTop(marginTopSm)};
        ${marginRightSm && getMarginRight(marginRightSm)};
        ${marginBottomSm && getMarginBottom(marginBottomSm)};
        ${marginLeftSm && getMarginLeft(marginLeftSm)};

        ${borderRadiusSm && getBorderRadius(borderRadiusSm)};
        ${borderTopRightRadiusSm && getBorderTopRightRadius(borderTopRightRadiusSm)};
        ${borderTopLeftRadiusSm && getBorderTopLeftRadius(borderTopLeftRadiusSm)};
        ${borderBottomRightRadiusSm && getBorderBottomRightRadius(borderBottomRightRadiusSm)};
        ${borderBottomLeftRadiusSm && getBorderBottomLeftRadius(borderBottomLeftRadiusSm)};
      `;
  }
}}
  /*
    media.mdUp
  */
  ${({
  // Padding
  paddingMd,
  paddingXMd,
  paddingYMd,
  paddingTopMd,
  paddingRightMd,
  paddingBottomMd,
  paddingLeftMd,
  // Margin
  marginMd,
  marginXMd,
  marginYMd,
  marginTopMd,
  marginRightMd,
  marginBottomMd,
  marginLeftMd,
  // BorderRadius
  borderRadiusMd,
  borderTopLeftRadiusMd,
  borderTopRightRadiusMd,
  borderBottomLeftRadiusMd,
  borderBottomRightRadiusMd
}) => {
  if (
    // Padding
    paddingMd || paddingXMd || paddingYMd || paddingTopMd || paddingRightMd || paddingBottomMd || paddingLeftMd || // Margin
    marginMd || marginXMd || marginYMd || marginTopMd || marginRightMd || marginBottomMd || marginLeftMd || // BorderRadius
    borderRadiusMd || borderTopLeftRadiusMd || borderTopRightRadiusMd || borderBottomLeftRadiusMd || borderBottomRightRadiusMd
  ) {
    return media_default.mdUp`
        ${paddingMd && getPadding2(paddingMd)};
        ${paddingXMd && getPaddingX(paddingXMd)};
        ${paddingYMd && getPaddingY(paddingYMd)};
        ${paddingTopMd && getPaddingTop(paddingTopMd)};
        ${paddingRightMd && getPaddingRight(paddingRightMd)};
        ${paddingBottomMd && getPaddingBottom(paddingBottomMd)};
        ${paddingLeftMd && getPaddingLeft(paddingLeftMd)};
        
        ${marginMd && getMargin(marginMd)}; 
        ${marginXMd && getMarginX(marginXMd)};
        ${marginYMd && getMarginY(marginYMd)};
        ${marginTopMd && getMarginTop(marginTopMd)};
        ${marginRightMd && getMarginRight(marginRightMd)};
        ${marginBottomMd && getMarginBottom(marginBottomMd)};
        ${marginLeftMd && getMarginLeft(marginLeftMd)};

        ${borderRadiusMd && getBorderRadius(borderRadiusMd)};
        ${borderTopRightRadiusMd && getBorderTopRightRadius(borderTopRightRadiusMd)};
        ${borderTopLeftRadiusMd && getBorderTopLeftRadius(borderTopLeftRadiusMd)};
        ${borderBottomRightRadiusMd && getBorderBottomRightRadius(borderBottomRightRadiusMd)};
        ${borderBottomLeftRadiusMd && getBorderBottomLeftRadius(borderBottomLeftRadiusMd)};
      `;
  }
}}
  /*
    media.lgUp
  */
  ${({
  // Padding
  paddingLg,
  paddingXLg,
  paddingYLg,
  paddingTopLg,
  paddingRightLg,
  paddingBottomLg,
  paddingLeftLg,
  // Margin
  marginLg,
  marginXLg,
  marginYLg,
  marginTopLg,
  marginRightLg,
  marginBottomLg,
  marginLeftLg,
  // BorderRadius
  borderRadiusLg,
  borderTopLeftRadiusLg,
  borderTopRightRadiusLg,
  borderBottomLeftRadiusLg,
  borderBottomRightRadiusLg
}) => {
  if (
    // Padding
    paddingLg || paddingXLg || paddingYLg || paddingTopLg || paddingRightLg || paddingBottomLg || paddingLeftLg || // Margin
    marginLg || marginXLg || marginYLg || marginTopLg || marginRightLg || marginBottomLg || marginLeftLg || // BorderRadius
    borderRadiusLg || borderTopLeftRadiusLg || borderTopRightRadiusLg || borderBottomLeftRadiusLg || borderBottomRightRadiusLg
  ) {
    return media_default.lgUp`
        ${paddingLg && getPadding2(paddingLg)};
        ${paddingXLg && getPaddingX(paddingXLg)};
        ${paddingYLg && getPaddingY(paddingYLg)};
        ${paddingTopLg && getPaddingTop(paddingTopLg)};
        ${paddingRightLg && getPaddingRight(paddingRightLg)};
        ${paddingBottomLg && getPaddingBottom(paddingBottomLg)};
        ${paddingLeftLg && getPaddingLeft(paddingLeftLg)};

        ${marginLg && getMargin(marginLg)};
        ${marginXLg && getMarginX(marginXLg)};
        ${marginYLg && getMarginY(marginYLg)};
        ${marginTopLg && getMarginTop(marginTopLg)};
        ${marginRightLg && getMarginRight(marginRightLg)};
        ${marginBottomLg && getMarginBottom(marginBottomLg)};
        ${marginLeftLg && getMarginLeft(marginLeftLg)};

        ${borderRadiusLg && getBorderRadius(borderRadiusLg)};
        ${borderTopRightRadiusLg && getBorderTopRightRadius(borderTopRightRadiusLg)};
        ${borderTopLeftRadiusLg && getBorderTopLeftRadius(borderTopLeftRadiusLg)};
        ${borderBottomRightRadiusLg && getBorderBottomRightRadius(borderBottomRightRadiusLg)};
        ${borderBottomLeftRadiusLg && getBorderBottomLeftRadius(borderBottomLeftRadiusLg)};
      `;
  }
}}
  /*
    media.xlUp
  */
  ${({
  // Padding
  paddingXl,
  paddingXXl,
  paddingYXl,
  paddingTopXl,
  paddingRightXl,
  paddingBottomXl,
  paddingLeftXl,
  // Margin
  marginXl,
  marginXXl,
  marginYXl,
  marginTopXl,
  marginRightXl,
  marginBottomXl,
  marginLeftXl,
  // BorderRadius
  borderRadiusXl,
  borderTopLeftRadiusXl,
  borderTopRightRadiusXl,
  borderBottomLeftRadiusXl,
  borderBottomRightRadiusXl
}) => {
  if (
    // Padding
    paddingXl || paddingXXl || paddingYXl || paddingTopXl || paddingRightXl || paddingBottomXl || paddingLeftXl || // Margin
    marginXl || marginXXl || marginYXl || marginTopXl || marginRightXl || marginBottomXl || marginLeftXl || // BorderRadius
    borderRadiusXl || borderTopLeftRadiusXl || borderTopRightRadiusXl || borderBottomLeftRadiusXl || borderBottomRightRadiusXl
  ) {
    return media_default.xlUp`
        ${paddingXl && getPadding2(paddingXl)};
        ${paddingXXl && getPaddingX(paddingXXl)};
        ${paddingYXl && getPaddingY(paddingYXl)};
        ${paddingTopXl && getPaddingTop(paddingTopXl)};
        ${paddingRightXl && getPaddingRight(paddingRightXl)};
        ${paddingBottomXl && getPaddingBottom(paddingBottomXl)};
        ${paddingLeftXl && getPaddingLeft(paddingLeftXl)};

        ${marginXl && getMargin(marginXl)};
        ${marginXXl && getMarginX(marginXXl)};
        ${marginYXl && getMarginY(marginYXl)};
        ${marginTopXl && getMarginTop(marginTopXl)};
        ${marginRightXl && getMarginRight(marginRightXl)};
        ${marginBottomXl && getMarginBottom(marginBottomXl)};
        ${marginLeftXl && getMarginLeft(marginLeftXl)};

        ${borderRadiusXl && getBorderRadius(borderRadiusXl)};
        ${borderTopRightRadiusXl && getBorderTopRightRadius(borderTopRightRadiusXl)};
        ${borderTopLeftRadiusXl && getBorderTopLeftRadius(borderTopLeftRadiusXl)};
        ${borderBottomRightRadiusXl && getBorderBottomRightRadius(borderBottomRightRadiusXl)};
        ${borderBottomLeftRadiusXl && getBorderBottomLeftRadius(borderBottomLeftRadiusXl)};
      `;
  }
}}
`;
var StyledBox = styled15("div")`
  ${StyledBoxCSS}
`;

// src/components/Grid/DeprecatedGrid.ts
var getDisplay2 = (display) => css21`
  display: ${display};
`;
var getGap2 = (gap) => css21`
  grid-gap: ${gap};
`;
var getRowGap = (gap) => css21`
  grid-row-gap: ${gap};
`;
var getColumnGap = (gap) => css21`
  grid-column-gap: ${gap};
`;
var getTemplate = (template) => css21`
  grid-template: ${template};
`;
var getTemplateColumns = (cols) => css21`
  grid-template-columns: ${cols};
`;
var getTemplateRows = (rows) => css21`
  grid-template-rows: ${rows};
`;
var getRow = (row) => css21`
  grid-row: ${row};
`;
var getColumn = (column) => css21`
  grid-column: ${column};
`;
var getAutoFlow = (flow) => css21`
  grid-auto-flow: ${flow};
`;
var getAutoRows = (rows) => css21`
  grid-auto-rows: ${rows};
`;
var getAutoColumns = (columns) => css21`
  grid-auto-columns: ${columns};
`;
var getJustifyItems = (alignment) => css21`
  justify-items: ${alignment};
`;
var getJustifyContent = (alignment) => css21`
  justify-content: ${alignment};
`;
var getAlignItems = (alignment) => css21`
  align-items: ${alignment};
`;
var getAlignContent = (alignment) => css21`
  align-content: ${alignment};
`;
var getPlaceItems = (alignment) => css21`
  place-items: ${alignment};
`;
var getPlaceContent = (alignment) => css21`
  place-content: ${alignment};
`;
var DeprecatedGrid = styled16("div")`
  ${StyledBoxCSS}
  /* Display */
  ${({ display = "grid" }) => display && getDisplay2(display)}
  /* Gaps */
  ${({ gap }) => gap && getGap2(gap)}
  ${({ rowGap }) => rowGap && getRowGap(rowGap)}
  ${({ columnGap }) => columnGap && getColumnGap(columnGap)}
  /* Template */
  ${({ template }) => template && getTemplate(template)}
  ${({ templateColumns }) => templateColumns && getTemplateColumns(templateColumns)}
  ${({ templateRows }) => templateRows && getTemplateRows(templateRows)}
  /* Alignment */
  ${({ justifyItems }) => justifyItems && getJustifyItems(justifyItems)}
  ${({ justifyContent }) => justifyContent && getJustifyContent(justifyContent)}
  ${({ alignItems }) => alignItems && getAlignItems(alignItems)}
  ${({ alignContent }) => alignContent && getAlignContent(alignContent)}
  ${({ placeItems }) => placeItems && getPlaceItems(placeItems)}
  ${({ placeContent }) => placeContent && getPlaceContent(placeContent)}
  /* Child Properties */
  ${({ row }) => row && getRow(row)}
  ${({ column }) => column && getColumn(column)}
  /* Auto Properties */
  ${({ autoFlow }) => autoFlow && getAutoFlow(autoFlow)}
  ${({ autoRows }) => autoRows && getAutoRows(autoRows)}
  ${({ autoColumns }) => autoColumns && getAutoColumns(autoColumns)}
  /*
    media.smUp
  */
  ${({
  displaySm,
  gapSm,
  rowGapSm,
  columnGapSm,
  templateSm,
  templateColumnsSm,
  templateRowsSm,
  justifyItemsSm,
  justifyContentSm,
  alignItemsSm,
  alignContentSm,
  placeItemsSm,
  placeContentSm,
  rowSm,
  columnSm,
  autoFlowSm,
  autoRowsSm,
  autoColumnsSm
}) => {
  if (displaySm || gapSm || rowGapSm || columnGapSm || templateSm || templateColumnsSm || templateRowsSm || justifyItemsSm || justifyContentSm || alignItemsSm || alignContentSm || placeItemsSm || placeContentSm || rowSm || columnSm || autoFlowSm || autoRowsSm || autoColumnsSm) {
    return media_default.smUp`
        /* Display */
        ${displaySm && getDisplay2(displaySm)};
        /* Gaps */
        ${gapSm && getGap2(gapSm)}
        ${rowGapSm && getRowGap(rowGapSm)}
        ${columnGapSm && getColumnGap(columnGapSm)}
        /* Template */
        ${templateSm && getTemplate(templateSm)}
        ${templateColumnsSm && getTemplateColumns(templateColumnsSm)}
        ${templateRowsSm && getTemplateRows(templateRowsSm)}
        /* Alignment */
        ${justifyItemsSm && getJustifyItems(justifyItemsSm)}
        ${justifyContentSm && getJustifyContent(justifyContentSm)}
        ${alignItemsSm && getAlignItems(alignItemsSm)}
        ${alignContentSm && getAlignContent(alignContentSm)}
        ${placeItemsSm && getPlaceItems(placeItemsSm)}
        ${placeContentSm && getPlaceContent(placeContentSm)}
        /* Child Properties */
        ${rowSm && getRow(rowSm)}
        ${columnSm && getColumn(columnSm)}
        /* Auto Properties */
        ${autoFlowSm && getAutoFlow(autoFlowSm)}
        ${autoRowsSm && getAutoRows(autoRowsSm)}
        ${autoColumnsSm && getAutoColumns(autoColumnsSm)}
      `;
  }
}}
  /*
    media.mdUp
  */
  ${({
  displayMd,
  gapMd,
  rowGapMd,
  columnGapMd,
  templateMd,
  templateColumnsMd,
  templateRowsMd,
  justifyItemsMd,
  justifyContentMd,
  alignItemsMd,
  alignContentMd,
  placeItemsMd,
  placeContentMd,
  rowMd,
  columnMd,
  autoFlowMd,
  autoRowsMd,
  autoColumnsMd
}) => {
  if (displayMd || gapMd || rowGapMd || columnGapMd || templateMd || templateColumnsMd || templateRowsMd || justifyItemsMd || justifyContentMd || alignItemsMd || alignContentMd || placeItemsMd || placeContentMd || rowMd || columnMd || autoFlowMd || autoRowsMd || autoColumnsMd) {
    return media_default.mdUp`
        /* Display */
        ${displayMd && getDisplay2(displayMd)};
        /* Gaps */
        ${gapMd && getGap2(gapMd)}
        ${rowGapMd && getRowGap(rowGapMd)}
        ${columnGapMd && getColumnGap(columnGapMd)}
        /* Template */
        ${templateMd && getTemplate(templateMd)}
        ${templateColumnsMd && getTemplateColumns(templateColumnsMd)}
        ${templateRowsMd && getTemplateRows(templateRowsMd)}
        /* Alignment */
        ${justifyItemsMd && getJustifyItems(justifyItemsMd)}
        ${justifyContentMd && getJustifyContent(justifyContentMd)}
        ${alignItemsMd && getAlignItems(alignItemsMd)}
        ${alignContentMd && getAlignContent(alignContentMd)}
        ${placeItemsMd && getPlaceItems(placeItemsMd)}
        ${placeContentMd && getPlaceContent(placeContentMd)}
        /* Child Properties */
        ${rowMd && getRow(rowMd)}
        ${columnMd && getColumn(columnMd)}
        /* Auto Properties */
        ${autoFlowMd && getAutoFlow(autoFlowMd)}
        ${autoRowsMd && getAutoRows(autoRowsMd)}
        ${autoColumnsMd && getAutoColumns(autoColumnsMd)}
      `;
  }
}}
  /*
    media.lgUp
  */
  ${({
  displayLg,
  gapLg,
  rowGapLg,
  columnGapLg,
  templateLg,
  templateColumnsLg,
  templateRowsLg,
  justifyItemsLg,
  justifyContentLg,
  alignItemsLg,
  alignContentLg,
  placeItemsLg,
  placeContentLg,
  rowLg,
  columnLg,
  autoFlowLg,
  autoRowsLg,
  autoColumnsLg
}) => {
  if (displayLg || gapLg || rowGapLg || columnGapLg || templateLg || templateColumnsLg || templateRowsLg || justifyItemsLg || justifyContentLg || alignItemsLg || alignContentLg || placeItemsLg || placeContentLg || rowLg || columnLg || autoFlowLg || autoRowsLg || autoColumnsLg) {
    return media_default.lgUp`
        /* Display */
        ${displayLg && getDisplay2(displayLg)};
        /* Gaps */
        ${gapLg && getGap2(gapLg)}
        ${rowGapLg && getRowGap(rowGapLg)}
        ${columnGapLg && getColumnGap(columnGapLg)}
        /* Template */
        ${templateLg && getTemplate(templateLg)}
        ${templateColumnsLg && getTemplateColumns(templateColumnsLg)}
        ${templateRowsLg && getTemplateRows(templateRowsLg)}
        /* Alignment */
        ${justifyItemsLg && getJustifyItems(justifyItemsLg)}
        ${justifyContentLg && getJustifyContent(justifyContentLg)}
        ${alignItemsLg && getAlignItems(alignItemsLg)}
        ${alignContentLg && getAlignContent(alignContentLg)}
        ${placeItemsLg && getPlaceItems(placeItemsLg)}
        ${placeContentLg && getPlaceContent(placeContentLg)}
        /* Child Properties */
        ${rowLg && getRow(rowLg)}
        ${columnLg && getColumn(columnLg)}
        /* Auto Properties */
        ${autoFlowLg && getAutoFlow(autoFlowLg)}
        ${autoRowsLg && getAutoRows(autoRowsLg)}
        ${autoColumnsLg && getAutoColumns(autoColumnsLg)}
      `;
  }
}}
  /*
    media.xlUp
  */
  ${({
  displayXl,
  gapXl,
  rowGapXl,
  columnGapXl,
  templateXl,
  templateColumnsXl,
  templateRowsXl,
  justifyItemsXl,
  justifyContentXl,
  alignItemsXl,
  alignContentXl,
  placeItemsXl,
  placeContentXl,
  rowXl,
  columnXl,
  autoFlowXl,
  autoRowsXl,
  autoColumnsXl
}) => {
  if (displayXl || gapXl || rowGapXl || columnGapXl || templateXl || templateColumnsXl || templateRowsXl || justifyItemsXl || justifyContentXl || alignItemsXl || alignContentXl || placeItemsXl || placeContentXl || rowXl || columnXl || autoFlowXl || autoRowsXl || autoColumnsXl) {
    return media_default.xlUp`
        /* Display */
        ${displayXl && getDisplay2(displayXl)};
        /* Gaps */
        ${gapXl && getGap2(gapXl)}
        ${rowGapXl && getRowGap(rowGapXl)}
        ${columnGapXl && getColumnGap(columnGapXl)}
        /* Template */
        ${templateXl && getTemplate(templateXl)}
        ${templateColumnsXl && getTemplateColumns(templateColumnsXl)}
        ${templateRowsXl && getTemplateRows(templateRowsXl)}
        /* Alignment */
        ${justifyItemsXl && getJustifyItems(justifyItemsXl)}
        ${justifyContentXl && getJustifyContent(justifyContentXl)}
        ${alignItemsXl && getAlignItems(alignItemsXl)}
        ${alignContentXl && getAlignContent(alignContentXl)}
        ${placeItemsXl && getPlaceItems(placeItemsXl)}
        ${placeContentXl && getPlaceContent(placeContentXl)}
        /* Child Properties */
        ${rowXl && getRow(rowXl)}
        ${columnXl && getColumn(columnXl)}
        /* Auto Properties */
        ${autoFlowXl && getAutoFlow(autoFlowXl)}
        ${autoRowsXl && getAutoRows(autoRowsXl)}
        ${autoColumnsXl && getAutoColumns(autoColumnsXl)}
      `;
  }
}}
`;

// src/components/Tab/TabList.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
var TabList = (props) => /* @__PURE__ */ jsx17(DeprecatedGrid, { role: "tablist", ...props });

// src/components/Tab/TabPanel.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var TabPanel = ({
  value,
  selected,
  ...props
}) => {
  if (selected) {
    return /* @__PURE__ */ jsx18(
      DeprecatedGrid,
      {
        role: "tabpanel",
        id: `${value}-panel`,
        "aria-labelledby": `${value}-tab`,
        ...props
      }
    );
  }
  return null;
};

// src/components/ToggleButton/ToggleButton.ts
import styled17, { css as css22 } from "styled-components";
var svg2 = css22`
  ${({ theme: theme2, alignIcon, styleType, state }) => {
  const dimensions = theme2.x3spacePx;
  return css22`
      > svg {
        display: inline;
        fill: ${styleType === "loud" && state === "on" ? theme2.color.brand01 : theme2.color.white};
        opacity: 0.5;
        width: ${dimensions}px;
        height: ${dimensions}px;
        vertical-align: middle;
        ${alignIcon && css22`
          padding-${alignIcon}: 4px;
        `}
      }
    `;
}}
`;
var disabled3 = css22`
  cursor: auto;
  pointer-events: none;
  opacity: 0.3;
  color: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "strong":
      return theme2.color.whiteRGBA(0.7);
    case "loud":
      return theme2.color.brand01;
    default:
      return theme2.color.white;
  }
}};
  background-color: ${({ theme: theme2, styleType }) => {
  switch (styleType) {
    case "strong":
      return theme2.color.brand01RGBA(0.3);
    case "loud":
      return theme2.color.brand03RGBA(0.1);
    default:
      return "transparent";
  }
}};
`;
var hover3 = css22`
  background-color: ${({ theme: theme2, styleType, state }) => {
  switch (styleType) {
    case "subtle":
      return theme2.color.whiteRGBA(0.1);
    case "loud":
      return theme2.color.brand03RGBA(0.2);
    case "strong":
      return state === "off" ? theme2.color.whiteRGBA(0.1) : theme2.color.brand01;
  }
}};
`;
var backgroundColor2 = css22`
  background-color: ${({ theme: theme2, styleType, state }) => {
  if (state === "off") {
    return "transparent";
  }
  switch (styleType) {
    case "subtle":
      return theme2.color.whiteRGBA(0.2);
    case "loud":
      return theme2.color.brand03RGBA(0.1);
    case "strong":
      return theme2.color.brand01;
  }
}};
`;
var toggleButtonCss = css22`
  ${({ theme: theme2 }) => theme2.typography.tiny}
  &:disabled {
    ${disabled3}
  }

  &:hover,
  &:visited {
    ${hover3}
  }

  position: relative;
  display: inline-flex;
  align-items: center;
  height: ${({ theme: theme2 }) => theme2.x4spacePx - 4}px;
  line-height: ${({ theme: theme2 }) => theme2.x4spacePx - 4}px;
  color: ${({ theme: theme2 }) => theme2.color.white};
  vertical-align: middle;
  border-radius: ${({ theme: theme2 }) => theme2.x1spacePx / 2}px;
  padding: ${({ theme: theme2 }) => `0 ${theme2.x2spacePx - 4}px`};
  ${backgroundColor2}
  ${svg2}
`;
var ToggleButton = styled17("button").attrs(({ theme: theme2 }) => {
  return {
    ...theme2.focus("dashed")
  };
})`
  ${toggleButtonCss}
`;
var ToggleButton_default = ToggleButton;

// src/components/Box/Box.tsx
import { forwardRef as forwardRef3 } from "react";
import { jsx as jsx19 } from "react/jsx-runtime";
var Box = forwardRef3(
  ({
    as = "div",
    children,
    display,
    width,
    height: height4,
    cursor,
    opacity,
    overflow,
    transform,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx19(
      StyledBox,
      {
        ref,
        as,
        $display: display,
        $width: width,
        $height: height4,
        $cursor: cursor,
        $opacity: opacity,
        $overflow: overflow,
        $transform: transform,
        ...props,
        children
      }
    );
  }
);
Box.displayName = "Box";

// src/components/Grid/Grid.tsx
import { forwardRef as forwardRef4 } from "react";

// src/components/Grid/styled.ts
import styled18, { css as css23 } from "styled-components";
var getGap3 = (gap) => css23`
  grid-gap: ${gap};
`;
var getRowGap2 = (gap) => css23`
  grid-row-gap: ${gap};
`;
var getColumnGap2 = (gap) => css23`
  grid-column-gap: ${gap};
`;
var getTemplate2 = (template) => css23`
  grid-template: ${template};
`;
var getTemplateColumns2 = (cols) => css23`
  grid-template-columns: ${cols};
`;
var getTemplateRows2 = (rows) => css23`
  grid-template-rows: ${rows};
`;
var getRow2 = (row) => css23`
  grid-row: ${row};
`;
var getColumn2 = (column) => css23`
  grid-column: ${column};
`;
var getAutoFlow2 = (flow) => css23`
  grid-auto-flow: ${flow};
`;
var getAutoRows2 = (rows) => css23`
  grid-auto-rows: ${rows};
`;
var getAutoColumns2 = (columns) => css23`
  grid-auto-columns: ${columns};
`;
var getJustifyItems2 = (alignment) => css23`
  justify-items: ${alignment};
`;
var getJustifyContent2 = (alignment) => css23`
  justify-content: ${alignment};
`;
var getAlignItems2 = (alignment) => css23`
  align-items: ${alignment};
`;
var getAlignContent2 = (alignment) => css23`
  align-content: ${alignment};
`;
var getPlaceItems2 = (alignment) => css23`
  place-items: ${alignment};
`;
var getPlaceContent2 = (alignment) => css23`
  place-content: ${alignment};
`;
var StyledGrid = styled18("div")`
  ${StyledBoxCSS}
  /* Gaps */
  ${({ gap }) => gap && getGap3(gap)}
  ${({ rowGap }) => rowGap && getRowGap2(rowGap)}
  ${({ columnGap }) => columnGap && getColumnGap2(columnGap)}
  /* Template */
  ${({ template }) => template && getTemplate2(template)}
  ${({ templateColumns }) => templateColumns && getTemplateColumns2(templateColumns)}
  ${({ templateRows }) => templateRows && getTemplateRows2(templateRows)}
  /* Alignment */
  ${({ justifyItems }) => justifyItems && getJustifyItems2(justifyItems)}
  ${({ justifyContent }) => justifyContent && getJustifyContent2(justifyContent)}
  ${({ alignItems }) => alignItems && getAlignItems2(alignItems)}
  ${({ alignContent }) => alignContent && getAlignContent2(alignContent)}
  ${({ placeItems }) => placeItems && getPlaceItems2(placeItems)}
  ${({ placeContent }) => placeContent && getPlaceContent2(placeContent)}
  /* Child Properties */
  ${({ row }) => row && getRow2(row)}
  ${({ column }) => column && getColumn2(column)}
  /* Auto Properties */
  ${({ autoFlow }) => autoFlow && getAutoFlow2(autoFlow)}
  ${({ autoRows }) => autoRows && getAutoRows2(autoRows)}
  ${({ autoColumns }) => autoColumns && getAutoColumns2(autoColumns)}
  /*
    media.smUp
  */
  ${({
  gapSm,
  rowGapSm,
  columnGapSm,
  templateSm,
  templateColumnsSm,
  templateRowsSm,
  justifyItemsSm,
  justifyContentSm,
  alignItemsSm,
  alignContentSm,
  placeItemsSm,
  placeContentSm,
  rowSm,
  columnSm,
  autoFlowSm,
  autoRowsSm,
  autoColumnsSm
}) => {
  if (gapSm || rowGapSm || columnGapSm || templateSm || templateColumnsSm || templateRowsSm || justifyItemsSm || justifyContentSm || alignItemsSm || alignContentSm || placeItemsSm || placeContentSm || rowSm || columnSm || autoFlowSm || autoRowsSm || autoColumnsSm) {
    return media_default.smUp`
        /* Gaps */
        ${gapSm && getGap3(gapSm)}
        ${rowGapSm && getRowGap2(rowGapSm)}
        ${columnGapSm && getColumnGap2(columnGapSm)}
        /* Template */
        ${templateSm && getTemplate2(templateSm)}
        ${templateColumnsSm && getTemplateColumns2(templateColumnsSm)}
        ${templateRowsSm && getTemplateRows2(templateRowsSm)}
        /* Alignment */
        ${justifyItemsSm && getJustifyItems2(justifyItemsSm)}
        ${justifyContentSm && getJustifyContent2(justifyContentSm)}
        ${alignItemsSm && getAlignItems2(alignItemsSm)}
        ${alignContentSm && getAlignContent2(alignContentSm)}
        ${placeItemsSm && getPlaceItems2(placeItemsSm)}
        ${placeContentSm && getPlaceContent2(placeContentSm)}
        /* Child Properties */
        ${rowSm && getRow2(rowSm)}
        ${columnSm && getColumn2(columnSm)}
        /* Auto Properties */
        ${autoFlowSm && getAutoFlow2(autoFlowSm)}
        ${autoRowsSm && getAutoRows2(autoRowsSm)}
        ${autoColumnsSm && getAutoColumns2(autoColumnsSm)}
      `;
  }
}}
  /*
    media.mdUp
  */
  ${({
  gapMd,
  rowGapMd,
  columnGapMd,
  templateMd,
  templateColumnsMd,
  templateRowsMd,
  justifyItemsMd,
  justifyContentMd,
  alignItemsMd,
  alignContentMd,
  placeItemsMd,
  placeContentMd,
  rowMd,
  columnMd,
  autoFlowMd,
  autoRowsMd,
  autoColumnsMd
}) => {
  if (gapMd || rowGapMd || columnGapMd || templateMd || templateColumnsMd || templateRowsMd || justifyItemsMd || justifyContentMd || alignItemsMd || alignContentMd || placeItemsMd || placeContentMd || rowMd || columnMd || autoFlowMd || autoRowsMd || autoColumnsMd) {
    return media_default.mdUp`
        /* Gaps */
        ${gapMd && getGap3(gapMd)}
        ${rowGapMd && getRowGap2(rowGapMd)}
        ${columnGapMd && getColumnGap2(columnGapMd)}
        /* Template */
        ${templateMd && getTemplate2(templateMd)}
        ${templateColumnsMd && getTemplateColumns2(templateColumnsMd)}
        ${templateRowsMd && getTemplateRows2(templateRowsMd)}
        /* Alignment */
        ${justifyItemsMd && getJustifyItems2(justifyItemsMd)}
        ${justifyContentMd && getJustifyContent2(justifyContentMd)}
        ${alignItemsMd && getAlignItems2(alignItemsMd)}
        ${alignContentMd && getAlignContent2(alignContentMd)}
        ${placeItemsMd && getPlaceItems2(placeItemsMd)}
        ${placeContentMd && getPlaceContent2(placeContentMd)}
        /* Child Properties */
        ${rowMd && getRow2(rowMd)}
        ${columnMd && getColumn2(columnMd)}
        /* Auto Properties */
        ${autoFlowMd && getAutoFlow2(autoFlowMd)}
        ${autoRowsMd && getAutoRows2(autoRowsMd)}
        ${autoColumnsMd && getAutoColumns2(autoColumnsMd)}
      `;
  }
}}
  /*
    media.lgUp
  */
  ${({
  gapLg,
  rowGapLg,
  columnGapLg,
  templateLg,
  templateColumnsLg,
  templateRowsLg,
  justifyItemsLg,
  justifyContentLg,
  alignItemsLg,
  alignContentLg,
  placeItemsLg,
  placeContentLg,
  rowLg,
  columnLg,
  autoFlowLg,
  autoRowsLg,
  autoColumnsLg
}) => {
  if (gapLg || rowGapLg || columnGapLg || templateLg || templateColumnsLg || templateRowsLg || justifyItemsLg || justifyContentLg || alignItemsLg || alignContentLg || placeItemsLg || placeContentLg || rowLg || columnLg || autoFlowLg || autoRowsLg || autoColumnsLg) {
    return media_default.lgUp`
        /* Gaps */
        ${gapLg && getGap3(gapLg)}
        ${rowGapLg && getRowGap2(rowGapLg)}
        ${columnGapLg && getColumnGap2(columnGapLg)}
        /* Template */
        ${templateLg && getTemplate2(templateLg)}
        ${templateColumnsLg && getTemplateColumns2(templateColumnsLg)}
        ${templateRowsLg && getTemplateRows2(templateRowsLg)}
        /* Alignment */
        ${justifyItemsLg && getJustifyItems2(justifyItemsLg)}
        ${justifyContentLg && getJustifyContent2(justifyContentLg)}
        ${alignItemsLg && getAlignItems2(alignItemsLg)}
        ${alignContentLg && getAlignContent2(alignContentLg)}
        ${placeItemsLg && getPlaceItems2(placeItemsLg)}
        ${placeContentLg && getPlaceContent2(placeContentLg)}
        /* Child Properties */
        ${rowLg && getRow2(rowLg)}
        ${columnLg && getColumn2(columnLg)}
        /* Auto Properties */
        ${autoFlowLg && getAutoFlow2(autoFlowLg)}
        ${autoRowsLg && getAutoRows2(autoRowsLg)}
        ${autoColumnsLg && getAutoColumns2(autoColumnsLg)}
      `;
  }
}}
  /*
    media.xlUp
  */
  ${({
  gapXl,
  rowGapXl,
  columnGapXl,
  templateXl,
  templateColumnsXl,
  templateRowsXl,
  justifyItemsXl,
  justifyContentXl,
  alignItemsXl,
  alignContentXl,
  placeItemsXl,
  placeContentXl,
  rowXl,
  columnXl,
  autoFlowXl,
  autoRowsXl,
  autoColumnsXl
}) => {
  if (gapXl || rowGapXl || columnGapXl || templateXl || templateColumnsXl || templateRowsXl || justifyItemsXl || justifyContentXl || alignItemsXl || alignContentXl || placeItemsXl || placeContentXl || rowXl || columnXl || autoFlowXl || autoRowsXl || autoColumnsXl) {
    return media_default.xlUp`
        /* Gaps */
        ${gapXl && getGap3(gapXl)}
        ${rowGapXl && getRowGap2(rowGapXl)}
        ${columnGapXl && getColumnGap2(columnGapXl)}
        /* Template */
        ${templateXl && getTemplate2(templateXl)}
        ${templateColumnsXl && getTemplateColumns2(templateColumnsXl)}
        ${templateRowsXl && getTemplateRows2(templateRowsXl)}
        /* Alignment */
        ${justifyItemsXl && getJustifyItems2(justifyItemsXl)}
        ${justifyContentXl && getJustifyContent2(justifyContentXl)}
        ${alignItemsXl && getAlignItems2(alignItemsXl)}
        ${alignContentXl && getAlignContent2(alignContentXl)}
        ${placeItemsXl && getPlaceItems2(placeItemsXl)}
        ${placeContentXl && getPlaceContent2(placeContentXl)}
        /* Child Properties */
        ${rowXl && getRow2(rowXl)}
        ${columnXl && getColumn2(columnXl)}
        /* Auto Properties */
        ${autoFlowXl && getAutoFlow2(autoFlowXl)}
        ${autoRowsXl && getAutoRows2(autoRowsXl)}
        ${autoColumnsXl && getAutoColumns2(autoColumnsXl)}
      `;
  }
}}
`;

// src/components/Grid/Grid.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var Grid = forwardRef4(
  ({
    as = "div",
    children,
    display = "grid",
    width,
    height: height4,
    cursor,
    opacity,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx20(
      StyledGrid,
      {
        ref,
        as,
        $display: display,
        $width: width,
        $height: height4,
        $cursor: cursor,
        $opacity: opacity,
        ...props,
        children
      }
    );
  }
);
Grid.displayName = "Grid";

// src/components/Text/Text.tsx
import { forwardRef as forwardRef5 } from "react";

// src/components/Text/constants.ts
var colorFor = {
  p: "white",
  b: "white",
  i: "white",
  strong: "white",
  em: "white",
  h1: "white",
  h2: "white",
  h3: "white",
  h4: "white",
  h5: "white",
  h6: "white",
  span: "inherit"
};
var typographyFor = {
  p: "base",
  b: "base",
  i: "base",
  strong: "base",
  em: "base",
  h1: "mega",
  h2: "xLarge",
  h3: "large",
  h4: "large",
  h5: "base",
  h6: "base",
  span: "inherit"
};

// src/components/Text/styled.ts
import styled19, { css as css24 } from "styled-components";
var StyledText = styled19("span")`
  margin: 0;
  ${({ theme: theme2, typography: typography2 }) => theme2.typography[typography2]}
  color: ${({ theme: theme2, $color, $opacity }) => {
  if ($color === "inherit") {
    return "inherit";
  }
  return applyColor(theme2.color[$color], $opacity);
}};
  ${({ textAlign }) => textAlign && css24`
      text-align: ${textAlign};
    `}
  ${({ textTransform }) => textTransform && css24`
      text-transform: ${textTransform};
    `}
  ${({ isTruncated }) => isTruncated && Ellipsis}
  ${({ lineClamp }) => typeof lineClamp !== "undefined" && EllipsisWithLineClamp(lineClamp)}
`;

// src/components/Text/Text.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var Text = forwardRef5(
  ({
    as = "p",
    opacity,
    textAlign,
    textTransform,
    color: color3 = colorFor[as],
    typography: typography2 = typographyFor[as],
    isTruncated = false,
    lineClamp,
    children,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx21(
      StyledText,
      {
        ref,
        as,
        $color: color3,
        $opacity: opacity,
        textAlign,
        textTransform,
        typography: typography2,
        isTruncated,
        lineClamp,
        ...props,
        children
      }
    );
  }
);
Text.displayName = "Text";
var Text_default = Text;

// src/components/Heading/Heading.tsx
import { forwardRef as forwardRef6 } from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var Heading = forwardRef6(
  ({
    as,
    opacity,
    textAlign,
    textTransform,
    color: color3 = colorFor[as],
    typography: typography2 = typographyFor[as],
    isTruncated = false,
    lineClamp,
    children,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx22(
      StyledText,
      {
        ref,
        as,
        $color: color3,
        $opacity: opacity,
        textAlign,
        typography: typography2,
        textTransform,
        isTruncated,
        lineClamp,
        ...props,
        children
      }
    );
  }
);
Heading.displayName = "Heading";
var Heading_default = Heading;

// src/components/Alert/Alert.tsx
import { useCallback as useCallback6, useMemo, useState as useState4 } from "react";

// src/hooks/useTheme.ts
import { useContext } from "react";
import { ThemeContext } from "styled-components";
function useTheme() {
  const theme2 = useContext(ThemeContext);
  if (typeof theme2 === "undefined") {
    throw new Error(
      "useTheme: Attempting to access undefined context, possibly outside of `ThemeProvider`"
    );
  }
  return theme2;
}

// src/hooks/useMount/useMount.ts
import { useEffect as useEffect6, useRef as useRef4, useState as useState3 } from "react";
var useMount = (effect) => {
  const mounted = useRef4(false);
  useEffect6(() => {
    if (!mounted.current) {
      effect();
      mounted.current = true;
    }
  });
};
var useIsMounted = () => {
  const [mounted, setMounted] = useState3(false);
  useMount(() => {
    setMounted(true);
  });
  return mounted;
};

// src/components/Alert/styled.ts
import styled20, { css as css25, keyframes as keyframes5 } from "styled-components";
var easeOutCubic = "cubic-bezier(0.23, 1, 0.32, 1)";
var exit = () => keyframes5`
  from        { opacity: 1; }
  to          { opacity: 0; }
`;
var StyledAlert = styled20(DeprecatedGrid)`
  width: 100%;
  border: 1px solid ${({ theme: theme2 }) => theme2.color.whiteRGBA(0.05)};
  box-shadow: 0 ${({ theme: theme2 }) => theme2.x1spacePx}px
    ${({ theme: theme2 }) => theme2.x2spacePx / 2}px
    ${({ theme: theme2 }) => theme2.color.blackRGBA(0.25)};
  background-color: ${({ theme: theme2 }) => theme2.color.phantom};
  border-radius: ${({ theme: theme2 }) => theme2.x1spacePx}px;
  padding: ${({ theme: theme2 }) => theme2.x3spacePx / 2}px;

  ${({ state }) => {
  if (state === "exiting") {
    return css25`
        animation: ${exit} 0.2s ${easeOutCubic} 0s forwards;
      `;
  }
}}
`;
var IconWrapper = styled20("div")`
  align-self: start;
  transform: translateY(1px);
  svg {
    width: 24px;
    height: 24px;
  }
`;
var AlertIconLoadingWrapper = styled20("div")`
  position: relative;
  align-self: start;
  transform: translateY(3px);
  padding-left: ${({ theme: theme2 }) => theme2.x1spacePx / 2}px;
`;

// src/icons/DangerSolid.tsx
import { forwardRef as forwardRef7 } from "react";

// src/icons/solid/danger.svg
import * as React2 from "react";
import { jsx as jsx23 } from "react/jsx-runtime";
var SvgDanger = (props) => /* @__PURE__ */ jsx23("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx23("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.07 4.525c.397-.7 1.463-.7 1.86 0l7.945 14.017c.374.66-.135 1.458-.93 1.458H4.055c-.795 0-1.304-.798-.93-1.458L11.07 4.525ZM12 8c.554 0 1.004.45 1.004 1.003v3.01a1.004 1.004 0 0 1-2.008 0v-3.01C10.996 8.45 11.446 8 12 8Zm0 9.027a1.004 1.004 0 1 0 0-2.007 1.004 1.004 0 0 0 0 2.007Z" }) });
var danger_default = SvgDanger;

// src/icons/DangerSolid.tsx
import { jsx as jsx24 } from "react/jsx-runtime";
var DangerSolid_default = forwardRef7(
  (props, ref) => /* @__PURE__ */ jsx24(danger_default, { ref, ...props })
);

// src/icons/SuccessSolid.tsx
import { forwardRef as forwardRef8 } from "react";

// src/icons/solid/success.svg
import * as React3 from "react";
import { jsx as jsx25 } from "react/jsx-runtime";
var SvgSuccess = (props) => /* @__PURE__ */ jsx25("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx25("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-11.707-.707a1 1 0 0 1 1.414 0L11 12.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z" }) });
var success_default = SvgSuccess;

// src/icons/SuccessSolid.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var SuccessSolid_default = forwardRef8(
  (props, ref) => /* @__PURE__ */ jsx26(success_default, { ref, ...props })
);

// src/icons/WarningSolid.tsx
import { forwardRef as forwardRef9 } from "react";

// src/icons/solid/warning.svg
import * as React4 from "react";
import { jsx as jsx27 } from "react/jsx-runtime";
var SvgWarning = (props) => /* @__PURE__ */ jsx27("svg", { width: 24, height: 24, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ jsx27("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM13 11C13 11.5523 12.5523 12 12 12C11.4477 12 11 11.5523 11 11V8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8L13 11ZM13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z" }) });
var warning_default = SvgWarning;

// src/icons/WarningSolid.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var WarningSolid_default = forwardRef9(
  (props, ref) => /* @__PURE__ */ jsx28(warning_default, { ref, ...props })
);

// src/components/Alert/AlertIcon.tsx
import { jsx as jsx29 } from "react/jsx-runtime";
var STYLE_TYPES = {
  positive: { Icon: SuccessSolid_default, color: "good" },
  warning: { Icon: WarningSolid_default, color: "warning" },
  negative: { Icon: DangerSolid_default, color: "bad" }
};
function isColor(color3, theme2) {
  return color3 in theme2.color && typeof theme2.color[color3] === "string";
}
var AlertIcon = ({ styleType }) => {
  const theme2 = useTheme();
  if (styleType === "loading") {
    return /* @__PURE__ */ jsx29(AlertIconLoadingWrapper, { children: /* @__PURE__ */ jsx29(LoadingSpinner, { styleType: "light", role: "presentation" }) });
  }
  const { Icon, color: color3 } = STYLE_TYPES[styleType];
  return /* @__PURE__ */ jsx29(IconWrapper, { children: /* @__PURE__ */ jsx29(
    Icon,
    {
      fill: isColor(color3, theme2) ? theme2.color[color3] : theme2.color.white,
      role: "presentation"
    }
  ) });
};

// src/components/Alert/AlertAction/AlertActions.tsx
import { Children } from "react";
import { jsx as jsx30 } from "react/jsx-runtime";
var AlertActions = ({ children, layout }) => /* @__PURE__ */ jsx30(
  DeprecatedGrid,
  {
    templateColumns: `repeat(${Children.count(children)}, max-content)`,
    gap: "12px",
    column: layout === "stack" ? "span 2" : "",
    justifyContent: layout === "stack" ? "end" : "start",
    children
  }
);

// src/components/Alert/alertStateContext.tsx
import { createContext, useContext as useContext2 } from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var defaultState = {
  current: "default",
  isDismissed: false,
  onDismiss() {
    return;
  }
};
var alertStateContext = createContext(void 0);
function useAlertStateContext() {
  const context = useContext2(alertStateContext);
  if (typeof context === "undefined") {
    console.warn(
      "useAlertStateContext: Attempting to access undefined context, possibly outside of `AlertStateProvider`. Default context will be returned, but it does not respond to updates."
    );
    return defaultState;
  }
  return context;
}
var AlertStateProvider = ({
  children,
  value
}) => {
  if (value.isDismissed) {
    return null;
  }
  return /* @__PURE__ */ jsx31(alertStateContext.Provider, { value, children });
};

// src/components/Alert/AlertAction/styled.ts
import styled21, { css as css26 } from "styled-components";
var variants = {
  link: {
    base: css26`
      color: ${({ theme: theme2 }) => theme2.color.brand01};
    `,
    hover: css26`
      background-color: ${({ theme: theme2 }) => theme2.color.brand01RGBA(0.1)};
    `,
    active: css26`
      background-color: ${({ theme: theme2 }) => theme2.color.blackRGBA(0.1)};
    `,
    disabled: css26`
      color: ${({ theme: theme2 }) => theme2.color.brand01RGBA(0.1)};
    `
  }
};
var StyledAlertAction = styled21("button").attrs(
  ({ theme: theme2 }) => theme2.focus("dashed")
)`
  ${({ theme: theme2 }) => theme2.typography.xSmall}
  transition: 0.2s background-color, 0.2s box-shadow, 0.4s color;

  border: 0;
  margin: 0;
  border-radius: 6px;
  white-space: nowrap;
  text-decoration: none;
  /** required so focus outline works */
  position: relative;

  /** size specific - 'small' */
  min-height: 28px;
  padding-left: ${({ theme: theme2 }) => theme2.x1spacePx}px;
  padding-right: ${({ theme: theme2 }) => theme2.x1spacePx}px;

  /** variant */
  ${({ variant = "link" }) => variants[variant].base}

  ${({ variant = "link" }) => media_default.mdUp`
    &:hover {
      ${variants[variant].hover}
    }
  `}
  
  &:active {
    ${({ variant = "link" }) => variants[variant].active}
  }

  &:disabled {
    cursor: auto;
    pointer-events: none;
    ${({ variant = "link" }) => variants[variant].disabled}
  }
`;

// src/components/Alert/AlertAction/AlertAction.tsx
import { jsx as jsx32 } from "react/jsx-runtime";
var AlertAction = ({
  children,
  onClick,
  shouldDismissAlert = true,
  ...props
}) => {
  const { onDismiss } = useAlertStateContext();
  const handleClick = (e) => {
    onClick?.(e);
    if (shouldDismissAlert) {
      onDismiss();
    }
  };
  return /* @__PURE__ */ jsx32(StyledAlertAction, { onClick: handleClick, ...props, children });
};

// src/components/Alert/Alert.tsx
import { jsx as jsx33, jsxs as jsxs10 } from "react/jsx-runtime";
var isPrimitive = (p) => ["string", "number", "boolean"].includes(typeof p);
var isPrimitiveChildren = (c) => isPrimitive(c) || Array.isArray(c) && c.every(isPrimitive);
var Alert = ({
  title,
  styleType,
  children,
  actions,
  onDismiss,
  layout = "inline",
  icon = null,
  ...props
}) => {
  const [state, setState] = useState4("default");
  const context = useMemo(
    () => ({
      current: state,
      isDismissed: state === "dismissed",
      onDismiss() {
        setState("exiting");
      }
    }),
    [state]
  );
  const handleAnimationEnd = useCallback6(() => {
    onDismiss?.();
    setState("dismissed");
  }, [onDismiss]);
  const iconElement = useMemo(() => {
    if (icon) {
      return /* @__PURE__ */ jsx33(IconWrapper, { children: icon });
    }
    if (styleType) {
      return /* @__PURE__ */ jsx33(AlertIcon, { styleType });
    }
    return null;
  }, [icon, styleType]);
  return /* @__PURE__ */ jsx33(AlertStateProvider, { value: context, children: /* @__PURE__ */ jsxs10(
    StyledAlert,
    {
      as: "section",
      role: "alert",
      columnGap: "12px",
      rowGap: layout === "stack" ? "16px" : void 0,
      alignItems: "center",
      state,
      onAnimationEnd: handleAnimationEnd,
      templateColumns: [
        iconElement ? "24px" : "",
        "auto",
        actions ? "minmax(min-content, max-content)" : ""
      ].join(" "),
      ...props,
      children: [
        iconElement,
        /* @__PURE__ */ jsxs10("div", { children: [
          title ? /* @__PURE__ */ jsx33(Heading_default, { as: "h2", typography: "baseStrong", children: title }) : null,
          isPrimitiveChildren(children) ? /* @__PURE__ */ jsx33(Text_default, { typography: "small", children }) : children
        ] }),
        actions ? /* @__PURE__ */ jsx33(AlertActions, { layout, children: actions }) : null
      ]
    }
  ) });
};
var Alert_default = Alert;

// src/components/Bones/Bones.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var Bones = ({
  as = "span",
  display = "block",
  minHeight,
  backgroundColor: backgroundColor3 = "white",
  borderRadius = "x0_25",
  ...props
}) => {
  const theme2 = useTheme();
  return /* @__PURE__ */ jsx34(
    StyledBox,
    {
      as,
      $display: display,
      $opacity: 0.1,
      minHeight: minHeight || theme2.x2,
      backgroundColor: backgroundColor3,
      borderRadius,
      ...props
    }
  );
};

// src/components/ScrollPanel/ScrollPanel.tsx
import { forwardRef as forwardRef10 } from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var ScrollPanel = forwardRef10(
  ({
    display = "block",
    overflow,
    width,
    height: height4,
    cursor,
    opacity,
    transform,
    children,
    className,
    ...props
  }, ref) => {
    return /* @__PURE__ */ jsx35(
      StyledBox,
      {
        ref,
        as: "div",
        style: { WebkitOverflowScrolling: "touch" },
        $display: display,
        $width: width,
        $height: height4,
        $overflow: overflow,
        $cursor: cursor,
        $opacity: opacity,
        $transform: transform,
        className: ["scrollbar", className].filter(Boolean).join(" "),
        ...props,
        children
      }
    );
  }
);
ScrollPanel.displayName = "ScrollPanel";

// src/components/ScrollPanel/ScrollPanelWithoutScrollbars.tsx
import { forwardRef as forwardRef11 } from "react";

// src/components/ScrollPanel/styled.ts
import { createGlobalStyle } from "styled-components";
var NoScrollbars = createGlobalStyle`
  .noScrollbars {
    /* Hide scrollbar */
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  }
`;

// src/components/ScrollPanel/ScrollPanelWithoutScrollbars.tsx
import { jsx as jsx36, jsxs as jsxs11 } from "react/jsx-runtime";
var ScrollPanelWithoutScrollbars = forwardRef11(({ children, ...props }, ref) => {
  return /* @__PURE__ */ jsxs11(ScrollPanel, { ref, className: "noScrollbars", ...props, children: [
    /* @__PURE__ */ jsx36(NoScrollbars, {}),
    children
  ] });
});
ScrollPanelWithoutScrollbars.displayName = "ScrollPanelWithoutScrollbars";

// src/components/Portal/Portal.tsx
import { useId as useId2 } from "react";
import { createPortal as createPortal2 } from "react-dom";

// src/components/Portal/usePortal.ts
import { useEffect as useEffect7, useState as useState5 } from "react";
function usePortal({ id, className, rootElement }) {
  const [ref] = useState5(
    () => typeof window === "undefined" ? null : document.createElement("div")
  );
  useEffect7(() => {
    if (ref) {
      const root = rootElement || document.body;
      ref.setAttribute("id", id);
      if (className !== void 0) {
        ref.setAttribute("class", className);
      }
      root.appendChild(ref);
      return () => {
        root.removeChild(ref);
      };
    }
  }, [id, rootElement, ref, className]);
  return ref;
}

// src/components/Portal/Portal.tsx
var Portal2 = ({
  portalId,
  rootElement,
  className,
  children
}) => {
  const defaultId = useId2();
  const portal = usePortal({
    id: portalId ?? defaultId,
    className,
    rootElement
  });
  if (portal) {
    return createPortal2(children, portal);
  }
  return null;
};

// src/logos/SWSLogoIcon.tsx
import { forwardRef as forwardRef12 } from "react";

// src/logos/sws-logo.svg
import * as React5 from "react";
import { jsx as jsx37, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgSwsLogo = (props) => /* @__PURE__ */ jsxs12("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 180 42", ...props, children: [
  /* @__PURE__ */ jsx37("path", { d: "M61.362 32.3h-9.72V19.19h2.909v10.488h6.81V32.3zM41.538 25.802v-4.008h2.248c1.454 0 2.361.693 2.361 1.985v.037c0 1.124-.85 1.986-2.304 1.986h-2.305zm-2.91 6.498h2.91v-3.933h2.21c2.966 0 5.347-1.574 5.347-4.607v-.037c0-2.678-1.91-4.532-5.063-4.532h-5.404V32.3zm-16.398 0h2.852v-8.502l3.684 5.543h.076l3.722-5.6V32.3h2.89V19.19h-3.08l-3.532 5.544-3.62-5.543H22.23V32.3zM67.374 32.3h-2.91v-5.169l-5.082-7.94h3.401l3.155 5.262 3.211-5.262h3.308l-5.083 7.884V32.3zM18.922 32.3h-2.909V19.19h2.91V32.3zM13.209 28.423c0 2.604-2.204 4.064-5.343 4.064-2.204 0-4.428-.693-6.173-2.098l1.688-2.03c1.31.975 2.886 1.582 4.548 1.582 1.31 0 2.224-.47 2.224-1.236v-.037c0-.731-.552-1.149-2.983-1.711-2.932-.674-4.896-1.592-4.896-3.965v-.036c0-2.38 2.12-3.952 5.093-3.952 2.12 0 3.93.598 5.405 1.666l-1.732 2.14c-1.289-.806-2.488-1.26-3.715-1.26-1.225 0-2.047.505-2.047 1.142v.038c0 .861.8 1.143 3.316 1.723 2.953.693 4.615 1.649 4.615 3.933v.037zM129.322 27.521l3.022-6.62 3.005 6.62h-6.027zm-3.682 4.78h1.528l1.568-3.44h7.2l1.548 3.44h1.607l-6.028-13.11h-1.398L125.64 32.3zM150.297 32.3h-8.794V19.19h1.493v11.744h7.301V32.3zM161.59 32.3h-8.795V19.19h1.493v11.744h7.302V32.3zM114.143 32.3h-1.337l-4.148-13.11h1.454l3.387 10.841 3.248-10.84h1.101l3.25 10.84 3.384-10.84h1.406l-4.161 13.11h-1.294l-3.159-10.523-3.131 10.522zM164.148 30.934h14.86v1.367h-14.86v-1.367zM171.409 26.049c0 1.795-1.461 2.854-3.458 2.854-1.509 0-2.816-.477-3.929-1.446l1.205-1.408c.834.672 1.666 1.106 2.724 1.106.834 0 1.376-.384 1.376-.914v-.025c0-.541-.336-.953-1.863-1.306-1.867-.466-3.07-1.188-3.07-2.866v-.025c0-1.64 1.349-2.725 3.241-2.725 1.349 0 2.499.413 3.438 1.15l-1.056 1.497c-.821-.555-1.629-.89-2.409-.89-.781 0-1.191.348-1.191.787v.026c0 .594.396.89 1.998 1.29 1.878.477 2.994 1.294 2.994 2.869v.026zM176.606 28.819h-1.942v-7.562h-2.481v-1.834h6.89v1.835h-2.467v7.56z", fill: "currentColor" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.596 9.015c9.016 0 16.325 7.244 16.325 16.182 0 8.937-7.309 16.183-16.325 16.183-9.016 0-16.326-7.246-16.326-16.183S81.58 9.015 90.596 9.015z", fill: "#CCC" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.506 28.832h.002l-.003.01a16.088 16.088 0 01-.629 2.066l-.036.093c-.034.083-.066.167-.101.25a1.83 1.83 0 01-.055.131c-.028.073-.059.145-.089.218l-.072.162-.085.184-.085.184-.079.164a16.343 16.343 0 01-14.677 9.087 16.338 16.338 0 01-14.686-9.106l-.059-.12c-.036-.08-.075-.157-.11-.237-.02-.041-.038-.082-.057-.124l-.107-.241-.048-.112a15.444 15.444 0 01-.106-.259l-.04-.1a22.707 22.707 0 01-.108-.278l-.031-.083-.106-.297-.023-.069c-.035-.104-.07-.21-.103-.316l-.018-.057a13.32 13.32 0 01-.1-.332l-.011-.045a30.529 30.529 0 01-.096-.343l-.01-.04a16.49 16.49 0 01-.085-.35l-.01-.038v-.003a587.29 587.29 0 018.538-5.6c2.718-.646 5.175-1.007 7.376-1.083 2.198.077 4.656.437 7.374 1.082 3.144 2.017 6.52 4.204 8.553 5.529v.001l-.002.002v.001c-.005.024-.009.046-.016.07z", fill: "#1A1A1A" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M74.684 28.832a587.29 587.29 0 018.537-5.6c2.718-.646 5.175-1.007 7.376-1.083 2.198.077 4.656.437 7.374 1.082 3.144 2.017 6.52 4.204 8.553 5.528-.022.103-.047.204-.072.306l-.012.05c-.024.096-.05.19-.076.287l-.016.06a7.339 7.339 0 01-.081.286l-.013.043c-.158.531-.343 1.051-.552 1.558l-.019.04c-.036.09-.076.179-.114.269l-.026.059-.119.262-.025.054c-.043.088-.084.179-.128.268l-.011.02c-.193.387-.398.766-.622 1.137l-.027.047c-.048.079-.098.157-.146.234l-.043.07c-.048.076-.097.15-.146.225l-.047.07c-.048.076-.1.15-.151.224l-.038.056c-.237.337-.484.665-.745.984-.016.02-.035.042-.05.063-.053.065-.108.129-.161.19a2.645 2.645 0 01-.073.086l-.157.18-.079.087c-.053.06-.108.119-.161.177-.025.028-.05.055-.079.083-.056.059-.111.119-.17.177a14.257 14.257 0 01-.749.726l-.159.143-.113.1c-.05.044-.103.088-.156.133-.042.033-.082.068-.122.102l-.158.129c-.039.033-.081.065-.123.099l-.16.126c-.042.032-.085.066-.13.099-.055.04-.105.08-.159.12l-.134.096a17.875 17.875 0 01-.444.312c-.05.032-.098.065-.146.097l-.16.104c-.052.033-.102.064-.15.096l-.162.1-.151.09-.172.101-.146.084a10.38 10.38 0 01-.184.101 10.095 10.095 0 01-.384.205l-.107.055-.298.147c-.04.02-.08.038-.121.057l-.216.099-.138.062c-.069.03-.136.06-.204.088l-.146.061-.203.082-.144.057-.216.081-.135.05-.274.096a4.201 4.201 0 00-.078.027c-.118.038-.237.078-.357.114l-.096.028a10.704 10.704 0 01-.395.114c-.08.021-.159.044-.24.064l-.14.035c-.077.02-.156.038-.233.057l-.142.032-.243.053c-.043.01-.086.018-.13.027a11.28 11.28 0 01-.375.07c-.127.024-.256.045-.383.064l-.043.006c-.113.017-.227.033-.341.048l-.115.014-.271.03-.134.014c-.087.008-.173.016-.26.022-.046.004-.092.008-.14.01a7.07 7.07 0 01-.259.017l-.136.008c-.096.005-.193.008-.29.01l-.102.004a17.748 17.748 0 01-.8 0l-.104-.003-.29-.01-.132-.01a7.468 7.468 0 01-.4-.026c-.088-.006-.173-.014-.259-.022-.045-.004-.09-.007-.133-.013-.094-.01-.189-.02-.28-.032a15.488 15.488 0 01-.48-.064l-.01-.002a12.467 12.467 0 01-.469-.078c-.098-.018-.197-.035-.294-.056l-.122-.025a15.032 15.032 0 01-.628-.144c-.043-.012-.087-.022-.13-.033a11.358 11.358 0 01-.367-.1c-.107-.03-.213-.06-.32-.093l-.042-.013c-.122-.038-.243-.078-.364-.117-.026-.009-.051-.019-.078-.027-.093-.032-.184-.063-.275-.096l-.12-.044-.233-.088a8.583 8.583 0 01-.129-.05l-.222-.09-.126-.053a28.61 28.61 0 01-.344-.15 11.509 11.509 0 01-.275-.126l-.06-.028a17.402 17.402 0 01-.411-.204c-.085-.044-.17-.09-.253-.132-.038-.02-.075-.041-.113-.063l-.213-.117-.12-.068-.203-.12-.119-.07-.209-.13c-.034-.02-.068-.043-.103-.066-.08-.05-.159-.103-.238-.154l-.072-.048-.304-.208-.06-.043c-.079-.057-.159-.114-.238-.173-.034-.025-.068-.05-.102-.077-.064-.047-.128-.095-.19-.144l-.111-.087a5.557 5.557 0 01-.182-.145c-.036-.03-.073-.058-.107-.088-.06-.049-.121-.099-.18-.15-.035-.03-.07-.058-.104-.089a9.734 9.734 0 01-.19-.166c-.028-.026-.058-.05-.086-.077-.09-.08-.178-.162-.266-.246l-.05-.047c-.072-.067-.142-.136-.212-.205l-.095-.096a15.519 15.519 0 01-.517-.542l-.146-.164a12.065 12.065 0 01-.097-.111c-.053-.06-.104-.12-.155-.182a15.546 15.546 0 01-.31-.377c-.01-.012-.02-.027-.032-.04a22.838 22.838 0 01-.19-.246c-.029-.038-.055-.076-.085-.113l-.131-.18a8.246 8.246 0 01-.211-.3l-.089-.13-.12-.181c-.03-.042-.055-.084-.083-.127-.04-.063-.08-.126-.118-.19-.026-.04-.053-.081-.078-.122-.048-.08-.096-.16-.142-.24-.023-.038-.046-.076-.067-.114a9.364 9.364 0 01-.223-.4c-.034-.064-.07-.128-.103-.193l-.073-.143c-.032-.062-.063-.125-.094-.189-.023-.048-.048-.097-.07-.146-.03-.061-.059-.123-.088-.186l-.07-.152a4.88 4.88 0 01-.085-.193l-.063-.143-.096-.234-.045-.11c-.044-.11-.086-.22-.128-.332l-.052-.145c-.025-.067-.05-.136-.073-.204l-.052-.158a8.696 8.696 0 01-.065-.197l-.05-.162-.06-.197-.047-.162c-.02-.068-.036-.136-.055-.204-.015-.053-.03-.105-.042-.158-.02-.076-.038-.152-.056-.227l-.034-.138v-.007h-.002z", fill: "#333" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M74.684 28.832c3.554 2.673 7.802 4.97 7.802 4.97-.835 1.163-1.514 2.545-2.046 4.066a16.17 16.17 0 01-5.756-9.036z", fill: "#333" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M106.524 28.759c-3.557 2.672-7.804 4.97-7.804 4.97.845 1.175 1.528 2.574 2.062 4.112a16.134 16.134 0 005.742-9.082zM75.529 31.438l-.846-2.606 8.657-5.601 7.263 15.239v2.91h-.006a16.332 16.332 0 01-15.068-9.942z", fill: "#4D4D4D" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M105.739 31.253l.719-2.22c.018-.07.037-.14.05-.21l-8.641-5.593-7.264 15.24v2.91c6.853-.003 12.718-4.191 15.136-10.127z", fill: "#333" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M83.22 23.23l7.376 15.69 7.374-15.69H83.22z", fill: "#CCC" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M88.667 34.818l1.93 4.102 1.927-4.102-1.396-2.598h-.03l1.057-1.003.162-.137-.575-2.917c-.102-.102-.083-.114-.207-.114l-.94.19-.94-.19c-.125 0-.106.012-.207.114l-.575 2.917.16.137 1.059 1.003h-.03l-1.395 2.598z", fill: "#C30" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.597 38.92l1.927-4.102-1.396-2.598h-.03l1.057-1.003.162-.137-.575-2.917c-.102-.102-.083-.114-.207-.114l-.94.19v10.68h.002z", fill: "#A32900" }),
  /* @__PURE__ */ jsx37("path", { d: "M91.5 34.495h-3.541v.707h3.54v-.707z", fill: "#FC0" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M83.22 23.23l4.313 9.176 3.063-3.028 2.93-6.148h4.444l-4.311 9.176-3.063-3.028-2.933-6.148H83.22z", fill: "#fff" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M81.696 24.215l-.359 4.013 2.446 1.086-1.817 1.092 8.63 8.514-7.376-15.69-1.524.985zM99.494 24.215l.36 4.013-2.446 1.086 1.818 1.092-8.63 8.514 7.374-15.69 1.524.985z", fill: "#1A1A1A" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66a.663.663 0 01-.665-.66c0-.365.298-.66.665-.66z", fill: "#B3B3B3" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66v-1.32z", fill: "gray" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66a.663.663 0 01-.665-.66c0-.365.298-.66.665-.66z", fill: "#B3B3B3" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.603 39.623c.369 0 .666.297.666.661 0 .364-.297.66-.666.66v-1.32z", fill: "gray" }),
  /* @__PURE__ */ jsx37("path", { d: "M101.327 35.52h-5.61v.775h5.61v-.775z", fill: "#4D4D4D" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M95.718 35.52l2.288-2.269 1.299 1.285.515-.51 1.507 1.494h-5.609z", fill: "#fff" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M98.62 14.082c-.808-1.038-.78-1.932.083-2.684 3.463.945 5.241 1.384 5.329 1.317-1.368 2.09-3.173 2.546-5.412 1.367zm-16.05 0c.809-1.038.781-1.932-.083-2.684-3.463.945-5.238 1.384-5.328 1.317 1.367 2.09 3.172 2.546 5.412 1.367z", fill: "#963" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M95.683 12.667c-1.698-1.98-1.944-3.106-.74-3.377 4.785.25 6.611-1.826 5.48-6.223L99.557.999c2.953 1.921 4.273 4.554 3.87 7.893-.228 1.89-2.837 3.146-7.744 3.775zm-10.175 0c1.698-1.98 1.944-3.106.74-3.377-4.785.25-6.61-1.826-5.48-6.223.577-1.38.868-2.068.868-2.068-2.955 1.921-4.274 4.554-3.872 7.893.227 1.89 2.836 3.146 7.744 3.775z", fill: "#4D4D4D" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.596 29.378l-10.761-8.97c.186-4.75 1.104-8.7 2.756-11.849 1.605-1.86 4.263-2.39 8.005-2.39 3.74 0 6.398.53 8.002 2.39 1.652 3.15 2.571 7.1 2.758 11.85l-10.76 8.969z", fill: "#C93" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.597 6.169c3.74 0 6.398.53 8.002 2.39 1.651 3.15 2.57 7.1 2.757 11.85l-10.76 8.969V6.168z", fill: "#A37A29" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M79.892 19.088c.294-4.166 1.188-7.676 2.684-10.53.064-.073.129-.146.197-.215 4.13-3.252 3.276 7.405 3.319 8.746.433 1.542-.58 2.484-3.038 2.828-1.275-.19-2.329-.467-3.162-.829zM101.3 19.088c-.294-4.166-1.19-7.676-2.685-10.53a5.314 5.314 0 00-.197-.215c-4.131-3.252-3.277 7.405-3.319 8.746-.433 1.542.58 2.484 3.039 2.828 1.274-.19 2.327-.467 3.162-.829z", fill: "#963" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.596 29.378L79.835 20.41a39.41 39.41 0 01.265-3.32h20.989c.132 1.06.221 2.166.267 3.32l-10.76 8.97z", fill: "#963" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.597 29.378l-7.069-5.889s.929-1.391 2.783-4.176c-.107-.977-.119-1.718-.038-2.223h1.8c.662.697 1.503 1.842 2.523 3.438 1.018-1.596 1.857-2.74 2.52-3.438h1.801c.08.506.068 1.247-.038 2.223 1.854 2.785 2.783 4.176 2.783 4.176l-7.065 5.89z", fill: "#85592B" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M86.312 19.313c.056-1.424 2.296-.082 3.329.614.167.128.338.248.511.36h.001c.154.1.311.193.469.28.363-.199.718-.434 1.063-.704 1.07-.71 3.18-1.931 3.234-.55 3.05-5.389-11.809-5.377-8.607 0z", fill: "#1A1A1A" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.597 15.56c1.37 0 2.482.54 2.482 1.205s-1.111 1.204-2.482 1.204c-1.373 0-2.485-.54-2.485-1.204 0-.666 1.112-1.205 2.485-1.205z", fill: "#666" }),
  /* @__PURE__ */ jsx37("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.597 23.19c-3.486 0-4.114-.62-3.94-1.968.046 1.129 1.358 1.391 3.94 1.391 2.58 0 3.891-.262 3.937-1.391.174 1.349-.454 1.968-3.938 1.968zM96.513 12.928c-.644-.027-1.21.491-1.419 1.156-.518-4.31 3.511-4.49 4.413-1.662-.76.46-1.577.567-2.994.506zm-11.835 0c.645-.027 1.21.491 1.42 1.156.517-4.31-3.513-4.49-4.413-1.662.759.46 1.576.567 2.993.506z", fill: "#1A1A1A" })
] });
var sws_logo_default = SvgSwsLogo;

// src/logos/SWSLogoIcon.tsx
import { jsx as jsx38 } from "react/jsx-runtime";
var SWSLogoIcon_default = forwardRef12(
  (props, ref) => /* @__PURE__ */ jsx38(sws_logo_default, { ref, ...props })
);

// src/logos/SWSLogoIconSimple.tsx
import { forwardRef as forwardRef13 } from "react";

// src/logos/sws-logo-sm.svg
import * as React6 from "react";
import { jsx as jsx39, jsxs as jsxs13 } from "react/jsx-runtime";
var SvgSwsLogoSm = (props) => /* @__PURE__ */ jsxs13("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 40", ...props, children: [
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 7.94c8.837 0 16 7.177 16 16.03 0 8.852-7.163 16.029-16 16.029-8.836 0-16-7.177-16-16.03C0 15.117 7.164 7.94 16 7.94z", fill: "#CCC" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.593 27.57h.002l-.003.01a15.96 15.96 0 01-.617 2.046l-.035.093c-.033.082-.065.165-.1.246a1.62 1.62 0 01-.052.131c-.028.072-.058.143-.088.215-.022.054-.048.108-.07.161l-.084.182a7.928 7.928 0 01-.084.183c-.024.054-.051.108-.077.162-2.6 5.329-8.064 9-14.384 9-6.328 0-11.797-3.679-14.393-9.018l-.057-.12c-.036-.078-.074-.155-.109-.235l-.056-.122-.104-.24-.047-.11c-.036-.085-.07-.17-.105-.256l-.038-.1a20.561 20.561 0 01-.106-.275l-.03-.082c-.036-.098-.07-.197-.104-.295l-.023-.067c-.034-.103-.069-.209-.1-.313l-.019-.057c-.034-.11-.066-.22-.097-.329l-.012-.044a31.106 31.106 0 01-.093-.34l-.01-.04a16.62 16.62 0 01-.084-.346l-.009-.038v-.003a574.915 574.915 0 018.367-5.548c2.664-.639 5.073-.996 7.23-1.071 2.153.076 4.562.432 7.226 1.071 3.082 1.998 6.39 4.165 8.383 5.476v.002l-.002.002-.016.07z", fill: "#1A1A1A" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.405 27.57a574.09 574.09 0 018.367-5.548c2.664-.64 5.073-.997 7.23-1.072 2.153.076 4.562.433 7.226 1.072 3.082 1.997 6.39 4.164 8.383 5.476-.022.101-.047.201-.071.302l-.011.049-.075.285-.016.059a6.41 6.41 0 01-.08.284l-.012.043a16.27 16.27 0 01-.541 1.542l-.019.04c-.035.089-.074.177-.111.266l-.026.059-.117.26-.024.053c-.043.088-.082.177-.125.265l-.011.02c-.19.384-.39.76-.61 1.126l-.026.047-.143.232-.043.07c-.047.074-.094.148-.143.222l-.046.07a6.379 6.379 0 01-.148.221l-.037.056c-.232.333-.474.659-.73.975l-.05.062c-.051.064-.105.127-.157.189a2.327 2.327 0 01-.071.084l-.154.179-.078.086-.157.175c-.025.028-.05.055-.078.082-.054.059-.11.118-.166.176l-.06.062a14.327 14.327 0 01-.674.657l-.156.141-.111.099-.153.132c-.041.033-.08.068-.12.102l-.154.127-.12.098c-.054.042-.104.083-.158.124-.041.033-.083.066-.127.099l-.156.118-.131.096a20.915 20.915 0 01-.435.309c-.05.032-.096.064-.143.096-.053.034-.104.07-.158.103l-.147.095-.158.098-.148.091-.169.1-.143.083-.18.1a10.263 10.263 0 01-.376.203l-.105.054c-.098.05-.195.098-.293.145-.039.02-.078.038-.118.057-.07.034-.141.066-.211.098l-.136.062a17.247 17.247 0 01-.343.147l-.198.082-.142.056-.211.08-.133.05-.269.095-.076.026c-.115.038-.232.078-.35.114-.03.01-.062.018-.094.028a10.85 10.85 0 01-.387.112l-.235.064c-.045.01-.092.023-.138.034-.075.02-.152.038-.228.056l-.139.032a15.16 15.16 0 01-1.485.266l-.112.013-.266.031-.131.013a14.65 14.65 0 01-.646.049l-.134.008-.283.01a16.501 16.501 0 01-.986 0l-.285-.01-.13-.008a7.17 7.17 0 01-.392-.027c-.086-.006-.169-.014-.253-.022-.044-.004-.088-.007-.13-.012-.092-.01-.185-.02-.275-.032a14.408 14.408 0 01-.47-.064l-.01-.001a12.628 12.628 0 01-.46-.079c-.096-.017-.192-.034-.288-.054l-.12-.025a14.472 14.472 0 01-.615-.143l-.127-.032a11.183 11.183 0 01-.36-.1c-.105-.03-.208-.06-.313-.092l-.042-.013c-.12-.037-.238-.077-.357-.116l-.076-.026-.27-.095c-.04-.014-.078-.03-.117-.043l-.229-.088a8.275 8.275 0 01-.126-.05l-.217-.089-.124-.052a27.618 27.618 0 01-.337-.148c-.09-.04-.18-.083-.27-.126-.019-.01-.039-.018-.06-.027a17.054 17.054 0 01-.401-.203l-.248-.13c-.038-.02-.074-.041-.111-.062l-.209-.116-.116-.068-.2-.118-.116-.07-.205-.128-.102-.066c-.078-.05-.155-.102-.233-.153l-.07-.047c-.1-.068-.2-.137-.299-.207l-.058-.042a16.923 16.923 0 01-.233-.171l-.1-.076c-.063-.048-.126-.095-.187-.143l-.109-.086a5.729 5.729 0 01-.178-.144l-.105-.087c-.059-.049-.118-.098-.177-.149l-.101-.088a9.854 9.854 0 01-.186-.164c-.028-.026-.057-.05-.084-.076a11.64 11.64 0 01-.31-.291c-.07-.066-.14-.135-.208-.203l-.093-.094a15.868 15.868 0 01-.506-.538l-.144-.163a14.074 14.074 0 01-.095-.11c-.052-.059-.101-.119-.152-.18a15.78 15.78 0 01-.304-.373l-.03-.04c-.063-.08-.125-.161-.187-.243-.028-.038-.054-.076-.083-.112a29.436 29.436 0 01-.218-.305 7.832 7.832 0 01-.118-.171c-.03-.043-.059-.085-.087-.13-.04-.058-.078-.119-.118-.178-.028-.041-.054-.083-.08-.125a27.448 27.448 0 01-.117-.188c-.025-.04-.052-.081-.076-.122l-.14-.237-.065-.113a9.379 9.379 0 01-.218-.396c-.034-.064-.068-.127-.101-.192l-.072-.141-.092-.187-.07-.145-.085-.184-.068-.151a4.855 4.855 0 01-.083-.191l-.062-.142-.095-.231-.044-.108c-.043-.11-.084-.22-.125-.33l-.051-.144a20.71 20.71 0 01-.072-.202l-.05-.156a8.513 8.513 0 01-.064-.195l-.05-.16-.058-.197-.046-.16c-.02-.067-.036-.134-.054-.201-.015-.053-.029-.105-.04-.157-.02-.076-.038-.15-.056-.225l-.033-.136v-.007H.405z", fill: "#333" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M.405 27.57c3.483 2.647 7.647 4.924 7.647 4.924-.819 1.151-1.484 2.52-2.005 4.026a16.037 16.037 0 01-5.642-8.95z", fill: "#333" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M31.61 27.497c-3.485 2.647-7.648 4.923-7.648 4.923.828 1.164 1.498 2.55 2.021 4.073a16.004 16.004 0 005.627-8.996zM1.234 30.151l-.83-2.581 8.485-5.548 7.118 15.095v2.882H16C9.35 40 3.649 35.935 1.234 30.151z", fill: "#4D4D4D" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.841 29.967l.705-2.198c.018-.07.036-.138.05-.21l-8.47-5.538-7.12 15.095v2.882c6.718-.002 12.466-4.151 14.835-10.03z", fill: "#333" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.772 22.021l7.229 15.54 7.227-15.54H8.772z", fill: "#CCC" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.11 33.5L16 37.561l1.89-4.063-1.368-2.574h-.03l1.037-.993.158-.135-.563-2.89c-.1-.1-.082-.113-.204-.113l-.92.19-.922-.19c-.122 0-.103.012-.203.113l-.563 2.89.157.135 1.037.994h-.03l-1.366 2.573z", fill: "#C30" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 37.562l1.89-4.063-1.368-2.574h-.03l1.036-.993.159-.135-.563-2.89c-.1-.1-.082-.113-.204-.113l-.92.19v10.578z", fill: "#A32900" }),
  /* @__PURE__ */ jsx39("path", { d: "M16.886 33.179h-3.47v.7h3.47v-.7z", fill: "#FC0" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.772 22.021l4.226 9.089H13l3.002-3 2.871-6.089h4.356l-4.226 9.089-3.001-3-2.875-6.089H8.772z", fill: "#fff" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.278 22.996l-.351 3.975 2.397 1.076-1.782 1.082 8.459 8.433-7.23-15.541-1.493.975zM24.72 22.996l.354 3.975-2.397 1.076 1.781 1.082-8.457 8.433 7.227-15.541 1.493.975z", fill: "#1A1A1A" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.008 38.259a.653.653 0 11-.002 1.306.653.653 0 01.002-1.306z", fill: "#B3B3B3" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.007 38.259a.653.653 0 010 1.308v-1.308z", fill: "gray" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.008 38.259a.653.653 0 11-.002 1.306.653.653 0 01.002-1.306z", fill: "#B3B3B3" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.007 38.259a.653.653 0 010 1.308v-1.308z", fill: "gray" }),
  /* @__PURE__ */ jsx39("path", { d: "M26.517 34.194H21.02v.768h5.497v-.768z", fill: "#4D4D4D" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.02 34.194l2.243-2.247 1.272 1.273.506-.505 1.476 1.479H21.02z", fill: "#fff" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.864 12.96c-.792-1.029-.765-1.914.082-2.66 3.394.937 5.136 1.371 5.222 1.305-1.34 2.07-3.11 2.522-5.304 1.355zm-15.729 0c.792-1.029.765-1.914-.082-2.66-3.394.937-5.134 1.371-5.221 1.305 1.339 2.07 3.108 2.522 5.303 1.355z", fill: "#963" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.986 11.558c-1.664-1.962-1.905-3.076-.725-3.345 4.69.247 6.478-1.808 5.37-6.164L24.782 0c2.894 1.903 4.188 4.512 3.794 7.818-.224 1.872-2.781 3.117-7.59 3.74zm-9.972 0c1.664-1.962 1.905-3.076.725-3.345C7.05 8.46 5.26 6.405 6.367 2.05L7.22 0C4.323 1.903 3.03 4.512 3.424 7.818c.223 1.872 2.78 3.117 7.59 3.74z", fill: "#4D4D4D" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 28.11L5.455 19.228c.182-4.706 1.082-8.618 2.701-11.738 1.573-1.842 4.178-2.367 7.846-2.367 3.665 0 6.27.525 7.842 2.367 1.619 3.12 2.52 7.033 2.703 11.738L16 28.11z", fill: "#C93" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.001 5.122c3.665 0 6.27.525 7.842 2.367 1.619 3.12 2.52 7.033 2.703 11.738L16 28.11V5.12z", fill: "#A37A29" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.51 17.919c.288-4.128 1.164-7.604 2.63-10.43.063-.074.127-.146.193-.214 4.049-3.221 3.211 7.335 3.253 8.664.424 1.526-.568 2.46-2.977 2.8-1.25-.188-2.283-.462-3.1-.82zM26.49 17.919c-.288-4.128-1.165-7.604-2.63-10.43a5.27 5.27 0 00-.194-.214c-4.049-3.221-3.212 7.335-3.252 8.664-.425 1.526.568 2.46 2.978 2.8 1.249-.188 2.28-.462 3.099-.82z", fill: "#963" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 28.11L5.455 19.228c.044-1.143.131-2.24.26-3.289h20.57c.13 1.05.217 2.146.262 3.289L16 28.11z", fill: "#963" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.001 28.11l-6.927-5.832 2.727-4.136c-.105-.968-.116-1.702-.038-2.202h1.765c.649.69 1.472 1.824 2.472 3.405.998-1.581 1.82-2.715 2.47-3.405h1.766c.078.5.066 1.234-.038 2.202 1.817 2.757 2.727 4.135 2.727 4.135l-6.924 5.834z", fill: "#85592B" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.802 18.14c.055-1.41 2.25-.08 3.262.609a7.513 7.513 0 00.962.635c.356-.198.703-.431 1.042-.698 1.048-.703 3.116-1.913 3.17-.545 2.989-5.338-11.574-5.326-8.436 0z", fill: "#1A1A1A" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 14.423c1.344 0 2.434.535 2.434 1.193 0 .66-1.09 1.194-2.433 1.194-1.346 0-2.436-.535-2.436-1.194.001-.658 1.09-1.193 2.436-1.193z", fill: "#666" }),
  /* @__PURE__ */ jsx39("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 21.981c-3.415 0-4.031-.613-3.86-1.95.045 1.119 1.33 1.379 3.86 1.379s3.815-.26 3.86-1.379c.17 1.337-.445 1.95-3.86 1.95zM21.8 11.816c-.632-.027-1.186.487-1.391 1.145-.508-4.27 3.44-4.447 4.324-1.645-.744.455-1.545.561-2.933.5zm-11.6 0c.632-.027 1.187.487 1.391 1.145.508-4.27-3.442-4.447-4.324-1.645.744.455 1.545.561 2.933.5z", fill: "#1A1A1A" })
] });
var sws_logo_sm_default = SvgSwsLogoSm;

// src/logos/SWSLogoIconSimple.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var SWSLogoIconSimple_default = forwardRef13(
  (props, ref) => /* @__PURE__ */ jsx40(sws_logo_sm_default, { ref, ...props })
);
export {
  Alert_default as Alert,
  AlertAction,
  Badge,
  BlurFilter,
  Bones,
  Box,
  Button_default as Button,
  ButtonWithDropdown,
  Column_default as Column,
  DeprecatedGrid,
  Ellipsis,
  EllipsisWithLineClamp,
  Grid,
  Heading_default as Heading,
  LoadingSpinner,
  LoadingWarren_default as LoadingWarren,
  Modal_default as Modal,
  Portal2 as Portal,
  Row_default as Row,
  SWSLogoIcon_default as SWSLogoIcon,
  SWSLogoIconSimple_default as SWSLogoIconSimple,
  ScreenSize,
  ScrollPanel,
  ScrollPanelWithoutScrollbars,
  Tab_default as Tab,
  TabList,
  TabPanel,
  Text_default as Text,
  Textfield_default as Textfield,
  ThemeProvider,
  Toggle_default as Toggle,
  ToggleButton_default as ToggleButton,
  ValidationMessage_default as ValidationMessage,
  buttonCSS,
  darken,
  focus_default as focus,
  font_exports as font,
  getBreakpoints,
  hexToRgb2 as hexToRgb,
  hideScrollbar,
  lighten,
  loadingAnimation,
  media_default as media,
  tabCSS,
  theme,
  typography_exports as typography,
  useIsMounted,
  useMount,
  usePreventWindowScroll,
  useTheme
};
